
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3geiu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "BoardsDirectory", () => $4ea34cf4fa920c71$export$84679aba0137274);
$parcel$export(module.exports, "default", () => $4ea34cf4fa920c71$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("2Geeh");

var $8mdxr = parcelRequire("8mdxr");

var $iFYlf = parcelRequire("iFYlf");

var $4041n = parcelRequire("4041n");

var $kUACW = parcelRequire("kUACW");

var $bPjHb = parcelRequire("bPjHb");

var $5qVrc = parcelRequire("5qVrc");

var $d31Su = parcelRequire("d31Su");

var $9NiTW = parcelRequire("9NiTW");

var $3RV1W = parcelRequire("3RV1W");

var $4dRjY = parcelRequire("4dRjY");

var $9OXo1 = parcelRequire("9OXo1");

var $l8ruj = parcelRequire("l8ruj");

var $2YP9W = parcelRequire("2YP9W");
var $1bQGJ = parcelRequire("1bQGJ");

var $bMGrS = parcelRequire("bMGrS");
const $4ea34cf4fa920c71$var$useBoardsDirectoryResource = (0, $kUACW.withSuspense)(()=>(0, $2YP9W.useResource)((0, $bPjHb.boardsDirectoryResource)));
const $4ea34cf4fa920c71$export$84679aba0137274 = ({ location: location })=>{
    const state = $4ea34cf4fa920c71$var$useBoardsDirectoryResource();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const renderContents = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8mdxr.default), {
            location: location
        }, ({ query: query, onQueryChanged: onQueryChanged })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4041n.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                    name: "boards-directory"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMGrS.default), {
                    tenantContext: tenantContext,
                    prefetchResult: {
                        ...state
                    },
                    favoriteChangeContext: favoriteChangeContext,
                    query: query,
                    onQueryChanged: onQueryChanged
                }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3RV1W.LicenseCheck), {
        type: "software"
    }, ({ result: result })=>result ? renderContents() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d31Su.AsyncNoSoftwareLicense), null)));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4ea34cf4fa920c71$var$RouterWrapper = (0, $1bQGJ.withRouter)($4ea34cf4fa920c71$export$84679aba0137274);
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$4ea34cf4fa920c71$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qVrc.default), {
        id: "spa-app-bootstrap.directories.boards"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iFYlf.default), {
        appNameSuffixForV2Event: "directory.boards",
        appNameForV3OperationalEvent: "boardsDirectory"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ea34cf4fa920c71$var$RouterWrapper, props)));

});
parcelRegister("8mdxr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6b0fdc6f482337d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8zupq = parcelRequire("8zupq");

var $iJPdQ = parcelRequire("iJPdQ");

var $buf2C = parcelRequire("buf2C");

var $himfI = parcelRequire("himfI");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c6b0fdc6f482337d$export$2e2bcd8739ae039 = ({ location: location, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iJPdQ.default), {
        location: location,
        sortFieldToParam: (0, $himfI.sortFieldToParam),
        sortFieldFromParam: (0, $himfI.sortFieldFromParam),
        filterFromParams: (0, $buf2C.filterFromParams),
        filterToParams: (0, $buf2C.filterToParams),
        defaultQuery: (0, $8zupq.initialQuery)
    }, children);

});
parcelRegister("8zupq", function(module, exports) {

$parcel$export(module.exports, "ITEMS_PER_PAGE", () => $6148799a6bfd3d0f$export$ec93a669a20aa982);
$parcel$export(module.exports, "EXPAND_PARAMETERS", () => $6148799a6bfd3d0f$export$ac5ed0fd17aacb1c);
$parcel$export(module.exports, "initialQuery", () => $6148799a6bfd3d0f$export$8af7177c92ae79e3);


var $fEtUJ = parcelRequire("fEtUJ");
const $6148799a6bfd3d0f$export$ec93a669a20aa982 = 25;
const $6148799a6bfd3d0f$export$ac5ed0fd17aacb1c = [
    'admins',
    'permissions',
    'favourite'
];
const $6148799a6bfd3d0f$export$8af7177c92ae79e3 = {
    sortField: (0, $fEtUJ.NAME),
    sortDirection: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
    page: 1,
    filter: {
        text: '',
        project: undefined
    }
};

});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';

parcelRegister("fEtUJ", function(module, exports) {

$parcel$export(module.exports, "NAME", () => $a59bc9a532566a54$export$3c5e605ca7ade9f2);
const $a59bc9a532566a54$export$3c5e605ca7ade9f2 = 'name';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a59bc9a532566a54$export$2e2bcd8739ae039 = [
    $a59bc9a532566a54$export$3c5e605ca7ade9f2
];

});


parcelRegister("iJPdQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $34933f66e78f501b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $67TwH = parcelRequire("67TwH");

var $4P5qU = parcelRequire("4P5qU");

var $cd2Ri = parcelRequire("cd2Ri");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$34933f66e78f501b$export$2e2bcd8739ae039 = ({ location: location, children: children, sortFieldFromParam: sortFieldFromParam, filterFromParams: filterFromParams, sortFieldToParam: sortFieldToParam, filterToParams: filterToParams, defaultQuery: defaultQuery })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67TwH.default), {
        location: location,
        queryFromUrl: (0, $cd2Ri.default)(sortFieldFromParam, filterFromParams),
        queryToUrl: (0, $4P5qU.default)(sortFieldToParam, filterToParams),
        defaultQuery: defaultQuery
    }, children);

});
parcelRegister("67TwH", function(module, exports) {

$parcel$export(module.exports, "default", () => $41e75e9a90d3818a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hJCUd = parcelRequire("hJCUd");

var $8Rkzz = parcelRequire("8Rkzz");

var $ebyGx = parcelRequire("ebyGx");

var $5y0F0 = parcelRequire("5y0F0");

var $6wlPy = parcelRequire("6wlPy");

var $aJXmP = parcelRequire("aJXmP");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$41e75e9a90d3818a$export$2e2bcd8739ae039 = ({ location: location, children: children, queryToUrl: queryToUrl, queryFromUrl: queryFromUrl, defaultQuery: defaultQuery })=>{
    const toQuery = (search)=>(0, (/*@__PURE__*/$parcel$interopDefault($hJCUd)))((0, $6wlPy.default)(queryFromUrl)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search)), defaultQuery);
    const replaceUrl = (// @ts-expect-error - TS2304 - Cannot find name 'Href'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    replace, query, prevParams)=>replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
            ...prevParams,
            ...queryToUrl(query)
        })}`, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJXmP.AdapterWithState), {
            search: location.search,
            toQuery: (search)=>toQuery(search),
            onChange: false ? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : (query, prevParams)=>replaceUrl(replace, query, prevParams)
        }, children));
};

});
parcelRegister("hJCUd", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $g7i7g = parcelRequire("g7i7g");

var $3KORh = parcelRequire("3KORh");

var $3dHKF = parcelRequire("3dHKF");
/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */ var $ce94d17a4ae582d5$var$defaultsDeep = $g7i7g(function(args) {
    args.push(undefined, $3KORh);
    return $hlchF($3dHKF, undefined, args);
});
module.exports = $ce94d17a4ae582d5$var$defaultsDeep;

});
parcelRegister("3KORh", function(module, exports) {

var $1m1GH = parcelRequire("1m1GH");

var $k0qYG = parcelRequire("k0qYG");
/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */ function $2bbd1e633373e9a1$var$customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if ($k0qYG(objValue) && $k0qYG(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        $1m1GH(objValue, srcValue, undefined, $2bbd1e633373e9a1$var$customDefaultsMerge, stack);
        stack['delete'](srcValue);
    }
    return objValue;
}
module.exports = $2bbd1e633373e9a1$var$customDefaultsMerge;

});


parcelRegister("6wlPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c011c7ab8644dae0$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $dPSWJ = parcelRequire("dPSWJ");
const $c011c7ab8644dae0$var$fromUrlTransformerFactory = (transformer)=>(0, (/*@__PURE__*/$parcel$interopDefault($basmW)))([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(params, (p)=>Array.isArray(p) ? p[0] : p),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>transformer(params)
    ]);
var $c011c7ab8644dae0$export$2e2bcd8739ae039 = $c011c7ab8644dae0$var$fromUrlTransformerFactory;

});

parcelRegister("aJXmP", function(module, exports) {

$parcel$export(module.exports, "AdapterWithState", () => $1acd1d8f1a4e9958$export$2fcc0cb3ae18b63e);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $ebyGx = parcelRequire("ebyGx");
class $1acd1d8f1a4e9958$export$2fcc0cb3ae18b63e extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props, state) {
        if (props.search !== state.prevSearch) return {
            query: props.toQuery(props.search),
            prevSearch: props.search
        };
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevState.query, this.state.query)) {
            const prevParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(prevState.prevSearch);
            this.props.onChange(this.state.query, prevParams);
        }
    }
    render() {
        return this.props.children({
            query: this.state.query,
            onQueryChanged: this.onQueryChanged
        });
    }
    constructor(...args){
        super(...args), this.state = {
            query: this.props.toQuery(this.props.search),
            prevSearch: this.props.search
        }, this.onQueryChanged = (query)=>{
            this.setState({
                query: query
            });
        };
    }
}

});


parcelRegister("4P5qU", function(module, exports) {

$parcel$export(module.exports, "default", () => $053ceb3ca02e043a$export$2e2bcd8739ae039);

var $27NS3 = parcelRequire("27NS3");

var $aud83 = parcelRequire("aud83");
const $053ceb3ca02e043a$var$toUrlTransformerFactory = (sortFieldTransformer, filterTransformer)=>{
    const valueTransformers = {
        // @ts-expect-error - TS7006 - Parameter 'page' implicitly has an 'any' type.
        page: (page)=>({
                page: (0, $aud83.number).stringify(page)
            }),
        // @ts-expect-error - TS7006 - Parameter 'dir' implicitly has an 'any' type.
        sortDirection: (dir)=>({
                sortOrder: (0, $aud83.string).stringify(dir)
            }),
        // @ts-expect-error - TS7006 - Parameter 'field' implicitly has an 'any' type.
        sortField: (field)=>({
                sortKey: sortFieldTransformer(field)
            }),
        filter: filterTransformer
    };
    return (query)=>(0, (/*@__PURE__*/$parcel$interopDefault($27NS3)))(query, (params, value, key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: string; }; sortDirection: (dir: any) => { sortOrder: any; }; sortField: (field: any) => { sortKey: string; }; filter: FilterToParamTransformer<TFilter>; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: string; }; sortDirection: (dir: any) => { sortOrder: any; }; sortField: (field: any) => { sortKey: string; }; filter: FilterToParamTransformer<TFilter>; }'.
            valueTransformers[key] ? {
                ...params,
                ...valueTransformers[key](value)
            } : params, {});
};
var $053ceb3ca02e043a$export$2e2bcd8739ae039 = $053ceb3ca02e043a$var$toUrlTransformerFactory;

});
parcelRegister("27NS3", function(module, exports) {

var $2YkAc = parcelRequire("2YkAc");

var $e7pfQ = parcelRequire("e7pfQ");

var $bxDef = parcelRequire("bxDef");

var $87mh8 = parcelRequire("87mh8");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $18c2eb891b6f17d9$var$reduce(collection, iteratee, accumulator) {
    var func = $8LQ84(collection) ? $2YkAc : $87mh8, initAccum = arguments.length < 3;
    return func(collection, $bxDef(iteratee, 4), accumulator, initAccum, $e7pfQ);
}
module.exports = $18c2eb891b6f17d9$var$reduce;

});
parcelRegister("87mh8", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $5e90419f1ca7764f$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $5e90419f1ca7764f$var$baseReduce;

});



parcelRegister("cd2Ri", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae9eca70c694773$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $dPSWJ = parcelRequire("dPSWJ");

var $27NS3 = parcelRequire("27NS3");

var $k15gu = parcelRequire("k15gu");

var $aud83 = parcelRequire("aud83");
const $5ae9eca70c694773$var$fromUrlTransformerFactory = (sortFieldTransformer, filterTransformer)=>{
    const transformers = {
        // @ts-expect-error - TS7006 - Parameter 'page' implicitly has an 'any' type.
        page: (page)=>(0, $k15gu.validatePageNumber)((0, $aud83.number).parse(page)) ? {
                page: (0, $aud83.number).parse(page)
            } : {},
        // @ts-expect-error - TS7006 - Parameter 'order' implicitly has an 'any' type.
        sortOrder: (order)=>(0, $k15gu.validateSortDirection)(order) ? {
                sortDirection: order
            } : {},
        // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type.
        sortKey: (key)=>sortFieldTransformer(key) ? {
                sortField: sortFieldTransformer(key)
            } : {}
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(params, (p)=>Array.isArray(p) ? p[0] : p),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($27NS3)))(params, (query, value, key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: number; } | { page?: undefined; }; sortOrder: (order: any) => { sortDirection: any; } | { sortDirection?: undefined; }; sortKey: (key: any) => { sortField: TSortField | null; } | { ...; }; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: number; } | { page?: undefined; }; sortOrder: (order: any) => { sortDirection: any; } | { sortDirection?: undefined; }; sortKey: (key: any) => { sortField: TSortField | null; } | { ...; }; }'.
                transformers[key] ? {
                    ...query,
                    ...transformers[key](value)
                } : query, {
                filter: filterTransformer(params)
            })
    ]);
};
var $5ae9eca70c694773$export$2e2bcd8739ae039 = $5ae9eca70c694773$var$fromUrlTransformerFactory;

});
parcelRegister("k15gu", function(module, exports) {

$parcel$export(module.exports, "calculateTotalPages", () => $871ef586a0cb0e22$export$fba88641b8ab6cd8);
$parcel$export(module.exports, "predictPageToRequestAfterItemDeletion", () => $871ef586a0cb0e22$export$3179e82a0f1565e1);
$parcel$export(module.exports, "validatePageNumber", () => $871ef586a0cb0e22$export$231cde03e0d8b537);
$parcel$export(module.exports, "validateSortDirection", () => $871ef586a0cb0e22$export$407c10b4791d7a16);

const $871ef586a0cb0e22$export$fba88641b8ab6cd8 = (totalItems, itemsPerPage)=>Math.max(Math.ceil(totalItems / itemsPerPage), 1);
const $871ef586a0cb0e22$export$3179e82a0f1565e1 = (itemsPerPage, totalItems, currentPage = 1, itemsRemoved = 1)=>{
    const maxPossiblePage = $871ef586a0cb0e22$export$fba88641b8ab6cd8(totalItems - itemsRemoved, itemsPerPage);
    return currentPage > maxPossiblePage ? maxPossiblePage : currentPage;
};
const $871ef586a0cb0e22$export$231cde03e0d8b537 = (input)=>typeof input === 'number' && Number.isInteger(input) && input >= 1;
const $871ef586a0cb0e22$export$407c10b4791d7a16 = (input)=>[
        (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
        (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
    ].includes(input);

});



parcelRegister("buf2C", function(module, exports) {

$parcel$export(module.exports, "filterToParams", () => $7013d72294cdffb0$export$cb128e46cc7ba0f1);
$parcel$export(module.exports, "filterFromParams", () => $7013d72294cdffb0$export$f6542f27c27241c6);
const $7013d72294cdffb0$export$66074cf594439162 = 'agility';
const $7013d72294cdffb0$var$transformSelectedProject = (input)=>input && input !== undefined ? {
        value: input
    } : undefined;
const $7013d72294cdffb0$export$cb128e46cc7ba0f1 = ({ project: project, text: text } = {})=>({
        contains: text || undefined,
        projectLocation: project?.value || undefined
    });
const $7013d72294cdffb0$export$f6542f27c27241c6 = (params)=>({
        text: params.contains || undefined,
        project: $7013d72294cdffb0$var$transformSelectedProject(params.projectLocation)
    });

});

parcelRegister("himfI", function(module, exports) {

$parcel$export(module.exports, "sortFieldToParam", () => $675929f179358b06$export$9a7ae3517c7d79c2);
$parcel$export(module.exports, "sortFieldFromParam", () => $675929f179358b06$export$307ee63ec20d9c92);

var $fEtUJ = parcelRequire("fEtUJ");
const $675929f179358b06$var$sortFieldMap = {
    [(0, $fEtUJ.NAME).toLowerCase()]: (0, $fEtUJ.NAME)
};
const $675929f179358b06$export$9a7ae3517c7d79c2 = (field)=>field.toLowerCase();
const $675929f179358b06$export$307ee63ec20d9c92 = (param)=>$675929f179358b06$var$sortFieldMap[param] ? $675929f179358b06$var$sortFieldMap[param] : null;

});


parcelRegister("iFYlf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d4f9fac2e290ba9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");
const $3d4f9fac2e290ba9$var$fireGasV2AndGasV3Analytics = (appNameSuffixForV2Event, appNameForV3OperationalEvent)=>(analyticsEvent)=>{
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${appNameForV3OperationalEvent} pageInitialised`);
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3d4f9fac2e290ba9$export$2e2bcd8739ae039 = ({ appNameSuffixForV2Event: appNameSuffixForV2Event, appNameForV3OperationalEvent: appNameForV3OperationalEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: $3d4f9fac2e290ba9$var$fireGasV2AndGasV3Analytics(appNameSuffixForV2Event, appNameForV3OperationalEvent)
    }));

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("kUACW", function(module, exports) {

$parcel$export(module.exports, "withSuspense", () => $4c5a941fc6e9229e$export$a3bce93d4fb4eda6);
const $4c5a941fc6e9229e$var$isDataEmpty = (data)=>data == null;
function $4c5a941fc6e9229e$export$a3bce93d4fb4eda6(theHook) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (...args)=>{
        const result = theHook(...args);
        if (!false && $4c5a941fc6e9229e$var$isDataEmpty(result.data) && result.loading) throw result.promise;
        return result;
    };
}

});

parcelRegister("5qVrc", function(module, exports) {

$parcel$export(module.exports, "default", () => $34104383eeaa69f9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i2Rm5 = parcelRequire("i2Rm5");

var $bVDE5 = parcelRequire("bVDE5");
const $34104383eeaa69f9$var$ErrorBoundaryWithExtraEventData = ({ children: children, id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), {
        id: "spa-apps.error-boundary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bVDE5.default), null, ({ transitionsCount: transitionsCount = 0, lastTransition: lastTransition = '', navigationStart: navigationStart = '' })=>{
        const extraEventData = {
            transitionsCount: transitionsCount,
            lastTransition: lastTransition,
            navigationStart: navigationStart
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), {
            id: id,
            extraEventData: extraEventData
        }, children);
    }));
const $34104383eeaa69f9$var$SpaErrorBoundary = $34104383eeaa69f9$var$ErrorBoundaryWithExtraEventData;
var $34104383eeaa69f9$export$2e2bcd8739ae039 = $34104383eeaa69f9$var$SpaErrorBoundary;

});

parcelRegister("d31Su", function(module, exports) {

$parcel$export(module.exports, "AsyncNoSoftwareLicense", () => $dcd2c1aef082694d$export$52d8964299339cae);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $dcd2c1aef082694d$var$LazyNoSoftwareLicense = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6VbwP")), {
    moduleId: "./src/packages/spa-apps/common/src/error-screens/no-software-license/index.tsx"
});
const $dcd2c1aef082694d$export$52d8964299339cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "no-software-license",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dcd2c1aef082694d$var$LazyNoSoftwareLicense, null));

});
parcelRegister("6VbwP", function(module, exports) {

let $50a10241a01cb576$var$load = (parcelRequire("28QjX"))(4);
module.exports = $50a10241a01cb576$var$load("lzKF1").then(()=>parcelRequire('eX102'));

});


parcelRegister("3RV1W", function(module, exports) {

$parcel$export(module.exports, "checkLicense", () => $6334356fa938c5d8$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $6334356fa938c5d8$export$944be0b3bf2a6feb);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");
const $6334356fa938c5d8$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess'
};
const $6334356fa938c5d8$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$6334356fa938c5d8$var$appPermissionMapper[type]]);
const $6334356fa938c5d8$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $6334356fa938c5d8$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});

parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("bMGrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6100b7493d51637f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9sGI6 = parcelRequire("9sGI6");

var $9dbF6 = parcelRequire("9dbF6");

var $ge478 = parcelRequire("ge478");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6100b7493d51637f$var$Updater = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "platform"
    });
var $6100b7493d51637f$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $ge478.default), {
    Updater: $6100b7493d51637f$var$Updater
});

});
parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $dJl1T = parcelRequire("dJl1T");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("ge478", function(module, exports) {

$parcel$export(module.exports, "default", () => $584d2e56579bafe1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jzjy1 = parcelRequire("jzjy1");

var $6Cydo = parcelRequire("6Cydo");

var $i2Rm5 = parcelRequire("i2Rm5");

var $7iJwP = parcelRequire("7iJwP");


var $8PRuf = parcelRequire("8PRuf");

var $5rqex = parcelRequire("5rqex");

var $cFtGt = parcelRequire("cFtGt");

var $fhVq7 = parcelRequire("fhVq7");

var $gcCnU = parcelRequire("gcCnU");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $584d2e56579bafe1$var$noop = ()=>{};
function $584d2e56579bafe1$var$BoardsDirectory(props) {
    const { Updater: Updater, tenantContext: tenantContext, prefetchResult: prefetchResult, favoriteChangeContext: favoriteChangeContext, query: query, onQueryChanged: onQueryChanged } = props;
    const { baseUrl: baseUrl, locale: locale, xsrfToken: xsrfToken, atlassianAccountId: atlassianAccountId } = tenantContext;
    const { error: prefetchError, loading: loading, data: data } = prefetchResult;
    if (prefetchError && !loading) // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)' is not assignable to type 'Error | null'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
        id: "directories-boards",
        error: prefetchError
    });
    if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cFtGt.BoardsDirectorySkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhVq7.PageLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "unhandled",
        packageName: "jiraSpaAppsDirectoriesBoards",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Updater, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Cydo.default), {
        isServer: false,
        baseUrl: baseUrl,
        accountId: atlassianAccountId || null,
        locale: locale,
        xsrfToken: xsrfToken,
        query: query,
        favoriteChangeContext: favoriteChangeContext,
        prefetchedData: data,
        onQueryChanged: onQueryChanged,
        onUnmount: $584d2e56579bafe1$var$noop,
        withPageReadyMetrics: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        metricKey: "jira.directories.boards",
        metric: (0, $gcCnU.boardsDirectoryPageLoad),
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $8PRuf.appBundleReadyMark),
            (0, $8PRuf.prefetchApiReadyMark)
        ]
    })));
}
var $584d2e56579bafe1$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('boards', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))($584d2e56579bafe1$var$BoardsDirectory);

});
parcelRegister("6Cydo", function(module, exports) {

$parcel$export(module.exports, "default", () => $15e623506c4811fd$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $2Lyby = parcelRequire("2Lyby");

var $7CwOv = parcelRequire("7CwOv");

var $i0p32 = parcelRequire("i0p32");

var $az4zD = parcelRequire("az4zD");

var $aJD80 = parcelRequire("aJD80");
var $15e623506c4811fd$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $az4zD.injectIntlV2), (0, $7CwOv.default)({
    CreateButton: $i0p32.default,
    BoardsDirectory: $2Lyby.default
}))((0, $aJD80.default));

});
parcelRegister("2Lyby", function(module, exports) {

$parcel$export(module.exports, "default", () => $c45d9ea8779b9c78$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8Rkzz = parcelRequire("8Rkzz");

var $hZHze = parcelRequire("hZHze");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $7iJwP = parcelRequire("7iJwP");

var $97Kan = parcelRequire("97Kan");

var $angbJ = parcelRequire("angbJ");

var $8zupq = parcelRequire("8zupq");

var $aVttx = parcelRequire("aVttx");

var $erhGT = parcelRequire("erhGT");

var $6czeS = parcelRequire("6czeS");

var $cZ9Ru = parcelRequire("cZ9Ru");

var $fjZQ1 = parcelRequire("fjZQ1");

var $c3ulr = parcelRequire("c3ulr");

var $h9Ceh = parcelRequire("h9Ceh");
class $c45d9ea8779b9c78$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            query: undefined,
            prefetchedData: {},
            withPageReadyMetrics: true,
            onQueryChanged: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $fjZQ1.default)((0, $aVttx.default));
        const { boards: boards } = props.prefetchedData;
        const { dispatch: dispatch } = this.store;
        dispatch((0, $erhGT.setAppProps)(props));
        dispatch((0, $cZ9Ru.setQuery)(props.query || (0, $8zupq.initialQuery)));
        dispatch(boards ? (0, $6czeS.retrieved)(boards) : (0, $6czeS.retrieve)());
    }
    componentDidUpdate(prevProps) {
        const { dispatch: dispatch } = this.store;
        const { query: query } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevProps, this.props)) dispatch((0, $erhGT.setAppProps)(this.props));
        if (query && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(query, (0, $c3ulr.getQuery)(this.store.getState()))) {
            dispatch((0, $cZ9Ru.setQuery)(query));
            dispatch((0, $6czeS.retrieve)());
        }
    }
    componentWillUnmount() {
        this.props.onUnmount();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store,
            hasErrorBoundary: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
            id: "unhandled",
            packageName: "jiraBoardsMain",
            teamName: "jira-cosmos"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $97Kan.FlagsDispatcher), {
            mapper: (0, $angbJ.default)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9Ceh.default), null))));
    }
}

});
parcelRegister("97Kan", function(module, exports) {

$parcel$export(module.exports, "FlagsDispatcher", () => $4ddeb9f500a62e17$export$9e60e3d40b6e758f);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $fpHHI = parcelRequire("fpHHI");
const $4ddeb9f500a62e17$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpHHI.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $pa9q9.showFlag),
        dismissFlag: (0, $pa9q9.dismissFlag)
    });

});
parcelRegister("fpHHI", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $eef6139685bfb64e$export$ab054a1ef92eeb01);

var $5uXOq = parcelRequire("5uXOq");

var $1kijq = parcelRequire("1kijq");
const $eef6139685bfb64e$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $5uXOq.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $5uXOq.useMemo)(()=>(0, $1kijq.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("1kijq", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $c324e875f8c6fe8f$export$7b259d28468da15b);

var $5uXOq = parcelRequire("5uXOq");

var $kVVL1 = parcelRequire("kVVL1");

var $pa9q9 = parcelRequire("pa9q9");
const $c324e875f8c6fe8f$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $c324e875f8c6fe8f$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $pa9q9.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $pa9q9.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVVL1.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $c324e875f8c6fe8f$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $pa9q9.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $c324e875f8c6fe8f$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $c324e875f8c6fe8f$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $c324e875f8c6fe8f$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $5uXOq.useMemo)(()=>$c324e875f8c6fe8f$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $c324e875f8c6fe8f$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $c324e875f8c6fe8f$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $kVVL1.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $c324e875f8c6fe8f$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $c324e875f8c6fe8f$var$Dispatcher8DefaultStore;
};

});



parcelRegister("angbJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $db416825a8c23b1a$export$2e2bcd8739ae039);

var $hSUp6 = parcelRequire("hSUp6");

var $3MMOA = parcelRequire("3MMOA");

var $3ZRYH = parcelRequire("3ZRYH");

var $folbR = parcelRequire("folbR");

var $2Hg6U = parcelRequire("2Hg6U");

var $3hBLs = parcelRequire("3hBLs");

var $eaOB8 = parcelRequire("eaOB8");

var $apSeM = parcelRequire("apSeM");

var $9bxha = parcelRequire("9bxha");
const $db416825a8c23b1a$var$BOARD_NOT_FOUND_REASON = 'board-not-found';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$db416825a8c23b1a$export$2e2bcd8739ae039 = (action, state)=>{
    switch(action.type){
        case 0, $3MMOA.DELETED:
            return (0, $eaOB8.default)(action.payload.board);
        case 0, $3MMOA.DELETE_FAILED:
            if (action.payload.reason === $db416825a8c23b1a$var$BOARD_NOT_FOUND_REASON) return (0, $hSUp6.default)(action.payload.board);
            return (0, $3hBLs.default)(action.payload.board);
        case 0, $3MMOA.COPIED:
            {
                const { board: board, copiedBoardSummary: copiedBoardSummary } = action.payload;
                return (0, $2Hg6U.default)(board, copiedBoardSummary, (0, $3ZRYH.getRapidBoardUrlForCopiedBoard)(state, copiedBoardSummary.id, copiedBoardSummary.location), (0, $3ZRYH.getRapidBoardEditUrlForCopiedBoard)(state, copiedBoardSummary.id, copiedBoardSummary.location));
            }
        case 0, $3MMOA.COPY_FAILED:
            if (action.payload.reason === $db416825a8c23b1a$var$BOARD_NOT_FOUND_REASON) return (0, $hSUp6.default)(action.payload.board);
            return (0, $folbR.default)(action.payload.board);
        case 0, $3MMOA.MOVED:
            return (0, $9bxha.default)(action.payload.board);
        case 0, $3MMOA.MOVE_FAILED:
            return (0, $apSeM.default)(action.payload.board);
        default:
            {
                const _exhaustiveCheck = action;
                return undefined;
            }
    }
};

});
parcelRegister("hSUp6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d5a39dce2fb1658$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $5d5a39dce2fb1658$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directories.boards-v2.common.flags.board-not-found.title",
        "defaultMessage": "We can't find {boardName}"
    },
    titlePrivateBoard: {
        "id": "directories.boards-v2.common.flags.board-not-found.title-private-board",
        "defaultMessage": "We can't find this board"
    },
    description: {
        "id": "directories.boards-v2.common.flags.board-not-found.description",
        "defaultMessage": "Someone might've deleted it. Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5d5a39dce2fb1658$export$2e2bcd8739ae039 = (board)=>{
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    if (board.isPrivate) return {
        type: 'error',
        title: $5d5a39dce2fb1658$var$messages.titlePrivateBoard,
        description: $5d5a39dce2fb1658$var$messages.description
    };
    return {
        type: 'error',
        // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
        title: [
            $5d5a39dce2fb1658$var$messages.title,
            {
                boardName: board.name
            }
        ],
        description: $5d5a39dce2fb1658$var$messages.description
    };
};

});

parcelRegister("3MMOA", function(module, exports) {

$parcel$export(module.exports, "DELETED", () => $2f423ff46d669efd$export$1cc76b53f23597de);
$parcel$export(module.exports, "deleted", () => $2f423ff46d669efd$export$bccbf0c716f226f4);
$parcel$export(module.exports, "DELETE_FAILED", () => $2f423ff46d669efd$export$ae082348f4557243);
$parcel$export(module.exports, "deleteFailed", () => $2f423ff46d669efd$export$8830effd508d9f31);
$parcel$export(module.exports, "COPIED", () => $2f423ff46d669efd$export$ab06cbdc503432af);
$parcel$export(module.exports, "copied", () => $2f423ff46d669efd$export$a92b46551664f4e);
$parcel$export(module.exports, "COPY_FAILED", () => $2f423ff46d669efd$export$9db31c0e010caedf);
$parcel$export(module.exports, "copyFailed", () => $2f423ff46d669efd$export$5d8d1af388d10413);
$parcel$export(module.exports, "MOVED", () => $2f423ff46d669efd$export$fdd9e4df1aa8958d);
$parcel$export(module.exports, "moved", () => $2f423ff46d669efd$export$7e507c9be5c491c1);
$parcel$export(module.exports, "MOVE_FAILED", () => $2f423ff46d669efd$export$a8fc6f431b735962);
$parcel$export(module.exports, "moveFailed", () => $2f423ff46d669efd$export$290884bafa3cdcc9);
const $2f423ff46d669efd$export$1cc76b53f23597de = 'state.actions.operations.DELETED';
const $2f423ff46d669efd$export$bccbf0c716f226f4 = (board)=>({
        type: $2f423ff46d669efd$export$1cc76b53f23597de,
        payload: {
            board: board
        }
    });
const $2f423ff46d669efd$export$ae082348f4557243 = 'state.actions.operations.DELETE_FAILED';
const $2f423ff46d669efd$export$8830effd508d9f31 = (board, reason)=>({
        type: $2f423ff46d669efd$export$ae082348f4557243,
        payload: {
            board: board,
            reason: reason
        }
    });
const $2f423ff46d669efd$export$ab06cbdc503432af = 'state.actions.operations.COPIED';
const $2f423ff46d669efd$export$a92b46551664f4e = (board, copiedBoardSummary)=>({
        type: $2f423ff46d669efd$export$ab06cbdc503432af,
        payload: {
            board: board,
            copiedBoardSummary: copiedBoardSummary
        }
    });
const $2f423ff46d669efd$export$9db31c0e010caedf = 'state.actions.operations.COPY_FAILED';
const $2f423ff46d669efd$export$5d8d1af388d10413 = (board, reason)=>({
        type: $2f423ff46d669efd$export$9db31c0e010caedf,
        payload: {
            board: board,
            reason: reason
        }
    });
const $2f423ff46d669efd$export$fdd9e4df1aa8958d = 'state.actions.operations.MOVED';
const $2f423ff46d669efd$export$7e507c9be5c491c1 = (board)=>({
        type: $2f423ff46d669efd$export$fdd9e4df1aa8958d,
        payload: {
            board: board
        }
    });
const $2f423ff46d669efd$export$a8fc6f431b735962 = 'state.actions.operations.MOVE_FAILED';
const $2f423ff46d669efd$export$290884bafa3cdcc9 = (board)=>({
        type: $2f423ff46d669efd$export$a8fc6f431b735962,
        payload: {
            board: board
        }
    });

});

parcelRegister("3ZRYH", function(module, exports) {

$parcel$export(module.exports, "getIds", () => $8cde7be4053a57ba$export$24b60fe7179439bc);
$parcel$export(module.exports, "getTotal", () => $8cde7be4053a57ba$export$94860ac4a286a8d9);
$parcel$export(module.exports, "isLoading", () => $8cde7be4053a57ba$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isError", () => $8cde7be4053a57ba$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "getBoard", () => $8cde7be4053a57ba$export$2223f2dfcfd77cef);
$parcel$export(module.exports, "isPrivate", () => $8cde7be4053a57ba$export$1d1349f4eb9a7003);
$parcel$export(module.exports, "getName", () => $8cde7be4053a57ba$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getType", () => $8cde7be4053a57ba$export$e2b5c5db9e2009fd);
$parcel$export(module.exports, "getLocation", () => $8cde7be4053a57ba$export$e7fd20fad3cf4b5f);
$parcel$export(module.exports, "getAdministrators", () => $8cde7be4053a57ba$export$cf06e17ab43f6f66);
$parcel$export(module.exports, "canEdit", () => $8cde7be4053a57ba$export$a261e9b0da701d0e);
$parcel$export(module.exports, "getRapidBoardUrlForCopiedBoard", () => $8cde7be4053a57ba$export$fa187c3e024a70f4);
$parcel$export(module.exports, "getRapidBoardEditUrlForCopiedBoard", () => $8cde7be4053a57ba$export$be2f5135768a781d);
$parcel$export(module.exports, "getRapidBoardUrlForSavedBoard", () => $8cde7be4053a57ba$export$5d7b71422cf0bc36);
$parcel$export(module.exports, "getEditBoardUrl", () => $8cde7be4053a57ba$export$1f52b9d4f45d4d7e);
$parcel$export(module.exports, "isFavorite", () => $8cde7be4053a57ba$export$70b3463aa7e3e514);
$parcel$export(module.exports, "isPending", () => $8cde7be4053a57ba$export$872dec21e9a69476);
$parcel$export(module.exports, "getChangeFavorite", () => $8cde7be4053a57ba$export$85b24bd43a2bd6cf);

var $aTxoZ = parcelRequire("aTxoZ");

var $jT5vh = parcelRequire("jT5vh");
const $8cde7be4053a57ba$export$dd1bc94b04021eeb = (state)=>state.boards.order.length === 0;
const $8cde7be4053a57ba$export$24b60fe7179439bc = (state)=>state.boards.order;
const $8cde7be4053a57ba$export$94860ac4a286a8d9 = (state)=>state.boards.total;
const $8cde7be4053a57ba$export$20bb0d907fbbe433 = (state)=>state.boards.isLoading;
const $8cde7be4053a57ba$export$e6127cc7fe7395c3 = (state)=>state.boards.isError;
const $8cde7be4053a57ba$export$2223f2dfcfd77cef = (state, id)=>state.boards.page[id];
const $8cde7be4053a57ba$export$1d1349f4eb9a7003 = (state, id)=>{
    const board = state.boards?.page[id];
    return board ? (0, $aTxoZ.isPrivateBoard)(board) : false;
};
const $8cde7be4053a57ba$export$7d9f7e9c1c02b41e = (state, id)=>{
    const board = $8cde7be4053a57ba$export$2223f2dfcfd77cef(state, id);
    if ((0, $aTxoZ.isPrivateBoard)(board)) throw new Error('Invalid access to name of private board.');
    return board?.name;
};
const $8cde7be4053a57ba$export$e2b5c5db9e2009fd = (state, id)=>{
    const board = $8cde7be4053a57ba$export$2223f2dfcfd77cef(state, id);
    if ((0, $aTxoZ.isPrivateBoard)(board)) throw new Error('Invalid access to type of private board.');
    return board?.type;
};
const $8cde7be4053a57ba$export$e7fd20fad3cf4b5f = (state, id)=>state.boards.page[id]?.location;
const $8cde7be4053a57ba$export$cf06e17ab43f6f66 = (state, id)=>state.boards.page[id]?.admins;
const $8cde7be4053a57ba$export$a261e9b0da701d0e = (state, id)=>state.boards.page[id]?.canEdit || false;
const $8cde7be4053a57ba$export$4777a065506d2787 = (state, id)=>`/secure/RapidBoard.jspa?rapidView=${id}&useStoredSettings=true`;
const $8cde7be4053a57ba$var$getRapidBoardUserBoardUrl = (baseUrl, userAccountId, boardId)=>`/jira/people/${userAccountId}/boards/${boardId}`;
const $8cde7be4053a57ba$var$getRapidBoardProjectBoardUrl = (baseUrl, projectKey, boardId)=>`/jira/software/c/projects/${projectKey}/boards/${boardId}`;
const $8cde7be4053a57ba$export$fa187c3e024a70f4 = (state, id, location)=>{
    const baseUrl = (0, $jT5vh.getBaseUrl)(state);
    if (!location.isValid) return `${$8cde7be4053a57ba$export$4777a065506d2787(state, id)}&locationless=true`;
    if (location.accountId != null) return $8cde7be4053a57ba$var$getRapidBoardUserBoardUrl(baseUrl, location.accountId, id);
    return $8cde7be4053a57ba$var$getRapidBoardProjectBoardUrl(baseUrl, location.locationKey, id);
};
const $8cde7be4053a57ba$export$be2f5135768a781d = (state, id, location)=>{
    const baseUrl = (0, $jT5vh.getBaseUrl)(state);
    const editQuery = 'config=default';
    if (!location.isValid) return `${$8cde7be4053a57ba$export$4777a065506d2787(state, id)}&locationless=true&${editQuery}`;
    if (location.accountId != null) return `${$8cde7be4053a57ba$var$getRapidBoardUserBoardUrl(baseUrl, location.accountId, id)}?${editQuery}`;
    return `${$8cde7be4053a57ba$var$getRapidBoardProjectBoardUrl(baseUrl, location.locationKey, id)}?${editQuery}`;
};
const $8cde7be4053a57ba$export$5d7b71422cf0bc36 = (state, id)=>{
    const location = $8cde7be4053a57ba$export$e7fd20fad3cf4b5f(state, id);
    const baseUrl = (0, $jT5vh.getBaseUrl)(state);
    // @ts-expect-error - TS2339 - Property 'projectKey' does not exist on type 'Location'.
    if (location?.projectKey != null) // @ts-expect-error - TS2339 - Property 'projectKey' does not exist on type 'Location'.
    return $8cde7be4053a57ba$var$getRapidBoardProjectBoardUrl(baseUrl, location.projectKey, id);
    // @ts-expect-error - TS2339 - Property 'userAccountId' does not exist on type 'Location'.
    if (location?.userAccountId != null) // @ts-expect-error - TS2339 - Property 'userAccountId' does not exist on type 'Location'.
    return $8cde7be4053a57ba$var$getRapidBoardUserBoardUrl(baseUrl, location.userAccountId, id);
    return `${$8cde7be4053a57ba$export$4777a065506d2787(state, id)}&locationless=true`;
};
const $8cde7be4053a57ba$export$1f52b9d4f45d4d7e = (state, id)=>{
    const baseUrl = (0, $jT5vh.getBaseUrl)(state);
    const location = $8cde7be4053a57ba$export$e7fd20fad3cf4b5f(state, id);
    if (location?.type === 'project') return `${$8cde7be4053a57ba$var$getRapidBoardProjectBoardUrl(baseUrl, location.projectKey, id)}?config=default`;
    if (location?.type === 'user') return `${$8cde7be4053a57ba$var$getRapidBoardUserBoardUrl(baseUrl, location.userAccountId, id)}?config=default`;
    return `${(0, $jT5vh.getBaseUrl)(state)}/secure/RapidBoard.jspa?rapidView=${id}&config=default&locationless=true`;
};
const $8cde7be4053a57ba$var$getFavoriteChangeContextItem = (state, id)=>// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    (0, $jT5vh.getFavoriteChangeContext)(state).items.boards[id];
const $8cde7be4053a57ba$export$70b3463aa7e3e514 = (state, id)=>{
    const board = $8cde7be4053a57ba$export$2223f2dfcfd77cef(state, id);
    if ((0, $aTxoZ.isPrivateBoard)(board)) throw new Error("Invalid access to 'favourite' state of private board.");
    const itemChanged = $8cde7be4053a57ba$var$getFavoriteChangeContextItem(state, id);
    return itemChanged?.value ?? board?.favourite;
};
const $8cde7be4053a57ba$export$872dec21e9a69476 = (state, id)=>{
    const item = $8cde7be4053a57ba$var$getFavoriteChangeContextItem(state, id);
    return !!(item && item.pending);
};
const $8cde7be4053a57ba$export$85b24bd43a2bd6cf = (state)=>(0, $jT5vh.getFavoriteChangeContext)(state).changeFavorite;

});
parcelRegister("aTxoZ", function(module, exports) {

$parcel$export(module.exports, "isPrivateBoard", () => $4a7341b8057520c0$export$24f9c7e9ded1e69b);
const $4a7341b8057520c0$export$51ab1b22799aafa = (board)=>board !== undefined && 'isPrivate' in board;
const $4a7341b8057520c0$export$24f9c7e9ded1e69b = (board)=>$4a7341b8057520c0$export$51ab1b22799aafa(board) && board.isPrivate;
const $4a7341b8057520c0$export$184eaec5cc535a29 = (location)=>location !== undefined && 'userAccountId' in location;
const $4a7341b8057520c0$export$511ce95363928ab7 = (location)=>location !== undefined && 'projectKey' in location;

});

parcelRegister("jT5vh", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $b17eb83be86fe39d$export$f654b28f82155665);
$parcel$export(module.exports, "getLoggedInUserAccountId", () => $b17eb83be86fe39d$export$a304ee7b66f5d1e);
$parcel$export(module.exports, "getOnQueryChanged", () => $b17eb83be86fe39d$export$59e4f8ebf6520bf7);
$parcel$export(module.exports, "getFavoriteChangeContext", () => $b17eb83be86fe39d$export$6fa121a48411f085);
$parcel$export(module.exports, "isWithPageReadyMetrics", () => $b17eb83be86fe39d$export$29e8a85166eb4498);
const $b17eb83be86fe39d$export$f654b28f82155665 = (state)=>state.app.props.baseUrl;
const $b17eb83be86fe39d$export$a304ee7b66f5d1e = (state)=>state.app.props.accountId;
const $b17eb83be86fe39d$export$59e4f8ebf6520bf7 = (state)=>state.app.props.onQueryChanged;
const $b17eb83be86fe39d$export$14407a25c57e1f92 = (state)=>state.app.props.xsrfToken;
const $b17eb83be86fe39d$export$6fa121a48411f085 = (state)=>state.app.props.favoriteChangeContext;
const $b17eb83be86fe39d$export$29e8a85166eb4498 = (state)=>state.app.props.withPageReadyMetrics;

});


parcelRegister("folbR", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d59534654cc3eec$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $9d59534654cc3eec$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directories.boards-v2.main.flags.copy.failed.title",
        "defaultMessage": "We couldn't copy {boardName}"
    },
    description: {
        "id": "directories.boards-v2.main.flags.copy.failed.description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9d59534654cc3eec$export$2e2bcd8739ae039 = (board)=>({
        type: 'error',
        title: [
            $9d59534654cc3eec$var$messages.title,
            {
                boardName: board.name
            }
        ],
        description: $9d59534654cc3eec$var$messages.description
    });

});

parcelRegister("2Hg6U", function(module, exports) {

$parcel$export(module.exports, "default", () => $2524e03016ac72d5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $2524e03016ac72d5$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directories.boards-v2.main.flags.copy.success.title",
        "defaultMessage": "{boardName} copied"
    },
    description: {
        "id": "directories.boards-v2.main.flags.copy.success.description",
        "defaultMessage": "{copiedBoardName} has been created with the same settings and filter as {boardName}"
    },
    viewBoard: {
        "id": "directories.boards-v2.main.flags.copy.success.view-board",
        "defaultMessage": "View board"
    },
    editBoard: {
        "id": "directories.boards-v2.main.flags.copy.success.edit-board",
        "defaultMessage": "Edit settings"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2524e03016ac72d5$export$2e2bcd8739ae039 = (board, copiedBoardSummary, copiedBoardUrl, copiedBoardSettingsUrl)=>({
        type: 'success',
        title: [
            $2524e03016ac72d5$var$messages.title,
            {
                boardName: board.name
            }
        ],
        description: [
            $2524e03016ac72d5$var$messages.description,
            {
                boardName: board.name,
                copiedBoardName: copiedBoardSummary.name
            }
        ],
        actions: [
            {
                content: $2524e03016ac72d5$var$messages.viewBoard,
                href: copiedBoardUrl
            },
            {
                content: $2524e03016ac72d5$var$messages.editBoard,
                href: copiedBoardSettingsUrl
            }
        ]
    });

});

parcelRegister("3hBLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $93d032f7da9907a0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $93d032f7da9907a0$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directories.boards-v2.main.flags.delete.failed.title",
        "defaultMessage": "We couldn't delete {boardName}"
    },
    titlePrivateBoard: {
        "id": "directories.boards-v2.main.flags.delete.failed.title-private-board",
        "defaultMessage": "We couldn't delete this board"
    },
    description: {
        "id": "directories.boards-v2.main.flags.delete.failed.description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$93d032f7da9907a0$export$2e2bcd8739ae039 = (board)=>{
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    if (board.isPrivate) return {
        type: 'error',
        title: $93d032f7da9907a0$var$messages.titlePrivateBoard,
        description: $93d032f7da9907a0$var$messages.description
    };
    return {
        type: 'error',
        // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
        title: [
            $93d032f7da9907a0$var$messages.title,
            {
                boardName: board.name
            }
        ],
        description: $93d032f7da9907a0$var$messages.description
    };
};

});

parcelRegister("eaOB8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ae13582000188d2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $2ae13582000188d2$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directories.boards-v2.main.flags.delete.success.title",
        "defaultMessage": "{boardName} deleted"
    },
    titlePrivateBoard: {
        "id": "directories.boards-v2.main.flags.delete.success.title-private-board",
        "defaultMessage": "Board deleted"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2ae13582000188d2$export$2e2bcd8739ae039 = (board)=>{
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    if (board.isPrivate) return {
        type: 'success',
        title: $2ae13582000188d2$var$messages.titlePrivateBoard
    };
    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
    return {
        type: 'success',
        title: [
            $2ae13582000188d2$var$messages.title,
            {
                boardName: board.name
            }
        ]
    };
};

});

parcelRegister("apSeM", function(module, exports) {

$parcel$export(module.exports, "default", () => $95faa4a87322d7ee$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $95faa4a87322d7ee$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directories.boards-v2.main.flags.move.failed.title",
        "defaultMessage": "We couldn't move {boardName}"
    },
    titlePrivateBoard: {
        "id": "directories.boards-v2.main.flags.move.failed.title-private-board",
        "defaultMessage": "We couldn't move this board"
    },
    description: {
        "id": "directories.boards-v2.main.flags.move.failed.description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95faa4a87322d7ee$export$2e2bcd8739ae039 = (board)=>{
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    if (board.isPrivate) return {
        type: 'error',
        title: $95faa4a87322d7ee$var$messages.titlePrivateBoard,
        description: $95faa4a87322d7ee$var$messages.description
    };
    return {
        type: 'error',
        // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
        title: [
            $95faa4a87322d7ee$var$messages.title,
            {
                boardName: board.name
            }
        ],
        description: $95faa4a87322d7ee$var$messages.description
    };
};

});

parcelRegister("9bxha", function(module, exports) {

$parcel$export(module.exports, "default", () => $556784b2da112bd1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $556784b2da112bd1$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directories.boards-v2.main.flags.move.success.title",
        "defaultMessage": "{boardName} moved"
    },
    titlePrivateBoard: {
        "id": "directories.boards-v2.main.flags.move.success.title-private-board",
        "defaultMessage": "Board moved"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$556784b2da112bd1$export$2e2bcd8739ae039 = (board)=>{
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    if (board.isPrivate) return {
        type: 'success',
        title: $556784b2da112bd1$var$messages.titlePrivateBoard
    };
    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
    return {
        type: 'success',
        title: [
            $556784b2da112bd1$var$messages.title,
            {
                boardName: board.name
            }
        ]
    };
};

});


parcelRegister("aVttx", function(module, exports) {

$parcel$export(module.exports, "default", () => $501e76cc61100cf8$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $cyyaa = parcelRequire("cyyaa");

var $apOc6 = parcelRequire("apOc6");

var $iYXki = parcelRequire("iYXki");
var $501e76cc61100cf8$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $apOc6.default), (0, $iYXki.default), (0, $cyyaa.default));

});
parcelRegister("cyyaa", function(module, exports) {

$parcel$export(module.exports, "default", () => $13518724613c6c9b$export$2e2bcd8739ae039);
parcelRequire("64ZAE");
parcelRequire("hZWgu");

var $jOEtE = parcelRequire("jOEtE");

var $erhGT = parcelRequire("erhGT");

var $jT5vh = parcelRequire("jT5vh");
const $13518724613c6c9b$var$pageReadyEpic = (action$, store)=>action$.ofType((0, $erhGT.READY)).do(()=>{
        (0, $jT5vh.isWithPageReadyMetrics)(store.getState()) && (0, $jOEtE.pageReady)();
    }).ignoreElements();
var $13518724613c6c9b$export$2e2bcd8739ae039 = $13518724613c6c9b$var$pageReadyEpic;

});
parcelRegister("jOEtE", function(module, exports) {

$parcel$export(module.exports, "pageReady", () => $2837fd6ce8da0df0$export$674e3a896edcf7c);
const $2837fd6ce8da0df0$export$674e3a896edcf7c = ()=>{
// no-op for now, to be properly cleaned up when FFs are removed - KITKAT-1419
};

});

parcelRegister("erhGT", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $d951fd36c6bfa57a$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $d951fd36c6bfa57a$export$cfda7627848a58cd);
$parcel$export(module.exports, "READY", () => $d951fd36c6bfa57a$export$4bf05b02be91f13a);
$parcel$export(module.exports, "ready", () => $d951fd36c6bfa57a$export$28ee1007e174a2a6);
const $d951fd36c6bfa57a$export$8aefe701a6f431e0 = 'state.actions.app.SET_APP_PROPS';
const $d951fd36c6bfa57a$export$cfda7627848a58cd = (payload)=>({
        type: $d951fd36c6bfa57a$export$8aefe701a6f431e0,
        payload: payload
    });
const $d951fd36c6bfa57a$export$4bf05b02be91f13a = 'state.actions.app.READY';
const $d951fd36c6bfa57a$export$28ee1007e174a2a6 = ()=>({
        type: $d951fd36c6bfa57a$export$4bf05b02be91f13a
    });

});


parcelRegister("apOc6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d05d88c339483b24$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $hJCUd = parcelRequire("hJCUd");

var $kVLXA = parcelRequire("kVLXA");

var $cZ9Ru = parcelRequire("cZ9Ru");

var $jT5vh = parcelRequire("jT5vh");

var $c3ulr = parcelRequire("c3ulr");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d05d88c339483b24$var$querySet = (action$, store)=>action$.ofType((0, $cZ9Ru.SET_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $jT5vh.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback(payload);
        return (0, $kVLXA.Observable).empty();
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d05d88c339483b24$var$queryPatched = (action$, store)=>action$.ofType((0, $cZ9Ru.PATCH_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $jT5vh.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback((0, (/*@__PURE__*/$parcel$interopDefault($hJCUd)))(payload, (0, $c3ulr.getQuery)(state)));
        return (0, $kVLXA.Observable).empty();
    });
var $d05d88c339483b24$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($d05d88c339483b24$var$querySet, $d05d88c339483b24$var$queryPatched);

});
parcelRegister("cZ9Ru", function(module, exports) {

$parcel$export(module.exports, "SET_QUERY", () => $3bf34153480cd933$export$11bcea24b35a126f);
$parcel$export(module.exports, "setQuery", () => $3bf34153480cd933$export$f3b215b0b382f63b);
$parcel$export(module.exports, "PATCH_QUERY", () => $3bf34153480cd933$export$403065a1ff0b1663);
$parcel$export(module.exports, "patchQuery", () => $3bf34153480cd933$export$8a4e224aafd3a2bf);
const $3bf34153480cd933$export$11bcea24b35a126f = 'state.actions.query.SET_QUERY';
const $3bf34153480cd933$export$f3b215b0b382f63b = (payload)=>({
        type: $3bf34153480cd933$export$11bcea24b35a126f,
        payload: payload
    });
const $3bf34153480cd933$export$403065a1ff0b1663 = 'state.actions.query.PATCH_QUERY';
const $3bf34153480cd933$export$8a4e224aafd3a2bf = (payload)=>({
        type: $3bf34153480cd933$export$403065a1ff0b1663,
        payload: payload
    });

});

parcelRegister("c3ulr", function(module, exports) {

$parcel$export(module.exports, "getQuery", () => $9448831944bd4476$export$71eec30d9db46a56);
$parcel$export(module.exports, "getSortField", () => $9448831944bd4476$export$9b753af5a9fb5911);
$parcel$export(module.exports, "getSortDirection", () => $9448831944bd4476$export$509e2b9937961873);
$parcel$export(module.exports, "getPage", () => $9448831944bd4476$export$c2a6433281518c91);
$parcel$export(module.exports, "getFilter", () => $9448831944bd4476$export$61ec8404f465cd36);
$parcel$export(module.exports, "getSearchText", () => $9448831944bd4476$export$f0fa84cdddf86109);
$parcel$export(module.exports, "getSelectedProject", () => $9448831944bd4476$export$1ebc7a42c839af66);
$parcel$export(module.exports, "isFilterApplied", () => $9448831944bd4476$export$980aed36f19060a5);

var $dGvGJ = parcelRequire("dGvGJ");
const $9448831944bd4476$export$71eec30d9db46a56 = (state)=>state.query;
const $9448831944bd4476$export$9b753af5a9fb5911 = (state)=>state.query.sortField;
const $9448831944bd4476$export$509e2b9937961873 = (state)=>state.query.sortDirection;
const $9448831944bd4476$export$c2a6433281518c91 = (state)=>state.query.page;
const $9448831944bd4476$export$61ec8404f465cd36 = (state)=>{
    // in our case, we **know** that there is always a filter
    if (!state.query.filter) throw new Error('Invalid state.');
    return state.query.filter;
};
const $9448831944bd4476$export$f0fa84cdddf86109 = (state)=>$9448831944bd4476$export$61ec8404f465cd36(state).text || '';
const $9448831944bd4476$export$1ebc7a42c839af66 = (state)=>$9448831944bd4476$export$61ec8404f465cd36(state).project;
const $9448831944bd4476$export$980aed36f19060a5 = (0, $dGvGJ.createSelector)($9448831944bd4476$export$f0fa84cdddf86109, $9448831944bd4476$export$1ebc7a42c839af66, (textValue, projectValue)=>!!textValue || !!projectValue);

});


parcelRegister("iYXki", function(module, exports) {

$parcel$export(module.exports, "default", () => $feb99dd4fc948eef$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("7qVV7");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $jcw0u = parcelRequire("jcw0u");

var $bBUzm = parcelRequire("bBUzm");

var $6czeS = parcelRequire("6czeS");

var $jT5vh = parcelRequire("jT5vh");

var $c3ulr = parcelRequire("c3ulr");

var $lMwsn = parcelRequire("lMwsn");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$feb99dd4fc948eef$export$2e2bcd8739ae039 = (action$, store)=>{
    const getDashboardsRequestAction$ = action$.ofType((0, $6czeS.RETRIEVE));
    return getDashboardsRequestAction$.mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $jT5vh.getBaseUrl)(state);
        const request = (0, $lMwsn.getServiceRequest)(state);
        const filter = (0, $c3ulr.getFilter)(state);
        return (0, $kVLXA.Observable).fromPromise((0, $bBUzm.default)(baseUrl, request, filter)).mergeMap((result)=>(0, $kVLXA.Observable).of((0, $6czeS.retrieved)(result))).takeUntil(getDashboardsRequestAction$).catch((error)=>{
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'retrieveBoards',
                    packageName: 'jiraBoardsMain',
                    teamName: 'jira-cosmos'
                }
            });
            return (0, $kVLXA.Observable).of((0, $6czeS.retrieveFailed)());
        });
    });
};

});
parcelRegister("bBUzm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe0d4b6d131c7e2c$export$2e2bcd8739ae039);

var $fqVDD = parcelRequire("fqVDD");

var $8o8q2 = parcelRequire("8o8q2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe0d4b6d131c7e2c$export$2e2bcd8739ae039 = async (baseUrl, request, filter)=>{
    const restResponse = await (0, $fqVDD.default)(baseUrl, request, filter, true);
    return (0, $8o8q2.transformBoards)(baseUrl, restResponse.values, restResponse.total);
};

});
parcelRegister("fqVDD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e88fcd9e8b136630$export$2e2bcd8739ae039);

var $3NMrl = parcelRequire("3NMrl");

var $ebyGx = parcelRequire("ebyGx");

var $8xvPa = parcelRequire("8xvPa");

var $5HnTq = parcelRequire("5HnTq");
const $e88fcd9e8b136630$export$20e00d0048bb5104 = ()=>'/rest/agile/1.0/board';
const $e88fcd9e8b136630$export$920c4ae61fe06896 = (filter)=>({
        name: filter.text || undefined
    });
const $e88fcd9e8b136630$var$createProjectFilter = (filter)=>({
        projectLocation: filter.project ? filter.project.value : undefined
    });
const $e88fcd9e8b136630$export$7138c24907de3954 = (baseUrl, request, filter, includePrivate)=>{
    const queryParams = {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(request, 'startAt', 'maxResults', 'orderBy', 'expand'),
        ...filter.text ? $e88fcd9e8b136630$export$920c4ae61fe06896(filter) : undefined,
        ...filter.project ? $e88fcd9e8b136630$var$createProjectFilter(filter) : undefined,
        includePrivate: includePrivate,
        overrideFilterPermissions: true
    };
    return `${$e88fcd9e8b136630$export$20e00d0048bb5104()}?${(0, $ebyGx.stringify)(queryParams)}`;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e88fcd9e8b136630$export$2e2bcd8739ae039 = async (baseUrl, request, filter, includePrivate)=>{
    const url = $e88fcd9e8b136630$export$7138c24907de3954(baseUrl, request, filter, includePrivate);
    const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
    if (response.ok) return response.json();
    throw await (0, $8xvPa.getErrorFromResponse)(response, 'Cannot fetch boards');
};

});
parcelRegister("8xvPa", function(module, exports) {

$parcel$export(module.exports, "getErrorFromResponse", () => $8065287d9cd7a779$export$7780d7826aafbede);

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $8065287d9cd7a779$export$7780d7826aafbede = async (response, defaultMessage)=>{
    let errorMessage = defaultMessage;
    try {
        const json = await response.json();
        const { errors: errors, errorMessages: errorMessages } = json;
        if (errors && Object.keys(errors).length) return (0, $eusud.transformValidationErrorFromServer)(json);
        errorMessage = errorMessages[0];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /**/ }
    return new (0, $jJZqs.default)(response.status, errorMessage);
};

});


parcelRegister("8o8q2", function(module, exports) {

$parcel$export(module.exports, "transformBoards", () => $900042bc1c8b30bf$export$ff748067a3618e48);

var $4Xk2W = parcelRequire("4Xk2W");

var $dPSWJ = parcelRequire("dPSWJ");

var $i7j5F = parcelRequire("i7j5F");
const $900042bc1c8b30bf$export$ff748067a3618e48 = (baseUrl, boards, total)=>{
    const order = boards.map((i)=>`${i.id}`);
    const responsesById = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(boards, (board)=>board.id);
    const page = (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(responsesById, (response)=>(0, $i7j5F.transformBoard)(baseUrl, response));
    return {
        page: page,
        order: order,
        total: total
    };
};

});
parcelRegister("i7j5F", function(module, exports) {

$parcel$export(module.exports, "transformBoard", () => $1a4d1796150aced9$export$1a6be520942a4bdd);

var $knvh6 = parcelRequire("knvh6");
const $1a4d1796150aced9$var$transformAdmins = (baseUrl, item)=>({
        users: item.users.map((user)=>(0, $knvh6.transformUser)(baseUrl, user)),
        groups: item.groups.map(({ name: name })=>({
                name: name
            }))
    });
const $1a4d1796150aced9$export$c8b75494f8074e15 = (item)=>// @ts-expect-error - TS2339 - Property 'projectKey' does not exist on type 'Location'.
    item.projectKey ? {
        displayName: item.displayName,
        avatarURI: item.avatarURI,
        // @ts-expect-error - TS2339 - Property 'projectKey' does not exist on type 'Location'.
        projectKey: item.projectKey,
        type: 'project'
    } : {
        displayName: item.displayName,
        avatarURI: item.avatarURI,
        // @ts-expect-error - TS2339 - Property 'userAccountId' does not exist on type 'Location'. | TS2339 - Property 'userAccountId' does not exist on type 'Location'.
        userAccountId: item.userAccountId != null ? item.userAccountId : '',
        type: 'user'
    };
const $1a4d1796150aced9$var$transformPrivateBoard = (baseUrl, item)=>({
        id: `${item.id}`,
        isPrivate: true,
        admins: $1a4d1796150aced9$var$transformAdmins(baseUrl, item.admins),
        canEdit: item.canEdit,
        location: item.location && $1a4d1796150aced9$export$c8b75494f8074e15(item.location)
    });
const $1a4d1796150aced9$var$transformPublicBoard = (baseUrl, item)=>({
        id: `${item.id}`,
        name: item.name,
        type: item.type,
        favourite: item.favourite,
        admins: $1a4d1796150aced9$var$transformAdmins(baseUrl, item.admins),
        canEdit: item.canEdit,
        location: item.location && $1a4d1796150aced9$export$c8b75494f8074e15(item.location)
    });
const $1a4d1796150aced9$export$1a6be520942a4bdd = (baseUrl, item)=>// @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'. | TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PrivateBoard'. | TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'.
    item.isPrivate ? $1a4d1796150aced9$var$transformPrivateBoard(baseUrl, item) : $1a4d1796150aced9$var$transformPublicBoard(baseUrl, item);

});
parcelRegister("knvh6", function(module, exports) {

$parcel$export(module.exports, "transformUser", () => $879c58d3b16279dc$export$88dcd5c1adae8021);
$parcel$export(module.exports, "transformSharePermission", () => $879c58d3b16279dc$export$443a799045209d52);
$parcel$export(module.exports, "transformSharePermissionsToServer", () => $879c58d3b16279dc$export$e05899da868da914);


const $879c58d3b16279dc$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
const $879c58d3b16279dc$export$88dcd5c1adae8021 = (baseUrl, user)=>({
        displayName: user.displayName,
        avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
        accountId: user.accountId,
        profileUrl: `/jira/people/${user.accountId}`
    });
const $879c58d3b16279dc$export$443a799045209d52 = (sharePermission)=>{
    switch(sharePermission.type){
        case 0, $a889b3091d5309c7$export$86517eb0163ef745:
            return {
                type: (0, $a889b3091d5309c7$export$86517eb0163ef745)
            };
        case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
            return {
                type: (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269)
            };
        case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
            return {
                type: (0, $a889b3091d5309c7$export$b02d7412182d1bce),
                group: {
                    ...sharePermission.group
                }
            };
        case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
            {
                const { project: project, role: role } = sharePermission;
                return {
                    type: (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6),
                    project: {
                        id: project.id,
                        name: project.name,
                        avatarUrl: project.avatarUrls['48x48']
                    },
                    role: role && {
                        id: role.id,
                        name: role.name
                    }
                };
            }
        case 0, $a889b3091d5309c7$export$487da0972e3459fe:
            return sharePermission;
        case 0, $a889b3091d5309c7$export$aea0835048e1c730:
            {
                const { user: user } = sharePermission;
                return {
                    type: (0, $a889b3091d5309c7$export$aea0835048e1c730),
                    user: {
                        accountId: user.accountId,
                        displayName: user.displayName,
                        avatarUrl: user.avatarUrls['48x48']
                    }
                };
            }
        default:
            $879c58d3b16279dc$var$assertUnreachable(sharePermission);
            return null;
    }
};
const $879c58d3b16279dc$export$e05899da868da914 = (sharePermissions, shouldReturnGroupIdForGroupIfAvailable = false)=>sharePermissions.map((sharePermission)=>{
        switch(sharePermission.type){
            case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                {
                    let group = {
                        name: sharePermission.group.name
                    };
                    if (shouldReturnGroupIdForGroupIfAvailable && sharePermission.group.groupId) group = {
                        groupId: sharePermission.group.groupId
                    };
                    return {
                        type: sharePermission.type,
                        group: group
                    };
                }
            case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                return {
                    type: sharePermission.type,
                    user: {
                        accountId: sharePermission.user.accountId
                    }
                };
            case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                {
                    const permission = {
                        type: sharePermission.role ? (0, $3f2163233a19a685$export$4d955b5fb0c1d4d7) : (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6),
                        project: {
                            id: sharePermission.project.id
                        }
                    };
                    if (sharePermission.role) permission.role = {
                        id: sharePermission.role.id
                    };
                    return permission;
                }
            case 0, $a889b3091d5309c7$export$487da0972e3459fe:
                return sharePermission;
            case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                return {
                    type: (0, $3f2163233a19a685$export$e2fe9963c33d5918)
                };
            case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                return sharePermission;
            default:
                $879c58d3b16279dc$var$assertUnreachable(sharePermission);
                return sharePermission;
        }
    });

});
const $a889b3091d5309c7$export$b02d7412182d1bce = 'group';
const $a889b3091d5309c7$export$5ef95a67b8fd1ff6 = 'project';
const $a889b3091d5309c7$export$487da0972e3459fe = 'project-unknown';
const $a889b3091d5309c7$export$b0a0e62d9b1a8269 = 'loggedin';
const $a889b3091d5309c7$export$86517eb0163ef745 = 'global';
const $a889b3091d5309c7$export$aea0835048e1c730 = 'user';
 // this is what can come from backend

const $3f2163233a19a685$export$e2fe9963c33d5918 = 'authenticated';
const $3f2163233a19a685$export$4d955b5fb0c1d4d7 = 'projectRole';





parcelRegister("6czeS", function(module, exports) {

$parcel$export(module.exports, "RETRIEVE", () => $d335c8cbeb563f03$export$7bf2c28a4e08c796);
$parcel$export(module.exports, "retrieve", () => $d335c8cbeb563f03$export$8a4d17b6e8486e66);
$parcel$export(module.exports, "RETRIEVED", () => $d335c8cbeb563f03$export$1a07e8ff5bab976c);
$parcel$export(module.exports, "retrieved", () => $d335c8cbeb563f03$export$4058166ec369dd8);
$parcel$export(module.exports, "RETRIEVE_FAILED", () => $d335c8cbeb563f03$export$26e5d507c83e3d5a);
$parcel$export(module.exports, "retrieveFailed", () => $d335c8cbeb563f03$export$1c9b9c3d8868d26f);
$parcel$export(module.exports, "PATCH", () => $d335c8cbeb563f03$export$54950d96c4d7b0);
$parcel$export(module.exports, "patch", () => $d335c8cbeb563f03$export$b76953f99ab2be78);
const $d335c8cbeb563f03$export$7bf2c28a4e08c796 = 'state.actions.boards.RETRIEVE';
const $d335c8cbeb563f03$export$8a4d17b6e8486e66 = ()=>({
        type: $d335c8cbeb563f03$export$7bf2c28a4e08c796
    });
const $d335c8cbeb563f03$export$1a07e8ff5bab976c = 'state.actions.boards.RETRIEVED';
const $d335c8cbeb563f03$export$4058166ec369dd8 = (payload)=>({
        type: $d335c8cbeb563f03$export$1a07e8ff5bab976c,
        payload: payload
    });
const $d335c8cbeb563f03$export$26e5d507c83e3d5a = 'state.actions.boards.RETRIEVE_FAILED';
const $d335c8cbeb563f03$export$1c9b9c3d8868d26f = ()=>({
        type: $d335c8cbeb563f03$export$26e5d507c83e3d5a
    });
const $d335c8cbeb563f03$export$54950d96c4d7b0 = 'state.actions.boards.PATCH';
const $d335c8cbeb563f03$export$b76953f99ab2be78 = (payload)=>({
        type: $d335c8cbeb563f03$export$54950d96c4d7b0,
        payload: payload
    });

});

parcelRegister("lMwsn", function(module, exports) {

$parcel$export(module.exports, "getServiceRequest", () => $a85256f4abe0aa66$export$d7889f7cae5c51ff);

var $b3NWe = parcelRequire("b3NWe");

var $8zupq = parcelRequire("8zupq");

var $fEtUJ = parcelRequire("fEtUJ");

var $c3ulr = parcelRequire("c3ulr");
const $a85256f4abe0aa66$var$SORT_FIELDS = {
    [(0, $fEtUJ.NAME)]: 'NAME'
};
const $a85256f4abe0aa66$var$getSort = (state)=>({
        direction: (0, $c3ulr.getSortDirection)(state),
        field: $a85256f4abe0aa66$var$SORT_FIELDS[(0, $c3ulr.getSortField)(state)]
    });
const $a85256f4abe0aa66$export$d7889f7cae5c51ff = (state)=>(0, $b3NWe.createPageRequest)((0, $c3ulr.getPage)(state), (0, $8zupq.ITEMS_PER_PAGE), $a85256f4abe0aa66$var$getSort(state), (0, $8zupq.EXPAND_PARAMETERS));

});
parcelRegister("b3NWe", function(module, exports) {

$parcel$export(module.exports, "createPageRequest", () => $76f67021d51b1075$export$6c268d1798324d1);
const $76f67021d51b1075$export$a2b44ae778ac3391 = (startAt, maxResults, order, expand)=>{
    const pageRequest = {
        maxResults: maxResults,
        startAt: startAt
    };
    if (order) {
        const orderString = `${order.direction === 'ASC' ? '+' : '-'}${order.field}`;
        pageRequest.orderBy = orderString;
    }
    if (expand && expand.length) pageRequest.expand = expand.join(',');
    return pageRequest;
};
const $76f67021d51b1075$export$2db35c6ee4729a76 = (startAt, maxResults, order, expand, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
searchBy)=>{
    const pageRequest = {
        maxResults: maxResults,
        startAt: startAt
    };
    if (order) {
        const orderString = `${order.direction === 'ASC' ? '+' : '-'}${order.field}`;
        pageRequest.orderBy = orderString;
    }
    if (expand && expand.length) pageRequest.expand = expand.join(',');
    if (searchBy && searchBy.length) pageRequest.searchBy = searchBy.join(',');
    return pageRequest;
};
const $76f67021d51b1075$export$6c268d1798324d1 = (page, itemsPerPage, order, expand)=>$76f67021d51b1075$export$a2b44ae778ac3391(itemsPerPage * (page - 1), itemsPerPage, order, expand);
const $76f67021d51b1075$export$98ffd4f2a2fa32d7 = (page, itemsPerPage, order, expand, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
searchBy)=>$76f67021d51b1075$export$2db35c6ee4729a76(itemsPerPage * (page - 1), itemsPerPage, order, expand, searchBy);

});




parcelRegister("fjZQ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6a314d3790af513$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $cvZre = parcelRequire("cvZre");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b6a314d3790af513$export$2e2bcd8739ae039 = (rootEpic, initialState)=>(0, $F2Mxm.default)({
        initialState: initialState,
        appName: 'directories/boards-v2',
        rootReducer: $cvZre.default,
        rootEpic: rootEpic
    });

});
parcelRegister("cvZre", function(module, exports) {

$parcel$export(module.exports, "default", () => $685bb8b4671d99c0$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $0LVmv = parcelRequire("0LVmv");

var $9mmL7 = parcelRequire("9mmL7");

var $1twB7 = parcelRequire("1twB7");
var $685bb8b4671d99c0$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    app: $0LVmv.default,
    boards: $9mmL7.default,
    query: $1twB7.default
});

});
parcelRegister("0LVmv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5d5bf5532ceda86$export$2e2bcd8739ae039);

var $fr1K2 = parcelRequire("fr1K2");

var $erhGT = parcelRequire("erhGT");
const $c5d5bf5532ceda86$export$d4c72bab9d6cc13a = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    props: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c5d5bf5532ceda86$export$2e2bcd8739ae039 = (state = $c5d5bf5532ceda86$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $erhGT.SET_APP_PROPS:
            return {
                ...state,
                props: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(action.payload, 'query')
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("9mmL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $65e5f7eb854be32a$export$2e2bcd8739ae039);

var $6czeS = parcelRequire("6czeS");
const $65e5f7eb854be32a$export$d4c72bab9d6cc13a = {
    page: {},
    order: [],
    total: 0,
    isLoading: true,
    isError: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$65e5f7eb854be32a$export$2e2bcd8739ae039 = (state = $65e5f7eb854be32a$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $6czeS.RETRIEVE:
            return {
                ...state,
                isLoading: true
            };
        case 0, $6czeS.RETRIEVED:
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isError: false
            };
        case 0, $6czeS.RETRIEVE_FAILED:
            return {
                ...state,
                isLoading: false,
                isError: true
            };
        case 0, $6czeS.PATCH:
            return {
                ...state,
                // @ts-expect-error - 2345 - Type 'undefined' is not assignable to type 'string'
                page: {
                    ...state.page,
                    [action.payload.id]: {
                        ...state.page[action.payload.id],
                        ...action.payload.patch
                    }
                }
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("1twB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e005d5b7bcf122a8$export$2e2bcd8739ae039);

var $8zupq = parcelRequire("8zupq");

var $cZ9Ru = parcelRequire("cZ9Ru");
const $e005d5b7bcf122a8$export$d4c72bab9d6cc13a = (0, $8zupq.initialQuery);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e005d5b7bcf122a8$export$2e2bcd8739ae039 = (state = $e005d5b7bcf122a8$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $cZ9Ru.SET_QUERY:
            return action.payload;
        case 0, $cZ9Ru.PATCH_QUERY:
            return {
                ...state,
                ...action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});



parcelRegister("h9Ceh", function(module, exports) {

$parcel$export(module.exports, "default", () => $671629b3fd16906f$export$2e2bcd8739ae039);

var $eHTfV = parcelRequire("eHTfV");

var $bC2fB = parcelRequire("bC2fB");

var $8zupq = parcelRequire("8zupq");

var $erhGT = parcelRequire("erhGT");

var $6czeS = parcelRequire("6czeS");

var $cZ9Ru = parcelRequire("cZ9Ru");

var $3ZRYH = parcelRequire("3ZRYH");

var $c3ulr = parcelRequire("c3ulr");

var $3HKsZ = parcelRequire("3HKsZ");

var $lReEu = parcelRequire("lReEu");

var $lhBHc = parcelRequire("lhBHc");

var $lzmCo = parcelRequire("lzmCo");
const $671629b3fd16906f$var$mapStateToProps = (state)=>({
        // data
        entityIds: (0, $3ZRYH.getIds)(state),
        totalItems: (0, $3ZRYH.getTotal)(state),
        itemsPerPage: (0, $8zupq.ITEMS_PER_PAGE),
        isLoading: (0, $3ZRYH.isLoading)(state),
        isError: (0, $3ZRYH.isError)(state),
        page: (0, $c3ulr.getPage)(state),
        sortField: (0, $c3ulr.getSortField)(state),
        sortDirection: (0, $c3ulr.getSortDirection)(state),
        filter: (0, $c3ulr.isFilterApplied)(state) ? (0, $c3ulr.getFilter)(state) : undefined,
        // ui
        firstColumnHeadingAlignment: 'center',
        FilterView: // views
        $lhBHc.default,
        tableConfiguration: (0, $lzmCo.getTableConfiguration)(state),
        tableLabel: (0, $lzmCo.getTableLabel)(),
        resultsAnnouncerMessage: (0, $lzmCo.getResultsAnnouncerMessage)(),
        emptyFilterResultConfiguration: $lzmCo.emptyFilterResultConfiguration,
        operationModals: $lzmCo.operationModals,
        EmptyView: $3HKsZ.default,
        ErrorView: $lReEu.default
    });
const $671629b3fd16906f$var$mapDispatchToProps = (dispatch)=>({
        // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'patch' implicitly has an 'any' type.
        onPatch: ({ id: id, patch: patch })=>dispatch((0, $6czeS.patch)({
                id: id,
                patch: patch
            })),
        onReload: (query)=>{
            dispatch((0, $cZ9Ru.patchQuery)(query));
            dispatch((0, $6czeS.retrieve)());
        },
        onFirstRender: ()=>dispatch((0, $erhGT.ready)())
    });
var // @ts-expect-error - TS2345 - Argument of type 'typeof Directory' is not assignable to parameter of type 'Component<{ entityIds: string[]; totalItems: number; itemsPerPage: number; isLoading: boolean; isError: boolean; page: number; sortField: "name"; sortDirection: SortDirection; filter: Filter | undefined; ... 7 more ...; ErrorView: ComponentClass<...> & { ...; }; } & { ...; }>'.
$671629b3fd16906f$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($671629b3fd16906f$var$mapStateToProps, $671629b3fd16906f$var$mapDispatchToProps)((0, $eHTfV.default));

});
parcelRegister("eHTfV", function(module, exports) {

$parcel$export(module.exports, "default", () => $68b9ede2efb547aa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dJl1T = parcelRequire("dJl1T");

var $dZw8H = parcelRequire("dZw8H");

var $j1FRT = parcelRequire("j1FRT");

var $6E8KZ = parcelRequire("6E8KZ");

var $2g1f1 = parcelRequire("2g1f1");

var $5wSMM = parcelRequire("5wSMM");

var $iqNVX = parcelRequire("iqNVX");

var $iOBt9 = parcelRequire("iOBt9");

const $68b9ede2efb547aa$var$defaultEntityIds = [];
class $68b9ede2efb547aa$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isOnboardingEnabled: false,
            headerConfiguration: undefined,
            FilterView: undefined,
            TableMaskView: undefined,
            CreateModal: undefined,
            metrics: {
                tableMounted: undefined
            },
            entityIds: $68b9ede2efb547aa$var$defaultEntityIds,
            dataProvider: undefined,
            renderOnboardingSpotlight: ()=>null,
            tableLabel: undefined,
            onboardingSpotlightTargets: [],
            onFirstRender: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props);
        if (props.entityIds !== $68b9ede2efb547aa$var$defaultEntityIds && props.dataProvider) (0, $dJl1T.default).safeErrorWithoutCustomerData('directory.base', 'Please provide only one of props: [entityIds] or [dataProvider], dataProvider will be used');
        this.store = (0, $iqNVX.default)((0, $2g1f1.default));
        this.store.dispatch((0, $5wSMM.setAppProps)(props));
    }
    componentDidUpdate() {
        this.store.dispatch((0, $5wSMM.setAppProps)(this.props));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6E8KZ.Provider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j1FRT.default), {
            onFirstMount: this.props.onFirstRender
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iOBt9.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null)));
    }
}

});
parcelRegister("j1FRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1db2b6388142380$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bKLSv = parcelRequire("bKLSv");
class $b1db2b6388142380$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKLSv.default).Provider, {
            value: {
                reportMount: this.onSubtreeMount
            }
        }, children);
    }
    constructor(...args){
        super(...args), this.onSubtreeMount = ()=>{
            if (!this.hasAnyMounted) {
                this.hasAnyMounted = true;
                this.props.onFirstMount();
            }
        }, this.hasAnyMounted = false;
    }
}

});
parcelRegister("bKLSv", function(module, exports) {

$parcel$export(module.exports, "default", () => $78841c2f4061c1bf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
var $78841c2f4061c1bf$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    reportMount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});

});


parcelRegister("6E8KZ", function(module, exports) {

$parcel$export(module.exports, "storeOptions", () => $faa45d572897b119$export$12cf63d9f5bd0793);
$parcel$export(module.exports, "Provider", () => $faa45d572897b119$export$2881499e37b75b9a);
$parcel$export(module.exports, "connect", () => $faa45d572897b119$export$64605811ab45167f);

var $5uXOq = parcelRequire("5uXOq");

var $bC2fB = parcelRequire("bC2fB");
const $faa45d572897b119$var$STORE_KEY = 'project-directories.directory.story';
const $faa45d572897b119$export$d03cc44e35038f93 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $faa45d572897b119$export$12cf63d9f5bd0793 = {
    storeKey: $faa45d572897b119$var$STORE_KEY,
    context: $faa45d572897b119$export$d03cc44e35038f93
};
const $faa45d572897b119$export$2881499e37b75b9a = (0, $bC2fB.createProvider)($faa45d572897b119$export$d03cc44e35038f93);
const $faa45d572897b119$export$64605811ab45167f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = Object.freeze({}))=>(0, $bC2fB.connect)(mapStateToProps, mapDispatchToProps, mergeProps, {
        ...options,
        context: $faa45d572897b119$export$d03cc44e35038f93,
        storeKey: $faa45d572897b119$var$STORE_KEY
    });

});

parcelRegister("2g1f1", function(module, exports) {

$parcel$export(module.exports, "default", () => $98259b1e80972783$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $gcE5m = parcelRequire("gcE5m");

var $eh8lN = parcelRequire("eh8lN");
var $98259b1e80972783$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $gcE5m.default), (0, $eh8lN.default));

});
parcelRegister("gcE5m", function(module, exports) {

$parcel$export(module.exports, "default", () => $dab58ae642be3a4d$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $26mQL = parcelRequire("26mQL");

var $eVVoZ = parcelRequire("eVVoZ");
var // flow can't deal with the generics here
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$dab58ae642be3a4d$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $26mQL.ENTITY_CREATED)).mergeMap(()=>{
        const state = store.getState();
        const page = (0, $eVVoZ.getPage)(state);
        (0, $eVVoZ.getOnReload)(state)({
            page: page
        });
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("26mQL", function(module, exports) {

$parcel$export(module.exports, "INITIATE", () => $fd2eed6f29a3dd08$export$643daa42aa3148d5);
$parcel$export(module.exports, "initiate", () => $fd2eed6f29a3dd08$export$b14c4413e822aa8d);
$parcel$export(module.exports, "ENTITY_CREATED", () => $fd2eed6f29a3dd08$export$61bc72c2b62d14ed);
$parcel$export(module.exports, "entityCreated", () => $fd2eed6f29a3dd08$export$5e2c0a0dc191dd3e);
$parcel$export(module.exports, "ENTITY_CREATE_FAILED", () => $fd2eed6f29a3dd08$export$ac0dd97afb285388);
$parcel$export(module.exports, "entityCreateFailed", () => $fd2eed6f29a3dd08$export$b71626a5d7099742);
$parcel$export(module.exports, "CANCELLED", () => $fd2eed6f29a3dd08$export$6b4658081fcf1aed);
$parcel$export(module.exports, "cancelled", () => $fd2eed6f29a3dd08$export$b108ea1063c657e3);
const $fd2eed6f29a3dd08$export$643daa42aa3148d5 = 'state.actions.create.INITIATE';
const $fd2eed6f29a3dd08$export$b14c4413e822aa8d = ()=>({
        type: $fd2eed6f29a3dd08$export$643daa42aa3148d5
    });
const $fd2eed6f29a3dd08$export$61bc72c2b62d14ed = 'state.actions.create.ENTITY_CREATED';
const $fd2eed6f29a3dd08$export$5e2c0a0dc191dd3e = (payload)=>({
        type: $fd2eed6f29a3dd08$export$61bc72c2b62d14ed,
        payload: payload
    });
const $fd2eed6f29a3dd08$export$ac0dd97afb285388 = 'state.actions.create.ENTITY_CREATE_FAILED';
const $fd2eed6f29a3dd08$export$b71626a5d7099742 = (payload)=>({
        type: $fd2eed6f29a3dd08$export$ac0dd97afb285388,
        payload: payload
    });
const $fd2eed6f29a3dd08$export$6b4658081fcf1aed = 'state.actions.create.CANCELLED';
const $fd2eed6f29a3dd08$export$b108ea1063c657e3 = ()=>({
        type: $fd2eed6f29a3dd08$export$6b4658081fcf1aed
    });

});

parcelRegister("eVVoZ", function(module, exports) {

$parcel$export(module.exports, "getEntityIds", () => $6cea3ab9141d1142$export$1fe43832be7d1fcb);
$parcel$export(module.exports, "getDataProvider", () => $6cea3ab9141d1142$export$add6bf8e4261fead);
$parcel$export(module.exports, "getTotalItems", () => $6cea3ab9141d1142$export$cbc4bdd6c02fac4d);
$parcel$export(module.exports, "getPage", () => $6cea3ab9141d1142$export$c2a6433281518c91);
$parcel$export(module.exports, "getItemsPerPage", () => $6cea3ab9141d1142$export$347447940701b338);
$parcel$export(module.exports, "getSortField", () => $6cea3ab9141d1142$export$9b753af5a9fb5911);
$parcel$export(module.exports, "getSortDirection", () => $6cea3ab9141d1142$export$509e2b9937961873);
$parcel$export(module.exports, "getFilter", () => $6cea3ab9141d1142$export$61ec8404f465cd36);
$parcel$export(module.exports, "getHeaderConfiguration", () => $6cea3ab9141d1142$export$60b0ef02721854ed);
$parcel$export(module.exports, "getFilterView", () => $6cea3ab9141d1142$export$4a62b01f13af161e);
$parcel$export(module.exports, "getTableConfiguration", () => $6cea3ab9141d1142$export$6847365bea1c5392);
$parcel$export(module.exports, "getTableLabel", () => $6cea3ab9141d1142$export$b2d196af18e06ad6);
$parcel$export(module.exports, "getResultsAnnouncerMessage", () => $6cea3ab9141d1142$export$64df75861e57fb7f);
$parcel$export(module.exports, "getEmptyView", () => $6cea3ab9141d1142$export$6ad7beec028137c);
$parcel$export(module.exports, "getErrorView", () => $6cea3ab9141d1142$export$67942d5525c28c28);
$parcel$export(module.exports, "getEmptyFilterResultConfiguration", () => $6cea3ab9141d1142$export$dae3c68be4c9569d);
$parcel$export(module.exports, "getTableMaskView", () => $6cea3ab9141d1142$export$7a35128187f8245c);
$parcel$export(module.exports, "getCreateModal", () => $6cea3ab9141d1142$export$be5bc82ccf7ca5ca);
$parcel$export(module.exports, "getOperationModal", () => $6cea3ab9141d1142$export$3f5ae3b2bfec9457);
$parcel$export(module.exports, "getOnReload", () => $6cea3ab9141d1142$export$7158eb69f7a0b59);
$parcel$export(module.exports, "getOnPatch", () => $6cea3ab9141d1142$export$944f52419ab8e737);
$parcel$export(module.exports, "isLoading", () => $6cea3ab9141d1142$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isError", () => $6cea3ab9141d1142$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "getTotalPages", () => $6cea3ab9141d1142$export$652b307566494a6);
$parcel$export(module.exports, "getFirstColumnHeadingAlignment", () => $6cea3ab9141d1142$export$22b039be773dbf63);
$parcel$export(module.exports, "getLastColumnHeadingAlignment", () => $6cea3ab9141d1142$export$affaf5a34a669e16);
$parcel$export(module.exports, "isCreateOpen", () => $6cea3ab9141d1142$export$996a71275221ab9e);
$parcel$export(module.exports, "getOperations", () => $6cea3ab9141d1142$export$acc17f62bededcaf);
$parcel$export(module.exports, "getOperationInitializationStatusPerEntity", () => $6cea3ab9141d1142$export$69a0d9b5be75b55d);
$parcel$export(module.exports, "getIsOnboardingEnabled", () => $6cea3ab9141d1142$export$65890ce3309e3ccf);
$parcel$export(module.exports, "getRenderOnboardingSpotlight", () => $6cea3ab9141d1142$export$98db60f26810390);
$parcel$export(module.exports, "getSpotlightForCell", () => $6cea3ab9141d1142$export$1faee8e10b588885);
$parcel$export(module.exports, "getAvailableSpotlightTargets", () => $6cea3ab9141d1142$export$7eda79d5ce9a0b8b);

var $dGvGJ = parcelRequire("dGvGJ");

var $4Xk2W = parcelRequire("4Xk2W");

var $dPSWJ = parcelRequire("dPSWJ");

var $k15gu = parcelRequire("k15gu");
const $6cea3ab9141d1142$export$876089ea65adc54 = (state)=>state.app.props;
const $6cea3ab9141d1142$export$1fe43832be7d1fcb = (state)=>state.app.props.entityIds;
const $6cea3ab9141d1142$export$add6bf8e4261fead = (state)=>state.app.props.dataProvider || undefined;
const $6cea3ab9141d1142$export$cbc4bdd6c02fac4d = (state)=>state.app.props.totalItems;
const $6cea3ab9141d1142$export$c2a6433281518c91 = (state)=>state.app.props.page;
const $6cea3ab9141d1142$export$347447940701b338 = (state)=>state.app.props.itemsPerPage;
const $6cea3ab9141d1142$export$9b753af5a9fb5911 = (state)=>state.app.props.sortField;
const $6cea3ab9141d1142$export$509e2b9937961873 = (state)=>state.app.props.sortDirection;
const $6cea3ab9141d1142$export$61ec8404f465cd36 = (state)=>state.app.props.filter;
const $6cea3ab9141d1142$export$60b0ef02721854ed = (state)=>state.app.props.headerConfiguration;
const $6cea3ab9141d1142$export$4a62b01f13af161e = (state)=>state.app.props.FilterView;
const $6cea3ab9141d1142$export$6847365bea1c5392 = (state)=>state.app.props.tableConfiguration;
const $6cea3ab9141d1142$export$b2d196af18e06ad6 = (state)=>state.app.props.tableLabel;
const $6cea3ab9141d1142$export$64df75861e57fb7f = (state)=>state.app.props.resultsAnnouncerMessage;
const $6cea3ab9141d1142$export$6ad7beec028137c = (state)=>state.app.props.EmptyView;
const $6cea3ab9141d1142$export$67942d5525c28c28 = (state)=>state.app.props.ErrorView;
const $6cea3ab9141d1142$export$dae3c68be4c9569d = (state)=>state.app.props.emptyFilterResultConfiguration;
const $6cea3ab9141d1142$export$7a35128187f8245c = (state)=>state.app.props.TableMaskView;
const $6cea3ab9141d1142$export$be5bc82ccf7ca5ca = (state)=>state.app.props.CreateModal;
const $6cea3ab9141d1142$export$3f5ae3b2bfec9457 = (state, operation)=>state.app.props.operationModals[operation];
const $6cea3ab9141d1142$export$7158eb69f7a0b59 = (state)=>state.app.props.onReload;
const $6cea3ab9141d1142$export$944f52419ab8e737 = (state)=>state.app.props.onPatch;
const $6cea3ab9141d1142$export$20bb0d907fbbe433 = (state)=>state.app.props.isLoading;
const $6cea3ab9141d1142$export$e6127cc7fe7395c3 = (state)=>state.app.props.isError;
const $6cea3ab9141d1142$var$getTotalPagesInternal = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6cea3ab9141d1142$export$cbc4bdd6c02fac4d, $6cea3ab9141d1142$export$347447940701b338, (totalItems, itemsOnPage)=>(0, $k15gu.calculateTotalPages)(totalItems, itemsOnPage));
const $6cea3ab9141d1142$export$652b307566494a6 = (state)=>$6cea3ab9141d1142$var$getTotalPagesInternal(state);
const $6cea3ab9141d1142$export$22b039be773dbf63 = (state)=>state.app.props.firstColumnHeadingAlignment;
const $6cea3ab9141d1142$export$affaf5a34a669e16 = (state)=>state.app.props.lastColumnHeadingAlignment;
const $6cea3ab9141d1142$export$996a71275221ab9e = (state)=>state.create.isOpen;
const $6cea3ab9141d1142$export$acc17f62bededcaf = (state)=>state.operations;
const $6cea3ab9141d1142$var$getOperationInitializationStatusPerEntityInternal = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.operations, (operations)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))((0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(operations, ({ id: id })=>id), ({ isInitializing: isInitializing })=>isInitializing));
const $6cea3ab9141d1142$export$69a0d9b5be75b55d = (state)=>$6cea3ab9141d1142$var$getOperationInitializationStatusPerEntityInternal(state);
const $6cea3ab9141d1142$export$65890ce3309e3ccf = (state)=>state.app.props.isOnboardingEnabled;
const $6cea3ab9141d1142$export$ee9bc95b4b33fe7b = (state)=>state.app.props.onboardingSpotlightTargets;
const $6cea3ab9141d1142$export$98db60f26810390 = (state)=>state.app.props.renderOnboardingSpotlight;
const $6cea3ab9141d1142$export$1faee8e10b588885 = (state)=>(id, colIndex)=>$6cea3ab9141d1142$export$ee9bc95b4b33fe7b(state).find((c)=>c.entityId === id && c.colIndex === colIndex);
const $6cea3ab9141d1142$export$7eda79d5ce9a0b8b = (state)=>// @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'string[]'.
    (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
    $6cea3ab9141d1142$export$6847365bea1c5392, $6cea3ab9141d1142$export$add6bf8e4261fead, $6cea3ab9141d1142$export$1fe43832be7d1fcb, $6cea3ab9141d1142$export$1faee8e10b588885, (tableConfig, dataProvider, entitiesIds, getSpotlightCellTarget)=>{
        const availableSpotlightTargets = [];
        const ids = dataProvider ? dataProvider.getData().map((entity)=>dataProvider.idSelector(entity)) : entitiesIds;
        if (ids && tableConfig) ids.forEach((entityId)=>{
            for(let i = 0; i < tableConfig.length; i += 1){
                const cellMatch = getSpotlightCellTarget(entityId, i);
                if (cellMatch && cellMatch.spotlightId) availableSpotlightTargets.push(entityId);
            }
        });
        return availableSpotlightTargets;
    })(state);

});


parcelRegister("eh8lN", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ecadf93c93225f$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $k15gu = parcelRequire("k15gu");


var $lxmKy = parcelRequire("lxmKy");

var $eVVoZ = parcelRequire("eVVoZ");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$37ecadf93c93225f$export$2e2bcd8739ae039 = (action$, store)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    action$.ofType((0, $lxmKy.ENTITY_UPDATED)).mergeMap((action)=>{
        const { id: id, operation: operation, patch: patch } = action.payload;
        const state = store.getState();
        const currentPage = (0, $eVVoZ.getPage)(state);
        if (patch) {
            (0, $eVVoZ.getOnPatch)(state)({
                id: id,
                patch: patch
            }); // change page's state with a patch instead of reloading a table's page
            return (0, $kVLXA.Observable).empty();
        }
        if (operation === (0, $088bf273559ead46$export$4bd2facc4a3e6aa1)) {
            const itemsPerPage = (0, $eVVoZ.getItemsPerPage)(state);
            const totalItems = (0, $eVVoZ.getTotalItems)(state);
            const predictedPage = (0, $k15gu.predictPageToRequestAfterItemDeletion)(itemsPerPage, totalItems, currentPage);
            (0, $eVVoZ.getOnReload)(state)({
                page: predictedPage
            });
        } else (0, $eVVoZ.getOnReload)(state)({
            page: currentPage
        });
        return (0, $kVLXA.Observable).empty();
    });

});
const $088bf273559ead46$export$250171a898bf7ef = 'EDIT';
const $088bf273559ead46$export$4bd2facc4a3e6aa1 = 'DELETE';
const $088bf273559ead46$export$257be95a51c84145 = 'DUPLICATE';
const $088bf273559ead46$export$a7c1ec142e70d69d = 'ARCHIVE';
const $088bf273559ead46$export$92f9e1ed9114d3a6 = 'COPY';
const $088bf273559ead46$export$346f08c1f0d0fe41 = 'MOVE';
const $088bf273559ead46$export$bbf2495ca7d54c9f = 'SHOW_DETAILS';
const $088bf273559ead46$export$39d2a7fb21967424 = 'CHANGE_OWNER';
const $088bf273559ead46$export$2b848a0670941e75 = 'TRASH';
const $088bf273559ead46$export$aeed50488a8a79d7 = 'RESTORE';

parcelRegister("lxmKy", function(module, exports) {

$parcel$export(module.exports, "INITIATE", () => $7c27857a14ac40bb$export$643daa42aa3148d5);
$parcel$export(module.exports, "initiate", () => $7c27857a14ac40bb$export$b14c4413e822aa8d);
$parcel$export(module.exports, "ENTITY_DATA_RETRIEVE_FAILED", () => $7c27857a14ac40bb$export$d5657bfeb6a06769);
$parcel$export(module.exports, "entityDataRetrieveFailed", () => $7c27857a14ac40bb$export$7771a5f3a1cb2756);
$parcel$export(module.exports, "DIALOG_SHOWN", () => $7c27857a14ac40bb$export$54e32bf20c0b405b);
$parcel$export(module.exports, "dialogShown", () => $7c27857a14ac40bb$export$7aca9ee5930fa3ea);
$parcel$export(module.exports, "ENTITY_UPDATED", () => $7c27857a14ac40bb$export$93e8e914b5b8b20d);
$parcel$export(module.exports, "entityUpdated", () => $7c27857a14ac40bb$export$c0932263cb70e08f);
$parcel$export(module.exports, "ENTITY_UPDATE_FAILED", () => $7c27857a14ac40bb$export$d2d41c22dcb7b1db);
$parcel$export(module.exports, "entityUpdateFailed", () => $7c27857a14ac40bb$export$fbb84be2ae83b4ed);
$parcel$export(module.exports, "CANCELLED", () => $7c27857a14ac40bb$export$6b4658081fcf1aed);
$parcel$export(module.exports, "cancelled", () => $7c27857a14ac40bb$export$b108ea1063c657e3);
// initiate
const $7c27857a14ac40bb$export$643daa42aa3148d5 = 'state.actions.operation.INITIATE';
const $7c27857a14ac40bb$export$b14c4413e822aa8d = (payload)=>({
        type: $7c27857a14ac40bb$export$643daa42aa3148d5,
        payload: payload
    });
const $7c27857a14ac40bb$export$d5657bfeb6a06769 = 'state.actions.operation.ENTITY_DATA_RETRIEVE_FAILED';
const $7c27857a14ac40bb$export$7771a5f3a1cb2756 = (payload)=>({
        type: $7c27857a14ac40bb$export$d5657bfeb6a06769,
        payload: payload
    });
const $7c27857a14ac40bb$export$54e32bf20c0b405b = 'state.actions.operation.DIALOG_SHOWN';
const $7c27857a14ac40bb$export$7aca9ee5930fa3ea = (payload)=>({
        type: $7c27857a14ac40bb$export$54e32bf20c0b405b,
        payload: payload
    });
const $7c27857a14ac40bb$export$93e8e914b5b8b20d = 'state.actions.operation.ENTITY_UPDATED';
const $7c27857a14ac40bb$export$c0932263cb70e08f = (payload)=>({
        type: $7c27857a14ac40bb$export$93e8e914b5b8b20d,
        payload: payload
    });
const $7c27857a14ac40bb$export$d2d41c22dcb7b1db = 'state.actions.operation.ENTITY_UPDATE_FAILED';
const $7c27857a14ac40bb$export$fbb84be2ae83b4ed = (payload)=>({
        type: $7c27857a14ac40bb$export$d2d41c22dcb7b1db,
        payload: payload
    });
const $7c27857a14ac40bb$export$6b4658081fcf1aed = 'state.actions.operation.CANCELLED';
const $7c27857a14ac40bb$export$b108ea1063c657e3 = (payload)=>({
        type: $7c27857a14ac40bb$export$6b4658081fcf1aed,
        payload: payload
    });

});



parcelRegister("5wSMM", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $2b3ff44e59fa5c9c$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $2b3ff44e59fa5c9c$export$cfda7627848a58cd);
const $2b3ff44e59fa5c9c$export$8aefe701a6f431e0 = 'state.actions.app.SET_APP_PROPS';
const $2b3ff44e59fa5c9c$export$cfda7627848a58cd = (payload)=>({
        type: $2b3ff44e59fa5c9c$export$8aefe701a6f431e0,
        payload: payload
    });

});

parcelRegister("iqNVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $908bc238b7ffec6c$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $1EQqh = parcelRequire("1EQqh");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$908bc238b7ffec6c$export$2e2bcd8739ae039 = (rootEpic)=>{
    // @ts-expect-error - TS2322 - Type 'Reducer<unknown>' is not assignable to type 'Reducer<TState>'.
    const fixedTypeRootReducer = (0, $1EQqh.default);
    // @ts-expect-error - TS2344 - Type 'TAction' does not satisfy the constraint '{ type: any; }'.
    return (0, $F2Mxm.default)({
        appName: 'directory-base',
        rootReducer: fixedTypeRootReducer,
        rootEpic: rootEpic
    });
};

});
parcelRegister("1EQqh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7f8876305395d63$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $bDEL5 = parcelRequire("bDEL5");

var $grerf = parcelRequire("grerf");

var $9Oh3c = parcelRequire("9Oh3c");
var $b7f8876305395d63$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    app: $bDEL5.default,
    create: $grerf.default,
    operations: $9Oh3c.default
});

});
parcelRegister("bDEL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6089ea8d621e8008$export$2e2bcd8739ae039);

var $5wSMM = parcelRequire("5wSMM");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6089ea8d621e8008$export$2e2bcd8739ae039 = (state = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    props: undefined
}, action)=>{
    switch(action.type){
        case 0, $5wSMM.SET_APP_PROPS:
            return {
                ...state,
                props: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("grerf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e84fac704b397d4d$export$2e2bcd8739ae039);

var $26mQL = parcelRequire("26mQL");
const $e84fac704b397d4d$var$initialState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e84fac704b397d4d$export$2e2bcd8739ae039 = (state = $e84fac704b397d4d$var$initialState, action)=>{
    switch(action.type){
        case 0, $26mQL.INITIATE:
            return {
                isOpen: true
            };
        case 0, $26mQL.ENTITY_CREATED:
        case 0, $26mQL.ENTITY_CREATE_FAILED:
        case 0, $26mQL.CANCELLED:
            return {
                isOpen: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("9Oh3c", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f9982687de3ac1$export$2e2bcd8739ae039);

var $lxmKy = parcelRequire("lxmKy");
const $32f9982687de3ac1$var$reducer = (state = [], action)=>{
    switch(action.type){
        case 0, $lxmKy.INITIATE:
            // adding new operation to array will render new <OperationModal>, showing new dialog/modal in UI
            return [
                ...state,
                {
                    ...action.payload,
                    isInitializing: true
                }
            ];
        case 0, $lxmKy.DIALOG_SHOWN:
            // change isInitializing from true to false
            return [
                ...state.filter(({ id: id, operation: operation })=>id !== action.payload.id || operation !== action.payload.operation),
                {
                    ...action.payload,
                    isInitializing: false
                }
            ];
        case 0, $lxmKy.ENTITY_DATA_RETRIEVE_FAILED:
        case 0, $lxmKy.ENTITY_UPDATED:
        case 0, $lxmKy.ENTITY_UPDATE_FAILED:
        case 0, $lxmKy.CANCELLED:
            return state.filter(({ id: id, operation: operation })=>id !== action.payload.id || operation !== action.payload.operation);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $32f9982687de3ac1$export$2e2bcd8739ae039 = $32f9982687de3ac1$var$reducer;

});



parcelRegister("iOBt9", function(module, exports) {

$parcel$export(module.exports, "default", () => $63bf7e60b7f91719$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $lm3g2 = parcelRequire("lm3g2");

var $gZxo5 = parcelRequire("gZxo5");

var $1Evzn = parcelRequire("1Evzn");
var $63bf7e60b7f91719$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(()=>({
        Content: $lm3g2.default,
        Modals: $gZxo5.default
    }), null, null, (0, $6E8KZ.storeOptions))((0, $1Evzn.default));

});
parcelRegister("lm3g2", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdf0f9e385dafe4e$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");

var $6dDSs = parcelRequire("6dDSs");

var $l3DlM = parcelRequire("l3DlM");

var $6E8KZ = parcelRequire("6E8KZ");

var $26mQL = parcelRequire("26mQL");

var $eVVoZ = parcelRequire("eVVoZ");

var $hLegl = parcelRequire("hLegl");

var $gSSqP = parcelRequire("gSSqP");

var $geyiO = parcelRequire("geyiO");

var $fjCWQ = parcelRequire("fjCWQ");

var $1zjdB = parcelRequire("1zjdB");

var $do0bP = parcelRequire("do0bP");

var $gO9Up = parcelRequire("gO9Up");
const $cdf0f9e385dafe4e$var$getEmptyViewSelectorMemoized = ()=>(0, $6dDSs.createSelector)((state)=>(0, $l3DlM.withMountReporting)((0, $eVVoZ.getEmptyView)(state)), (res)=>res);
const $cdf0f9e385dafe4e$var$getErrorViewSelectorMemoized = ()=>(0, $6dDSs.createSelector)((state)=>(0, $l3DlM.withMountReporting)((0, $eVVoZ.getErrorView)(state)), (res)=>res);
const $cdf0f9e385dafe4e$var$getAvailableSpotlightTargetsSelectorMemoized = ()=>(0, $6dDSs.createSelector)((state)=>(0, $eVVoZ.getAvailableSpotlightTargets)(state), (res)=>res);
const $cdf0f9e385dafe4e$var$mapStateToPropsFactory = ()=>{
    const getEmptyViewSelectorInstance = $cdf0f9e385dafe4e$var$getEmptyViewSelectorMemoized();
    const getErrorViewSelectorInstance = $cdf0f9e385dafe4e$var$getErrorViewSelectorMemoized();
    const getAvailableSpotlightTargetsSelectorInstance = $cdf0f9e385dafe4e$var$getAvailableSpotlightTargetsSelectorMemoized();
    const onRetryFactory = (0, $8QpSo.default)((state)=>()=>(0, $eVVoZ.getOnReload)(state)({}));
    return (state)=>{
        let Header;
        const FilterView = (0, $eVVoZ.getFilterView)(state);
        if (FilterView) Header = (0, $gSSqP.default);
        else {
            const headerConfiguration = (0, $eVVoZ.getHeaderConfiguration)(state);
            if (headerConfiguration) {
                // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
                if (headerConfiguration.View) Header = (0, $fjCWQ.default);
                else Header = (0, $geyiO.default);
            }
        }
        return {
            Header: Header,
            Table: $do0bP.default,
            Paginator: $1zjdB.default,
            Empty: getEmptyViewSelectorInstance(state),
            Error: getErrorViewSelectorInstance(state),
            status: (0, $hLegl.getStatus)(state),
            onRetry: onRetryFactory(state),
            isOnboardingEnabled: (0, $eVVoZ.getIsOnboardingEnabled)(state),
            renderOnboardingSpotlight: (0, $eVVoZ.getRenderOnboardingSpotlight)(state),
            availableSpotlightTargets: getAvailableSpotlightTargetsSelectorInstance(state)
        };
    };
};
const $cdf0f9e385dafe4e$var$mapDispatchToProps = {
    onAdd: (0, $26mQL.initiate)
};
var $cdf0f9e385dafe4e$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($cdf0f9e385dafe4e$var$mapStateToPropsFactory, $cdf0f9e385dafe4e$var$mapDispatchToProps, null, (0, $6E8KZ.storeOptions))((0, $gO9Up.default));

});
parcelRegister("l3DlM", function(module, exports) {

$parcel$export(module.exports, "withMountReporting", () => $626145856bfd7724$export$95fa4b7a60ebef6);
$parcel$export(module.exports, "default", () => $626145856bfd7724$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $bKLSv = parcelRequire("bKLSv");
// eslint-disable-next-line jira/react/no-class-components
class $626145856bfd7724$var$Reporter extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            performanceMarkKey: undefined
        };
    }
    componentDidMount() {
        this.props.onMounted();
    }
    render() {
        const { performanceMarkKey: performanceMarkKey } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, performanceMarkKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
            metricKey: performanceMarkKey
        }), this.props.children);
    }
}
function $626145856bfd7724$export$95fa4b7a60ebef6(Wrapped) {
    return (props)=>{
        const { performanceMarkKey: performanceMarkKey, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKLSv.default).Consumer, null, ({ reportMount: reportMount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($626145856bfd7724$var$Reporter, {
                onMounted: reportMount,
                performanceMarkKey: performanceMarkKey
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapped, rest)));
    };
}
const $626145856bfd7724$var$MountReporter = $626145856bfd7724$export$95fa4b7a60ebef6(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null));
var $626145856bfd7724$export$2e2bcd8739ae039 = $626145856bfd7724$var$MountReporter;

});

parcelRegister("hLegl", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $2846182b2726a0e3$export$b70265791d2079d4);

var $eVVoZ = parcelRequire("eVVoZ");
const $2846182b2726a0e3$export$b70265791d2079d4 = (state)=>{
    if ((0, $eVVoZ.isError)(state)) return 'error';
    if ((0, $eVVoZ.isLoading)(state)) return 'has-entities';
    const dataProvider = (0, $eVVoZ.getDataProvider)(state);
    const elementsCount = dataProvider ? dataProvider.getData().length : (0, $eVVoZ.getEntityIds)(state).length;
    return elementsCount === 0 && (0, $eVVoZ.getFilter)(state) === undefined && (0, $eVVoZ.getPage)(state) === 1 ? 'empty' : 'has-entities';
};

});

parcelRegister("gSSqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebd0a798fbf431b0$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $hLegl = parcelRequire("hLegl");

var $6Wj1D = parcelRequire("6Wj1D");
const $ebd0a798fbf431b0$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $8QpSo.default)((state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter)=>(0, $eVVoZ.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>({
            FilterView: (0, $eVVoZ.getFilterView)(state),
            onFilter: onFilterFactory(state),
            hasEntities: (0, $hLegl.getStatus)(state) === 'has-entities'
        });
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type '<T>(props: Props<T>) => false | Element' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$ebd0a798fbf431b0$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($ebd0a798fbf431b0$var$mapStateToPropsFactory, {})((0, $6Wj1D.default));

});
parcelRegister("6Wj1D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb63d55477b9357$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
function $5eb63d55477b9357$export$2e2bcd8739ae039(props) {
    const { hasEntities: hasEntities, FilterView: FilterView, onFilter: onFilter } = props;
    return hasEntities ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5eb63d55477b9357$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FilterView, {
        onFilter: onFilter
    })) : null;
}
const $5eb63d55477b9357$var$wrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});

});


parcelRegister("geyiO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef20ad5474450900$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $hLegl = parcelRequire("hLegl");

var $kBSkq = parcelRequire("kBSkq");

var $9WoAf = parcelRequire("9WoAf");

var $gg466 = parcelRequire("gg466");
const $ef20ad5474450900$var$mapStateToProps = (state)=>{
    const headerConfiguration = (0, $eVVoZ.getHeaderConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
    if (!headerConfiguration || headerConfiguration.View) throw new Error('Invalid state - Default Header view must not be mounted');
    return {
        Filter: $9WoAf.default,
        // @ts-expect-error - TS2339 - Property 'ActionsView' does not exist on type 'HeaderConfiguration<TFilter>'.
        Actions: headerConfiguration.ActionsView || (0, $kBSkq.default),
        hasEntities: (0, $hLegl.getStatus)(state) === 'has-entities',
        // @ts-expect-error - TS2339 - Property 'caption' does not exist on type 'HeaderConfiguration<TFilter>'.
        caption: headerConfiguration.caption || null
    };
};
var // @ts-expect-error - TS2345 - Argument of type 'ComponentType<Diff<Record<any, any> | (Record<any, any> & { children?: ReactNode; }), InjectIntlVoidProps>>' is not assignable to parameter of type 'Component<DispatchProp<any> & { Filter: ComponentClass<Omit<DispatchProp<any>, "dispatch">> & { WrappedComponent: Component<DispatchProp<any>>; }; Actions: any; hasEntities: boolean; caption: any; }>'.
$ef20ad5474450900$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($ef20ad5474450900$var$mapStateToProps, null, null, (0, $6E8KZ.storeOptions))((0, $gg466.default));

});
parcelRegister("kBSkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $665d045383a33008$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $26mQL = parcelRequire("26mQL");

var $eVVoZ = parcelRequire("eVVoZ");

var $k0n1b = parcelRequire("k0n1b");
const $665d045383a33008$var$mapStateToProps = (state)=>{
    const headerConfiguration = (0, $eVVoZ.getHeaderConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'. | TS2339 - Property 'ActionsView' does not exist on type 'HeaderConfiguration<TFilter>'.
    if (headerConfiguration && !headerConfiguration.View && !headerConfiguration.ActionsView) {
        // @ts-expect-error - TS2339 - Property 'isAddAllowed' does not exist on type 'HeaderConfiguration<TFilter>'. | TS2339 - Property 'addButtonCaption' does not exist on type 'HeaderConfiguration<TFilter>'.
        const { isAddAllowed: isAddAllowed, addButtonCaption: addButtonCaption } = headerConfiguration;
        return {
            canAdd: isAddAllowed,
            caption: addButtonCaption
        };
    }
    return {};
};
const $665d045383a33008$var$mapDispatchToProps = {
    onAdd: (0, $26mQL.initiate)
};
var $665d045383a33008$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($665d045383a33008$var$mapStateToProps, $665d045383a33008$var$mapDispatchToProps, null, (0, $6E8KZ.storeOptions))((0, $k0n1b.default));

});
parcelRegister("k0n1b", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e2628b3f0abf572$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $koVbs = parcelRequire("koVbs");
function $5e2628b3f0abf572$var$Add(props) {
    const { canAdd: canAdd, caption: caption, onAdd: onAdd } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return canAdd ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        onClick: onAdd
    }, caption && formatMessage(caption)) : null;
}
$5e2628b3f0abf572$var$Add.defaultProps = {
    canAdd: false
};
var $5e2628b3f0abf572$export$2e2bcd8739ae039 = $5e2628b3f0abf572$var$Add;

});


parcelRegister("9WoAf", function(module, exports) {

$parcel$export(module.exports, "default", () => $900e6ddadbcb8d02$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $fwdEW = parcelRequire("fwdEW");
const $900e6ddadbcb8d02$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $8QpSo.default)((state)=>(filter)=>(0, $eVVoZ.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>{
        const headerConfiguration = (0, $eVVoZ.getHeaderConfiguration)(state);
        // @ts-expect-error - TS2339 - Property 'FilterView' does not exist on type 'HeaderConfiguration<TFilter>'.
        if (!headerConfiguration || !headerConfiguration.FilterView) throw new Error('Invalid state - Filter wrapper must not be mounted');
        return {
            // @ts-expect-error - TS2339 - Property 'FilterView' does not exist on type 'HeaderConfiguration<TFilter>'.
            FilterView: headerConfiguration.FilterView,
            onFilter: onFilterFactory(state)
        };
    };
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Filter' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$900e6ddadbcb8d02$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($900e6ddadbcb8d02$var$mapStateToPropsFactory, {})((0, $fwdEW.default));

});
parcelRegister("fwdEW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2acfb424a6da5ad8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $2acfb424a6da5ad8$export$2e2bcd8739ae039(props) {
    const { FilterView: FilterView, onFilter: onFilter } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FilterView, {
        onFilter: onFilter
    });
}

});


parcelRegister("gg466", function(module, exports) {

$parcel$export(module.exports, "default", () => $c60de6ef876d0e76$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cS37j = parcelRequire("cS37j");

var $az4zD = parcelRequire("az4zD");
function $c60de6ef876d0e76$var$Default(props) {
    const { Filter: Filter, Actions: Actions, caption: caption, hasEntities: hasEntities, intl: { formatMessage: formatMessage } } = props;
    let searchBar = null;
    let actions = null;
    if (hasEntities) {
        searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Filter, null);
        actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Actions, null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        truncateTitle: true,
        actions: actions,
        bottomBar: searchBar
    }, caption ? formatMessage(caption) : '');
}
var $c60de6ef876d0e76$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($c60de6ef876d0e76$var$Default);

});


parcelRegister("fjCWQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $06b8144acd42bd1f$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $6E8KZ = parcelRequire("6E8KZ");

var $26mQL = parcelRequire("26mQL");

var $eVVoZ = parcelRequire("eVVoZ");

var $hLegl = parcelRequire("hLegl");

var $1F2yg = parcelRequire("1F2yg");
const $06b8144acd42bd1f$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $8QpSo.default)((state)=>(filter)=>(0, $eVVoZ.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>{
        const headerConfiguration = (0, $eVVoZ.getHeaderConfiguration)(state);
        // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
        if (!headerConfiguration || !headerConfiguration.View) throw new Error('Invalid state - Header wrapper must not be mounted');
        return {
            // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
            HeaderView: headerConfiguration.View,
            hasEntities: (0, $hLegl.getStatus)(state) === 'has-entities',
            onFilter: onFilterFactory(state)
        };
    };
};
const $06b8144acd42bd1f$var$mapDispatchToProps = {
    onAdd: (0, $26mQL.initiate)
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Wrapper' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$06b8144acd42bd1f$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($06b8144acd42bd1f$var$mapStateToPropsFactory, $06b8144acd42bd1f$var$mapDispatchToProps)((0, $1F2yg.default));

});
parcelRegister("1F2yg", function(module, exports) {

$parcel$export(module.exports, "default", () => $197bfc3e7904115c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $197bfc3e7904115c$export$2e2bcd8739ae039(props) {
    const { HeaderView: HeaderView, hasEntities: hasEntities, onAdd: onAdd, onFilter: onFilter } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeaderView, {
        hasEntities: hasEntities,
        onAdd: onAdd,
        onFilter: onFilter
    });
}

});


parcelRegister("1zjdB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c7e92938aa45f06$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $hNlad = parcelRequire("hNlad");
const $6c7e92938aa45f06$var$mapStateToPropsFactory = ()=>{
    const onPageChangeFactory = (0, $8QpSo.default)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type. | TS7006 - Parameter 'page' implicitly has an 'any' type.
    (state)=>(event, page)=>(0, $eVVoZ.getOnReload)(state)({
                page: page
            }));
    return (state)=>({
            currentPage: (0, $eVVoZ.getPage)(state),
            totalPages: (0, $eVVoZ.getTotalPages)(state),
            onPageChange: onPageChangeFactory(state)
        });
};
var $6c7e92938aa45f06$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($6c7e92938aa45f06$var$mapStateToPropsFactory, {}, null, (0, $6E8KZ.storeOptions))((0, $hNlad.default));

});
parcelRegister("hNlad", function(module, exports) {

$parcel$export(module.exports, "default", () => $83c4a3856827caa5$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iASWI = parcelRequire("iASWI");

var $xBgAj = parcelRequire("xBgAj");

var $kgoHi = parcelRequire("kgoHi");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $4iWLf = parcelRequire("4iWLf");
function $83c4a3856827caa5$var$Paginator(props) {
    const { currentPage: currentPage, totalPages: totalPages, intl: { formatMessage: formatMessage } } = props;
    const onPageChange = (data, event, analyticsEvent)=>{
        props.onPageChange(data, event);
        if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'pagination');
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xBgAj.default), {
        selectedIndex: currentPage - 1,
        onChange: onPageChange,
        pages: (0, (/*@__PURE__*/$parcel$interopDefault($iASWI)))(1, totalPages + 1),
        previousLabel: formatMessage((0, $4iWLf.default).previousButton),
        nextLabel: formatMessage((0, $4iWLf.default).nextButton)
    });
    if (totalPages > 1) return (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_3') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $83c4a3856827caa5$var$styles.paginationContainer,
        testId: "global-pages.directories.directory-base.content.paginator.container"
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83c4a3856827caa5$var$Container, {
        "data-test-id": "global-pages.directories.directory-base.content.paginator.container"
    }, content);
    return null;
}
var $83c4a3856827caa5$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($83c4a3856827caa5$var$Paginator);
const $83c4a3856827caa5$var$styles = {
    paginationContainer: "_n3td1ejb _18u0xmi2"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $83c4a3856827caa5$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n3td1ejb _18u0xmi2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("xBgAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aaadfaafd170b3c$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $33etG = parcelRequire("33etG");

var $fmJTX = parcelRequire("fmJTX");

var $6s76W = parcelRequire("6s76W");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $5HBW9 = parcelRequire("5HBW9");

var $15F6T = parcelRequire("15F6T");

var $lmPue = parcelRequire("lmPue");

var $fc5SA = parcelRequire("fc5SA");

var $gRWrA = parcelRequire("gRWrA");
const $8aaadfaafd170b3c$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t",
    navigatorIconWrapper: "_18zr12x7"
};
const $8aaadfaafd170b3c$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($fmJTX))) : (0, (/*@__PURE__*/$parcel$interopDefault($6s76W)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        as: "span",
        xcss: $8aaadfaafd170b3c$var$styles.navigatorIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Chevron, {
        label: "",
        LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
        color: "currentColor"
    }));
}
function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, $fc5SA.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $fc5SA.emptyObject), max: max = 7, onChange: onChange = (0, $eGmKJ.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $lmPue.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $33etG.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$8aaadfaafd170b3c$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
            as: "li",
            xcss: $8aaadfaafd170b3c$var$styles.paginationMenuItem,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $15F6T.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBW9.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
            chevronDirection: "left"
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $8aaadfaafd170b3c$var$styles.paginationMenu
    }, (0, $gRWrA.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBW9.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
            chevronDirection: "right"
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $8aaadfaafd170b3c$var$Pagination = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;

});
parcelRegister("fmJTX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17932ebf54d3f380634494a3a0e710ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));

var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
function $b2fc843461eabf96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
    }, props));
$b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;

});
parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6122da5228d1f3e4cce8be42702737a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});

parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default,
        iconType: "utility"
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});


parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ef383524276f158d595d267ad16f45a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default,
        iconType: "utility"
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


parcelRegister("c0aEF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed572e62fc5b1cd0$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3JT92 = parcelRequire("3JT92");

var $bUmQV = parcelRequire("bUmQV");
const $ed572e62fc5b1cd0$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $ed572e62fc5b1cd0$var$Separator = ({ children: children })=>/*#__PURE__*/ $5uXOq.createElement("span", {
        className: (0, $bwpsq.default)([
            $ed572e62fc5b1cd0$var$styles.separator
        ])
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $ed572e62fc5b1cd0$var$Inline = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5uXOq.createElement($ed572e62fc5b1cd0$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $5uXOq.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ $5uXOq.createElement((0, $5uXOq.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5uXOq.createElement((0, $bUmQV.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $3JT92.cx)(grow === 'hug' && $ed572e62fc5b1cd0$var$styles.hug, grow === 'fill' && $ed572e62fc5b1cd0$var$styles.fill, // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- TODO: We need to handle pass-through `xcss` => `xcss` here.
        xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$ed572e62fc5b1cd0$var$Inline.displayName = 'Inline';
var $ed572e62fc5b1cd0$export$2e2bcd8739ae039 = $ed572e62fc5b1cd0$var$Inline;

});
parcelRegister("bUmQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ccb72b8ddc20b7$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d0ccb72b8ddc20b7$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $d0ccb72b8ddc20b7$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $d0ccb72b8ddc20b7$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $d0ccb72b8ddc20b7$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $d0ccb72b8ddc20b7$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $d0ccb72b8ddc20b7$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $d0ccb72b8ddc20b7$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $d0ccb72b8ddc20b7$var$Flex = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement(Component, {
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            $d0ccb72b8ddc20b7$var$styles.root,
            gap && $d0ccb72b8ddc20b7$var$columnGapMap[gap],
            columnGap && $d0ccb72b8ddc20b7$var$columnGapMap[columnGap],
            gap && $d0ccb72b8ddc20b7$var$rowGapMap[gap],
            rowGap && $d0ccb72b8ddc20b7$var$rowGapMap[rowGap],
            alignItems && $d0ccb72b8ddc20b7$var$alignItemsMap[alignItems],
            direction && $d0ccb72b8ddc20b7$var$flexDirectionMap[direction],
            justifyContent && $d0ccb72b8ddc20b7$var$justifyContentMap[justifyContent],
            wrap && $d0ccb72b8ddc20b7$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$d0ccb72b8ddc20b7$var$Flex.displayName = 'Flex';
var $d0ccb72b8ddc20b7$export$2e2bcd8739ae039 = $d0ccb72b8ddc20b7$var$Flex;

});


parcelRegister("5HBW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $63acbbc2953d9b5a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("15F6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $097dd42f19f41562$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("lmPue", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d144cd0d91a90ab$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $jldZL = parcelRequire("jldZL");
const $3d144cd0d91a90ab$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $3d144cd0d91a90ab$var$styles.container,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});

parcelRegister("fc5SA", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $cbef1c2cfb373aca$export$3f860eba1218f8d3);
const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};

});

parcelRegister("gRWrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $48fbac64848b775a$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $8QpSo.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;

});


parcelRegister("4iWLf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f9b7bf6876a52ce$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3f9b7bf6876a52ce$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    previousButton: {
        "id": "directory-base.content.paginator.previous-button",
        "defaultMessage": "Prev"
    },
    nextButton: {
        "id": "directory-base.content.paginator.next-button",
        "defaultMessage": "Next"
    }
});

});



parcelRegister("do0bP", function(module, exports) {

$parcel$export(module.exports, "default", () => $cca8b4269a3eb958$export$2e2bcd8739ae039);

var $dGvGJ = parcelRequire("dGvGJ");

var $8QpSo = parcelRequire("8QpSo");

var $6E8KZ = parcelRequire("6E8KZ");

var $lxmKy = parcelRequire("lxmKy");

var $eVVoZ = parcelRequire("eVVoZ");

var $d0BRN = parcelRequire("d0BRN");

var $c3kRB = parcelRequire("c3kRB");

var $joT8a = parcelRequire("joT8a");
const $cca8b4269a3eb958$var$getSpotlightForCellSelectorMemoized = ()=>(0, $dGvGJ.createSelector)((state)=>(0, $eVVoZ.getSpotlightForCell)(state), (res)=>res);
const $cca8b4269a3eb958$var$mapStateToPropsFactory = ()=>{
    const getSpotlightForCellSelectorInstance = $cca8b4269a3eb958$var$getSpotlightForCellSelectorMemoized();
    const onSortFactory = (0, $8QpSo.default)(// @ts-expect-error - TS7006 - Parameter 'sort' implicitly has an 'any' type.
    (state)=>(sort)=>(0, $eVVoZ.getOnReload)(state)({
                page: 1,
                ...sort
            }));
    return (state)=>{
        // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'EmptyFilterResultConfiguration'.
        const EmptyView = (0, $eVVoZ.getEmptyFilterResultConfiguration)(state).View || (0, $c3kRB.default);
        const TableMaskView = (0, $eVVoZ.getTableMaskView)(state);
        const filter = (0, $eVVoZ.getFilter)(state);
        const filterQuery = filter ? filter.query : '';
        return {
            tableConfiguration: (0, $eVVoZ.getTableConfiguration)(state),
            tableLabel: (0, $eVVoZ.getTableLabel)(state),
            resultsAnnouncerMessage: (0, $eVVoZ.getResultsAnnouncerMessage)(state),
            EmptyView: EmptyView,
            TableMaskView: TableMaskView,
            dataProvider: (0, $eVVoZ.getDataProvider)(state),
            entityIds: (0, $eVVoZ.getEntityIds)(state),
            totalItems: (0, $eVVoZ.getTotalItems)(state),
            operationInitializationStatusPerEntity: (0, $eVVoZ.getOperationInitializationStatusPerEntity)(state),
            isLoading: (0, $eVVoZ.isLoading)(state),
            sortField: (0, $eVVoZ.getSortField)(state),
            sortDirection: (0, $eVVoZ.getSortDirection)(state),
            onSort: onSortFactory(state),
            mountMetricKey: (0, $d0BRN.getTableMountedMetricKey)(state),
            getSpotlightForCell: getSpotlightForCellSelectorInstance(state),
            firstColumnHeadingAlignment: (0, $eVVoZ.getFirstColumnHeadingAlignment)(state),
            lastColumnHeadingAlignment: (0, $eVVoZ.getLastColumnHeadingAlignment)(state),
            filterQuery: filterQuery
        };
    };
};
const $cca8b4269a3eb958$var$mapDispatchToProps = {
    onOperationRequested: (0, $lxmKy.initiate)
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2.
$cca8b4269a3eb958$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($cca8b4269a3eb958$var$mapStateToPropsFactory, $cca8b4269a3eb958$var$mapDispatchToProps)((0, $joT8a.default));

});
parcelRegister("d0BRN", function(module, exports) {

$parcel$export(module.exports, "getTableMountedMetricKey", () => $fda68c97331475d3$export$b6c1493984bb04f9);
const $fda68c97331475d3$export$b6c1493984bb04f9 = (state)=>state.app.props.metrics.tableMounted;

});

parcelRegister("c3kRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $68cb0124d97ea366$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $dh6ia = parcelRequire("dh6ia");
const $68cb0124d97ea366$var$mapStateToProps = (state)=>{
    const configuration = (0, $eVVoZ.getEmptyFilterResultConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'message' does not exist on type 'EmptyFilterResultConfiguration'.
    if (!configuration.message) throw new Error('Invalid state - Default empty view should not be mounted');
    return {
        // @ts-expect-error - TS2339 - Property 'message' does not exist on type 'EmptyFilterResultConfiguration'.
        message: configuration.message
    };
};
var $68cb0124d97ea366$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($68cb0124d97ea366$var$mapStateToProps, null, null, (0, $6E8KZ.storeOptions))((0, $dh6ia.default));

});
parcelRegister("dh6ia", function(module, exports) {

$parcel$export(module.exports, "default", () => $d730ce5cb03c7be1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $4R6GH = parcelRequire("4R6GH");

var $8RXs9 = parcelRequire("8RXs9");

var $b3sGD = parcelRequire("b3sGD");
function $d730ce5cb03c7be1$var$DefaultEmptyView(props) {
    const { message: message } = props;
    const { intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-test-id": "global-pages.directories.directory-base.content.table.default-empty-view.empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($b3sGD))),
        header: formatMessage(message),
        size: "narrow",
        ...(0, $4R6GH.fg)('jfp-a11y-team_dashboards_empty-state-heading') && {
            headingLevel: 2
        }
    }));
}
var $d730ce5cb03c7be1$export$2e2bcd8739ae039 = (0, $8RXs9.default)($d730ce5cb03c7be1$var$DefaultEmptyView);

});
parcelRegister("b3sGD", function(module, exports) {
module.exports = new URL("generic-no-results.fb302821.svg", import.meta.url).toString();

});



parcelRegister("joT8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c01d48f0796d7f8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $7Jxgt = parcelRequire("7Jxgt");

var $dHbUn = parcelRequire("dHbUn");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $fraBZ = parcelRequire("fraBZ");


var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $l3DlM = parcelRequire("l3DlM");

var $8Tb2p = parcelRequire("8Tb2p");
class $5c01d48f0796d7f8$var$Table extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isLoading: false,
            entityIds: [],
            totalItems: 0,
            sortDirection: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
            mountMetricKey: undefined,
            getSpotlightForCell: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            TableMaskView: undefined,
            firstColumnHeadingAlignment: 'left',
            lastColumnHeadingAlignment: 'left',
            filterQuery: '',
            tableLabel: undefined,
            resultsAnnouncerMessage: (0, $8Tb2p.default).filterResultsAnnouncement,
            onSort: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onOperationRequested: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.sortDirection !== this.props.sortDirection || prevProps.sortField !== this.props.sortField) this.state.hasSortingChanged = true;
        if (!prevProps.isLoading && this.props.isLoading) this.state.shouldAnnounceResults = !this.state.hasSortingChanged;
        else if (prevProps.isLoading && !this.props.isLoading) this.state.hasSortingChanged = false;
    }
    render() {
        const { tableConfiguration: tableConfiguration, entityIds: entityIds, totalItems: totalItems, EmptyView: EmptyView, isLoading: isLoading, operationInitializationStatusPerEntity: operationInitializationStatusPerEntity, sortField: sortField, sortDirection: sortDirection, mountMetricKey: mountMetricKey, getSpotlightForCell: getSpotlightForCell, TableMaskView: TableMaskView, dataProvider: dataProvider, firstColumnHeadingAlignment: firstColumnHeadingAlignment, lastColumnHeadingAlignment: lastColumnHeadingAlignment, intl: { formatMessage: formatMessage }, tableLabel: tableLabel, resultsAnnouncerMessage: resultsAnnouncerMessage } = this.props;
        const headCells = tableConfiguration.map(({ title: title, width: width, sortField: cellSortField, dataTestId: dataTestId })=>{
            let content = '';
            const wrapperProps = dataTestId ? {
                'data-test-id': dataTestId
            } : {};
            if (dataTestId) // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$NonBreakingCell, wrapperProps);
            if (typeof title === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const HeaderCell = title; // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
                content = (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_3') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                    xcss: $5c01d48f0796d7f8$var$styles.headerWrapper,
                    testId: dataTestId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeaderCell, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$HeaderWrapper, wrapperProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeaderCell, null));
            } else if (typeof title !== 'undefined') {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const message = title; // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
                content = (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_3') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    testId: dataTestId,
                    color: "color.text.subtle",
                    maxLines: 1,
                    weight: "bold",
                    size: "small"
                }, formatMessage(message))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$NonBreakingCell, wrapperProps, formatMessage(message));
            }
            return {
                key: cellSortField || (0, $7Jxgt.v1)(),
                isSortable: !!cellSortField,
                content: content,
                width: width
            };
        });
        const head = {
            cells: headCells
        };
        const ids = dataProvider ? dataProvider.getData().map((entity)=>dataProvider.idSelector(entity)) : entityIds;
        const tableAriaLabel = tableLabel ? formatMessage(tableLabel) : undefined;
        const rowCells = ids.map((entityId, rowIndex)=>{
            // the page is already sorted (by the API), so fake key,
            // so that DynamicTable won't destroy it
            const key = sortDirection === 'DESC' ? -(rowIndex + 1) : rowIndex + 1;
            const entity = dataProvider ? dataProvider.getData()[rowIndex] : undefined;
            const cells = tableConfiguration.map(({ Cell: Cell }, colIndex)=>{
                const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Cell, {
                    id: entityId,
                    entity: entity,
                    isOperationInProgress: !!operationInitializationStatusPerEntity[entityId],
                    onOperationRequested: (operation, operationParams)=>this.props.onOperationRequested({
                            id: entityId,
                            childEntityId: operationParams && operationParams.childEntityId,
                            operation: operation
                        })
                });
                const getVisuallyRefreshedContent = (visuallyRefreshedContent)=>{
                    if (!(0, $dCm1o.isVisualRefreshEnabled)()) return visuallyRefreshedContent;
                    if ((0, $4R6GH.fg)('visual-refresh_drop_3')) return visuallyRefreshedContent;
                    if ((0, $4R6GH.fg)('visual-refresh_drop_2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                        alignItems: "center",
                        xcss: $5c01d48f0796d7f8$var$cellWrapperStyles
                    }, visuallyRefreshedContent);
                };
                const cellMatch = getSpotlightForCell(entityId, colIndex);
                if (cellMatch && cellMatch.spotlightId) {
                    const onboardingContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                        name: cellMatch.spotlightId
                    }, getVisuallyRefreshedContent(content));
                    return {
                        content: onboardingContent,
                        key: key
                    };
                }
                return {
                    content: getVisuallyRefreshedContent(content),
                    key: key
                };
            });
            return {
                cells: cells
            };
        });
        return(// Note: the data-test-id attribute is used by Pollinator checks in Jalapeno so avoid changing if possible
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$Container, {
            "data-test-id": "global-pages.directories.directory-base.content.table.container",
            firstColumnHeadingAlignment: firstColumnHeadingAlignment,
            lastColumnHeadingAlignment: lastColumnHeadingAlignment,
            visualRefreshEnabled: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_2')
        }, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3DlM.default), {
            performanceMarkKey: mountMetricKey
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
            message: formatMessage(resultsAnnouncerMessage || (0, $8Tb2p.default).filterResultsAnnouncement, {
                itemCount: totalItems
            }),
            shouldAnnounce: !isLoading && this.state.shouldAnnounceResults
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHbUn.default), {
            isFixedSize: true,
            isLoading: isLoading,
            head: head,
            rows: rowCells,
            onSort: this.onSort,
            sortKey: sortField,
            sortOrder: sortDirection,
            emptyView: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$EmptyLoadingView, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EmptyView, null),
            label: tableAriaLabel
        }), TableMaskView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TableMaskView, null)));
    }
    constructor(...args){
        super(...args), this.state = {
            hasSortingChanged: false,
            shouldAnnounceResults: false
        }, /**
   * We very much wish that `attrs` is an object of this type {| key: string, sortOrder: string |}
   * but unfortunately @atlaskit/dynamic-table types do not give any guarantee of that
   * so we should be handling mixed here.
   */ this.onSort = (attrs, analyticsEvent)=>{
            // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'unknown'. | TS2339 - Property 'sortOrder' does not exist on type 'unknown'.
            const { key: key, sortOrder: sortOrder } = attrs;
            const { onSort: onSort } = this.props;
            if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'tableHeader', {
                key: key
            });
            onSort({
                sortField: key,
                sortDirection: sortOrder
            });
        };
    }
}
var // @ts-expect-error - Argument of type 'typeof Table' is not assignable to parameter of type 'ComponentType<WithIntlProvided<Props<unknown, string, unknown, unknown>>> & typeof Table'.
$5c01d48f0796d7f8$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($5c01d48f0796d7f8$var$Table);
const $5c01d48f0796d7f8$var$TABLE_ROW_HEIGHT = '40px'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c01d48f0796d7f8$var$NonBreakingCell = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
}); // delete when cleaning up FG visual-refresh_drop_2
const $5c01d48f0796d7f8$var$cellWrapperStyles = (0, $8CUq3.xcss)({
    height: '40px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c01d48f0796d7f8$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { firstColumnHeadingAlignment: firstColumnHeadingAlignment, lastColumnHeadingAlignment: lastColumnHeadingAlignment, visualRefreshEnabled: visualRefreshEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1bgnkvw": (0, $lD23V.default)(__cmplp.firstColumnHeadingAlignment),
            "--_jlq5ur": (0, $lD23V.default)(__cmplp.lastColumnHeadingAlignment)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _2ws7jp4b _p4liidpf _6autidpf _7dd61ux8 _13jcdlk8 _496idlk8 _9yen1pfg _10wbnkob _jwot4jg8",
            __cmplp.visualRefreshEnabled && "_19ibi2wt _y4wot94y _oaa6nqa1 _10okmuej _cnoh16g6 _1m2zqbzx _1cuj1ylp _qassi2wt _1g00i2wt",
            __cmplp.className
        ])
    });
});
const $5c01d48f0796d7f8$var$styles = {
    headerWrapper: "_18zr1b66 _1rjcu2gc _4cvr1h6o _1bah1h6o _1bsbzwfg"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c01d48f0796d7f8$var$EmptyLoadingView = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1w81",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c01d48f0796d7f8$var$HeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dHbUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb6422faa785b221$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");


var $gS5Cm = parcelRequire("gS5Cm");

var $hiWL0 = parcelRequire("hiWL0");

var $kF3yx = parcelRequire("kF3yx");

var $fkvnY = parcelRequire("fkvnY");

var $hK8cd = parcelRequire("hK8cd");

var $dDBI6 = parcelRequire("dDBI6");

var $dk72m = parcelRequire("dk72m");

var $50Tma = parcelRequire("50Tma");

var $jlnvO = parcelRequire("jlnvO");
function $cb6422faa785b221$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65:
            return 0, $d43e0bb5a9200c87$export$1dee026a19752d6b;
        case 0, $d43e0bb5a9200c87$export$1dee026a19752d6b:
            return 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $cb6422faa785b221$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $eGmKJ.default), onSort: providedOnSort = (0, $eGmKJ.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $eGmKJ.default), onRankEnd: providedOnRankEnd = (0, $eGmKJ.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous',
    next: 'Next',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
    const tableBodyRef = (0, $5uXOq.useRef)(null);
    const onSort = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $5uXOq.useEffect)(()=>{
        (0, $gS5Cm.validateSortKey)(sortKey, head);
        (0, $gS5Cm.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) : $cb6422faa785b221$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $gS5Cm.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3) : (0, $d43e0bb5a9200c87$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kF3yx.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kF3yx.EmptyViewContainer), {
            testId: testId
        }, emptyView);
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dk72m.default), {
        isLoading: isLoading && rowsExist,
        spinnerSize: spinnerSize,
        targetRef: ()=>tableBodyRef.current,
        testId: testId,
        loadingLabel: loadingLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hiWL0.Table), {
        isFixedSize: isFixedSize,
        "aria-label": label,
        hasDataRow: rowsExist,
        testId: testId,
        isLoading: isLoading
    }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hiWL0.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jlnvO.default), {
        head: head,
        onSort: onSortHandler,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRanking: isRanking,
        isRankable: isRankable,
        testId: testId
    }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$TableBody, {
        ref: tableBodyRef,
        highlightedRowIndex: highlightedRowIndex,
        rows: rows,
        head: head,
        sortKey: sortKey,
        sortOrder: sortOrder,
        rowsPerPage: rowsPerPage,
        page: getPageNumber,
        isFixedSize: isFixedSize || false,
        onPageRowsUpdate: onPageRowsUpdate,
        isTotalPagesControlledExternally: isTotalPagesControlledExternally,
        testId: testId,
        isRankable: isRankable,
        isRanking: isRanking,
        onRankStart: onRankStartHandler,
        onRankEnd: onRankEndHandler,
        isRankingDisabled: isRankingDisabled || isLoading || false
    }))), totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hiWL0.PaginationWrapper), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $50Tma.default), {
        value: getPageNumber,
        onChange: onSetPageHandler,
        total: totalPages,
        i18n: paginationi18n,
        isDisabled: isLoading,
        testId: testId
    })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dDBI6.default), {
        isLoading: isLoading,
        spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
        testId: testId,
        loadingLabel: loadingLabel
    }, emptyBody));
};

const $cb6422faa785b221$var$RankableTableBody = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("8DmN8")));
const $cb6422faa785b221$var$TableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fkvnY.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hK8cd.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$RankableTableBody, {
        ref: ref,
        ...bodyProps,
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    }))) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cb6422faa785b221$export$2e2bcd8739ae039 = $cb6422faa785b221$var$DynamicTable;

});
const $d43e0bb5a9200c87$export$1dee026a19752d6b = 'ASC';
const $d43e0bb5a9200c87$export$b6abcf7fa1d94f65 = 'DESC';
const $d43e0bb5a9200c87$export$71dd4c8ecd45e95f = 'small';
const $d43e0bb5a9200c87$export$7b93a10c0fefe3e3 = 'large';
const $d43e0bb5a9200c87$export$3843c586a90b9cbf = 0.22;

parcelRegister("gS5Cm", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $7f55105045703159$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $7f55105045703159$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $7f55105045703159$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $7f55105045703159$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $7f55105045703159$export$c476bbe5da59992d);
const $7f55105045703159$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $7f55105045703159$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $7f55105045703159$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $7f55105045703159$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $7f55105045703159$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $7f55105045703159$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $7f55105045703159$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $7f55105045703159$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("hiWL0", function(module, exports) {

$parcel$export(module.exports, "tableRowCSSVars", () => $3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb);
$parcel$export(module.exports, "Table", () => $3b29b0d00cd7b5c6$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $54lmm = parcelRequire("54lmm");
function $3b29b0d00cd7b5c6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb = {
    CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
    CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
    CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
    CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
};
const $3b29b0d00cd7b5c6$var$fixedSizeTableStyles = {
    name: "wgb42e",
    styles: "table-layout:fixed"
};
const $3b29b0d00cd7b5c6$var$tableStyles = {
    name: "mul4pg",
    styles: "width:100%;border-collapse:separate;border-spacing:0px"
};
const $3b29b0d00cd7b5c6$var$bodyBorder = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $54lmm.tableBorder).borderColor}`
});
const $3b29b0d00cd7b5c6$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, $54lmm.row).hoverBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, $54lmm.row).highlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, $54lmm.row).hoverHighlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, $54lmm.row).focusOutline
        },
        css: [
            $3b29b0d00cd7b5c6$var$tableStyles,
            isFixedSize && $3b29b0d00cd7b5c6$var$fixedSizeTableStyles,
            hasDataRow && $3b29b0d00cd7b5c6$var$bodyBorder
        ],
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`
    }, children);
});
const $3b29b0d00cd7b5c6$var$captionStyles = {
    name: "h9a27i",
    styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
};
const $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("caption", {
        css: $3b29b0d00cd7b5c6$var$captionStyles
    }, children);
const $3b29b0d00cd7b5c6$var$paginationWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $3b29b0d00cd7b5c6$var$paginationWrapperStyles,
        "data-testid": testId && `${testId}--pagination--container`
    }, children);

});
parcelRegister("54lmm", function(module, exports) {

$parcel$export(module.exports, "MSThemeColors", () => $b728acac6d8ee4bc$export$34af08ce45c78352);
$parcel$export(module.exports, "arrow", () => $b728acac6d8ee4bc$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "row", () => $b728acac6d8ee4bc$export$120ff0929b202a6d);
$parcel$export(module.exports, "head", () => $b728acac6d8ee4bc$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tableBorder", () => $b728acac6d8ee4bc$export$38d703b73e2cf64d);

const $b728acac6d8ee4bc$export$34af08ce45c78352 = {
    Background: 'Canvas',
    Text: 'CanvasText',
    SelectedBackground: 'Highlight',
    SelectedText: 'HighlightText'
};
const $b728acac6d8ee4bc$export$f2120bbfa5450bd2 = {
    defaultColor: `var(--ds-icon-disabled, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`,
    selectedColor: `var(--ds-icon-subtle, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
};
const $b728acac6d8ee4bc$export$120ff0929b202a6d = {
    focusOutline: `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
    highlightedBackground: `var(--ds-background-selected, ${$829f609a65d26a98$export$226de0355ed012f8})`,
    hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$829f609a65d26a98$export$e655ef011c4aa1a2})`,
    hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`
};
const $b728acac6d8ee4bc$export$5fd5031fecdacec3 = {
    textColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
};
const $b728acac6d8ee4bc$export$38d703b73e2cf64d = {
    borderColor: `var(--ds-border, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
};

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';



parcelRegister("kF3yx", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $0852c529eaab7231$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $0852c529eaab7231$export$381ea436de119582);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $0852c529eaab7231$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0852c529eaab7231$var$fixedHeightStyles = {
    name: "50gc26",
    styles: "height:9rem"
};
const $0852c529eaab7231$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $0852c529eaab7231$var$fixedHeightStyles,
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`
    }, children);
const $0852c529eaab7231$var$emptyViewContainerStyles = {
    name: "1yld51o",
    styles: "width:50%;margin:auto;padding:10px;text-align:center"
};
const $0852c529eaab7231$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $0852c529eaab7231$var$emptyViewContainerStyles,
        "data-testid": testId && `${testId}--empty-view-container`
    }, children);
};

});

parcelRegister("fkvnY", function(module, exports) {

$parcel$export(module.exports, "default", () => $32bba7afdbc8736a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7bJDt = parcelRequire("7bJDt");

var $ggqAE = parcelRequire("ggqAE");
class $32bba7afdbc8736a$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef
        }, pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ggqAE.default), {
                head: head,
                isFixedSize: isFixedSize,
                key: row.key || rowIndex,
                row: row,
                isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                testId: testId
            })));
    }
}
const $32bba7afdbc8736a$var$Body = (0, $7bJDt.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($32bba7afdbc8736a$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$32bba7afdbc8736a$export$2e2bcd8739ae039 = $32bba7afdbc8736a$var$Body;

});
parcelRegister("7bJDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc6eeecb3dc05edd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $gS5Cm = parcelRequire("gS5Cm");
const $dc6eeecb3dc05edd$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $dc6eeecb3dc05edd$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $dc6eeecb3dc05edd$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $dc6eeecb3dc05edd$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $dc6eeecb3dc05edd$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $gS5Cm.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $dc6eeecb3dc05edd$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $gS5Cm.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("ggqAE", function(module, exports) {

$parcel$export(module.exports, "default", () => $136b57fea50cecd2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1g0dL = parcelRequire("1g0dL");

var $d9WgS = parcelRequire("d9WgS");
const $136b57fea50cecd2$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9WgS.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
    }, cells.map((cell, cellIndex)=>{
        const { content: content, testId: cellTestId, ...restCellProps } = cell;
        const { shouldTruncate: shouldTruncate, width: width } = (head || {
            cells: []
        }).cells[cellIndex] || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1g0dL.TableBodyCell), {
            "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
            ...restCellProps,
            isFixedSize: isFixedSize,
            key: cellIndex,
            shouldTruncate: shouldTruncate,
            width: width
        }, content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$136b57fea50cecd2$export$2e2bcd8739ae039 = $136b57fea50cecd2$var$Row;

});
parcelRegister("1g0dL", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $11c3ea74eda01ab8$export$948e91fcef170792);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $9GQPi = parcelRequire("9GQPi");
const $11c3ea74eda01ab8$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $9GQPi.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $9GQPi.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && (0, $9GQPi.overflowTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $9GQPi.cellStyles)
        ],
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        ...props
    });

});
parcelRegister("9GQPi", function(module, exports) {

$parcel$export(module.exports, "truncationWidthStyles", () => $99c9652c1fab2b08$export$708a733455f59a29);
$parcel$export(module.exports, "fixedSizeTruncateStyles", () => $99c9652c1fab2b08$export$616c93ee022c8812);
$parcel$export(module.exports, "overflowTruncateStyles", () => $99c9652c1fab2b08$export$7f2cd17defa265d8);
$parcel$export(module.exports, "getTruncationStyleVars", () => $99c9652c1fab2b08$export$5e6497a652ae30b5);
$parcel$export(module.exports, "cellStyles", () => $99c9652c1fab2b08$export$f7913df521f684e2);

var $f8Sb3 = parcelRequire("f8Sb3");
function $99c9652c1fab2b08$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $99c9652c1fab2b08$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $99c9652c1fab2b08$export$708a733455f59a29 = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: `var(${$99c9652c1fab2b08$var$CSS_VAR_WIDTH})`
});
const $99c9652c1fab2b08$export$616c93ee022c8812 = {
    name: "1s7jr4j",
    styles: "text-overflow:ellipsis;white-space:nowrap"
};
const $99c9652c1fab2b08$export$7f2cd17defa265d8 = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $99c9652c1fab2b08$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$99c9652c1fab2b08$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
const $99c9652c1fab2b08$export$f7913df521f684e2 = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    border: 'none',
    textAlign: 'left',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        paddingInlineStart: "var(--ds-space-0, 0px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        paddingInlineEnd: "var(--ds-space-0, 0px)"
    }
});

});


parcelRegister("d9WgS", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $ba9cb59faf06ce7f$export$45f39d9c38b886d5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $hiWL0 = parcelRequire("hiWL0");
const $ba9cb59faf06ce7f$var$rowStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    '&:focus-visible': {
        outline: `2px solid ${`var(--ds-border-focused, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $hiWL0.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
        outlineOffset: `-2px`
    }
});
const $ba9cb59faf06ce7f$var$rowBackgroundStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $hiWL0.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
    }
});
const $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: `var(--ds-background-selected, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    `var(${(0, $hiWL0.tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $hiWL0.tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
    }
});
const $ba9cb59faf06ce7f$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        css: [
            $ba9cb59faf06ce7f$var$rowStyles,
            isHighlighted ? $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles : $ba9cb59faf06ce7f$var$rowBackgroundStyles
        ],
        ...rest,
        ref: ref,
        "data-testid": testId
    }, children);
});

});



parcelRegister("hK8cd", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $883137116243a6a0$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
class $883137116243a6a0$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("dDBI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4b90b361173610$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $lLAKY = parcelRequire("lLAKY");
class $2e4b90b361173610$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $d43e0bb5a9200c87$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLAKY.Container), {
            testId: testId
        }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLAKY.ContentsContainer), {
            contentsOpacity: contentsOpacity,
            testId: testId
        }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLAKY.SpinnerContainer), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        })));
    }
}

});
parcelRegister("lLAKY", function(module, exports) {

$parcel$export(module.exports, "Container", () => $d0e2766ad96d94ad$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $d0e2766ad96d94ad$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $d0e2766ad96d94ad$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $d0e2766ad96d94ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d0e2766ad96d94ad$export$c335a80381ec61f5 = '--contents-opacity';
const $d0e2766ad96d94ad$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $d0e2766ad96d94ad$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d0e2766ad96d94ad$var$containerStyles,
        "data-testid": testId && `${testId}--container`
    }, children);
const $d0e2766ad96d94ad$var$contentsContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: `var(${$d0e2766ad96d94ad$export$c335a80381ec61f5})`,
    pointerEvents: 'none'
});
const $d0e2766ad96d94ad$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$d0e2766ad96d94ad$export$c335a80381ec61f5]: contentsOpacity
        },
        css: [
            $d0e2766ad96d94ad$var$contentsContainerStyles
        ],
        "data-testid": testId && `${testId}--contents--container`
    }, children);
const $d0e2766ad96d94ad$var$spinnerContainerStyles = {
    name: "su4u96",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
};
const $d0e2766ad96d94ad$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d0e2766ad96d94ad$var$spinnerContainerStyles,
        "data-testid": testId && `${testId}--spinner--container`
    }, children);

});


parcelRegister("dk72m", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba39c903b39a83b1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $4xXH4 = parcelRequire("4xXH4");
class $ba39c903b39a83b1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $d43e0bb5a9200c87$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4xXH4.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef
        }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4xXH4.SpinnerBackdrop), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4xXH4.SpinnerContainer), {
            ref: this.spinnerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        }))));
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("4xXH4", function(module, exports) {

$parcel$export(module.exports, "Container", () => $48301faf1109874f$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $48301faf1109874f$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $48301faf1109874f$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
function $48301faf1109874f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $48301faf1109874f$var$containerStyles = {
    name: "17fhw1k",
    styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
};
const $48301faf1109874f$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $48301faf1109874f$var$containerStyles,
        ...rest,
        "data-testid": testId,
        ref: ref
    }, children));
});
const $48301faf1109874f$var$spinnerBackdropStyles = {
    name: "1yy6mjk",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
};
const $48301faf1109874f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $48301faf1109874f$var$spinnerBackdropStyles,
        "data-testid": testId && `${testId}--spinner-backdrop`
    }, children);
const $48301faf1109874f$var$spinnerContainerStyles = {
    name: "vi3nlf",
    styles: "position:relative;inset-block-start:0"
};
const $48301faf1109874f$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $48301faf1109874f$var$spinnerContainerStyles,
        ref: ref
    }, children));

});


parcelRegister("50Tma", function(module, exports) {

$parcel$export(module.exports, "default", () => $21d5ee5c6331aeb9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $xBgAj = parcelRequire("xBgAj");
class $21d5ee5c6331aeb9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xBgAj.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});

parcelRegister("jlnvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $097ee65829e33b82$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $gS5Cm = parcelRequire("gS5Cm");

var $9Ooyy = parcelRequire("9Ooyy");

var $a41RA = parcelRequire("a41RA");

var $7gEwE = parcelRequire("7gEwE");

var $dpXLF = parcelRequire("dpXLF");

var $BQUUh = parcelRequire("BQUUh");
class $097ee65829e33b82$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $gS5Cm.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $gS5Cm.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponentOld = isRankable ? (0, $7gEwE.default) : (0, $BQUUh.default);
        const HeadCellComponent = isRankable ? (0, $a41RA.default) : (0, $dpXLF.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ooyy.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", null, cells.map((cell, index)=>{
            const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
            // the API.
            ...restCellProps } = cell;
            const headCellId = `head-cell-${index}`;
            const handleClick = ()=>{
                this.setState({
                    activeSortButtonId: headCellId
                });
                if (isSortable) onSort(cell)();
            };
            return (0, $VSDnB.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeadCellComponent, {
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isIconOnlyHeader: isIconOnlyHeader,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                headCellId: headCellId,
                activeSortButtonId: activeSortButtonId,
                onClick: handleClick,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ascendingSortTooltip: ascendingSortTooltip,
                descendingSortTooltip: descendingSortTooltip,
                buttonAriaRoleDescription: buttonAriaRoleDescription,
                ...restCellProps
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeadCellComponentOld, {
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                onClick: isSortable ? onSort(cell) : undefined,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ...restCellProps
            });
        })));
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$097ee65829e33b82$export$2e2bcd8739ae039 = $097ee65829e33b82$var$TableHead;

});
parcelRegister("9Ooyy", function(module, exports) {

$parcel$export(module.exports, "Head", () => $e002e0403dc403bb$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $e002e0403dc403bb$export$4e8024263ace498b);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");



var $54lmm = parcelRequire("54lmm");

var $9GQPi = parcelRequire("9GQPi");
function $e002e0403dc403bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $e002e0403dc403bb$var$rankingStyles = {
    name: "4zleql",
    styles: "display:block"
};
const $e002e0403dc403bb$var$headStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderBlockEnd: `none`
});
const $e002e0403dc403bb$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("thead", {
        css: [
            $e002e0403dc403bb$var$headStyles,
            isRanking && $e002e0403dc403bb$var$rankingStyles
        ],
        "data-testid": testId,
        ...props
    });
};
const $e002e0403dc403bb$var$headCellBaseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $54lmm.tableBorder).borderColor}`,
    color: `var(--ds-text-subtle, ${`var(${$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    textAlign: 'left',
    verticalAlign: 'middle',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
    }
});
const $e002e0403dc403bb$var$headCellBaseStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $54lmm.tableBorder).borderColor}`,
    color: `var(--ds-text-subtle, ${`var(${$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
    }
});
const $e002e0403dc403bb$var$onClickStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        cursor: 'pointer'
    }
});
const $e002e0403dc403bb$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        padding: "var(--ds-space-0, 0)",
        position: 'relative',
        appearance: 'none',
        background: 'none',
        border: 'none',
        color: 'inherit',
        cursor: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontWeight: 'inherit',
        '&::before, &::after': {
            display: 'block',
            width: 0,
            height: 0,
            position: 'absolute',
            border: '3px solid transparent',
            content: '""',
            insetInlineEnd: "var(--ds-space-negative-100, -8px)"
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $54lmm.arrow).defaultColor}`,
            insetBlockEnd: "var(--ds-space-100, 8px)"
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $54lmm.arrow).defaultColor}`,
            insetBlockEnd: 0
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before, &::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `3px solid ${(0, $54lmm.MSThemeColors).Background}`
            },
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $54lmm.MSThemeColors).Text}`
            },
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $54lmm.MSThemeColors).Text}`
            }
        }
    }
});
const $e002e0403dc403bb$var$ascendingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $54lmm.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $54lmm.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e002e0403dc403bb$var$descendingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $54lmm.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $54lmm.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e002e0403dc403bb$export$4e8024263ace498b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        [$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR]: (0, $54lmm.head).textColor
    };
    const isASC = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    const isVisuallyRefreshed = (0, $VSDnB.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $9GQPi.cellStyles),
            isVisuallyRefreshed ? $e002e0403dc403bb$var$headCellBaseStyles : $e002e0403dc403bb$var$headCellBaseStylesOld,
            !isVisuallyRefreshed && onClick && $e002e0403dc403bb$var$onClickStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $9GQPi.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $9GQPi.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && (0, $9GQPi.overflowTruncateStyles),
            !isVisuallyRefreshed && isSortable && $e002e0403dc403bb$var$baseStyles,
            !isVisuallyRefreshed && isASC && $e002e0403dc403bb$var$ascendingStyles,
            !isVisuallyRefreshed && isDESC && $e002e0403dc403bb$var$descendingStyles
        ],
        onClick: !isVisuallyRefreshed ? onClick : undefined,
        ref: ref,
        "data-testid": testId,
        ...rest
    }, children);
});

});

parcelRegister("a41RA", function(module, exports) {

$parcel$export(module.exports, "default", () => $669a06e89a9827f7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $dpXLF = parcelRequire("dpXLF");
class $669a06e89a9827f7$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpXLF.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $669a06e89a9827f7$var$RankableTableHeadCell = (0, $cVljL.default)($669a06e89a9827f7$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$669a06e89a9827f7$export$2e2bcd8739ae039 = $669a06e89a9827f7$var$RankableTableHeadCell;

});
parcelRegister("cVljL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e49a9b167764eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $a3e49a9b167764eb$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("dpXLF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c80f4a483cfd6a$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $cC5ib = parcelRequire("cC5ib");

var $kcHZS = parcelRequire("kcHZS");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $3Lty3 = parcelRequire("3Lty3");
var $dS3PR = parcelRequire("dS3PR");

var $3bDjY = parcelRequire("3bDjY");


var $9Ooyy = parcelRequire("9Ooyy");
const $d9c80f4a483cfd6a$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $d9c80f4a483cfd6a$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o"
};
const $d9c80f4a483cfd6a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $d9c80f4a483cfd6a$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Lty3.default), {
        onClick: onClick,
        xcss: $d9c80f4a483cfd6a$var$styles.buttonWrapper,
        "aria-roledescription": buttonAriaRoleDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        xcss: isVisibleIconOnlyHeader ? $d9c80f4a483cfd6a$var$styles.hideIconHeaderWrapper : $d9c80f4a483cfd6a$var$styles.visibleHeaderWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "small",
        color: "color.text.subtle",
        weight: "bold",
        maxLines: 1
    }, content)), shouldRenderSortIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        xcss: isSortIconVisible ? $d9c80f4a483cfd6a$var$styles.sortIconVisibleWrapper : $d9c80f4a483cfd6a$var$styles.sortIconHiddenWrapper
    }, sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kcHZS))), {
        label: "",
        color: "var(--ds-text-subtle, #44546F)",
        testId: testId && `${testId}--up--icon`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cC5ib))), {
        label: "",
        color: "var(--ds-text-subtle, #44546F)",
        testId: testId && `${testId}--down--icon`
    })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder
    }, isSortable ? visuallyRefreshedButton : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d9c80f4a483cfd6a$export$2e2bcd8739ae039 = $d9c80f4a483cfd6a$var$TableHeadCell;

});
parcelRegister("cC5ib", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::980468f720de67e44e700795aed02102>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $92ed238f23140736$var$_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $92ed238f23140736$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92ed238f23140736$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1v12.75m-5-4.5 5 5 5-5"/>`
    }, props));
$92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;

});

parcelRegister("kcHZS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::656cb3b07e22a80c807b482f8fbbfa44>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb570e807ab2e210$var$_react = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb570e807ab2e210$var$_baseNew = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb570e807ab2e210$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb570e807ab2e210$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $eb570e807ab2e210$var$_react.default.createElement($eb570e807ab2e210$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15V2.25m-5 4.5 5-5 5 5"/>`
    }, props));
$eb570e807ab2e210$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $eb570e807ab2e210$var$_default = module.exports.default = $eb570e807ab2e210$var$ArrowUpIcon;

});

parcelRegister("3Lty3", function(module, exports) {

$parcel$export(module.exports, "default", () => $70eb08f4038c94d3$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $6wxJn = parcelRequire("6wxJn");

var $a1dy0 = parcelRequire("a1dy0");
const $70eb08f4038c94d3$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
}; /**
    * __Pressable__
    *
    * A primitive for building custom buttons.
    *
    * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
    * - [Code](https://atlassian.design/components/primitives/pressable/code)
    * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
    */ 
const $70eb08f4038c94d3$var$Pressable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $eGmKJ.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ $5uXOq.createElement((0, $a1dy0.default // @ts-expect-error we don't allow `button` on Focusable for makers as they should use Pressable instead
    ), {
        as: "button" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- TODO: Properly type this and allow pass-through if we can determine the type
        ,
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $DEWI6.cx)($70eb08f4038c94d3$var$styles.root, isDisabled && $70eb08f4038c94d3$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }, children);
});
var $70eb08f4038c94d3$export$2e2bcd8739ae039 = $70eb08f4038c94d3$var$Pressable;

});



parcelRegister("7gEwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $BQUUh = parcelRequire("BQUUh");
class $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BQUUh.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld = (0, $cVljL.default)($5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039 = $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld;

});
parcelRegister("BQUUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bd2f57a58531c0d$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $5uXOq = parcelRequire("5uXOq");

var $9Ooyy = parcelRequire("9Ooyy");
const $4bd2f57a58531c0d$var$TableHeadCellOld = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable
    }, isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4bd2f57a58531c0d$export$2e2bcd8739ae039 = $4bd2f57a58531c0d$var$TableHeadCellOld;

});



parcelRegister("8DmN8", function(module, exports) {

let $6493a52e1cae0609$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6493a52e1cae0609$var$load("cM9em"),
    $6493a52e1cae0609$var$load("fr9NE"),
    $6493a52e1cae0609$var$load("bz1jP")
]).then(()=>parcelRequire('4THp8'));

});


parcelRegister("8Tb2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ccc3b7593e6b203$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3ccc3b7593e6b203$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterResultAnnounce: {
        "id": "directory-base.content.table.filter-result-announce",
        "defaultMessage": "{itemCount, plural, one {One item was found after filtering.} other {{itemCount} items were found after filtering.}}"
    },
    filterResultsAnnouncement: {
        "id": "directory-base.content.table.filter-results-announcement",
        "defaultMessage": "{itemCount, plural, =0 {No results were found that match your search} one {{itemCount} result found} other {{itemCount} results found}}"
    }
});

});



parcelRegister("gO9Up", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c83f1ab25cac0ee$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $imZsD = parcelRequire("imZsD");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");
const $8c83f1ab25cac0ee$var$styles = {
    pageContainerNav3: "_7opz1wug",
    pageContainerNav3inner: "_1ul94na8"
};
function $8c83f1ab25cac0ee$export$2e2bcd8739ae039(props) {
    const { Header: Header, Table: Table, Paginator: Paginator, Empty: Empty, Error: Error, status: status, onAdd: onAdd, onRetry: onRetry, isOnboardingEnabled: isOnboardingEnabled, renderOnboardingSpotlight: renderOnboardingSpotlight, availableSpotlightTargets: availableSpotlightTargets } = props;
    let main = null;
    let spotlight = null;
    let expectOverflow = false;
    switch(status){
        case 'has-entities':
            expectOverflow = true;
            main = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Table, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Paginator, null));
            spotlight = isOnboardingEnabled && renderOnboardingSpotlight && renderOnboardingSpotlight(availableSpotlightTargets);
            break;
        case 'empty':
            main = Empty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Empty, {
                onAdd: onAdd
            }) : null;
            break;
        case 'error':
            main = Error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Error, {
                onRetry: onRetry
            }) : null;
            break;
        default:
            break;
    }
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null) : null, main));
    if (expectOverflow && (0, $4R6GH.fg)('blu-6146-responsive-directories')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $8c83f1ab25cac0ee$var$styles.pageContainerNav3
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $8c83f1ab25cac0ee$var$styles.pageContainerNav3inner
        ])
    }, main)));
    return expectOverflow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $8c83f1ab25cac0ee$var$styles.pageContainerNav3
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $8c83f1ab25cac0ee$var$styles.pageContainerNav3inner
        ])
    }, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null) : null, main))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null) : null, main));
}
$8c83f1ab25cac0ee$export$2e2bcd8739ae039.defaultProps = {
    isOnboardingEnabled: false,
    renderOnboardingSpotlight: ()=>null,
    availableSpotlightTargets: [],
    onAdd: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onRetry: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};

});


parcelRegister("gZxo5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9e30bbc17bbf06$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $7vDsW = parcelRequire("7vDsW");

var $dXqrk = parcelRequire("dXqrk");

var $jd28H = parcelRequire("jd28H");
const $ad9e30bbc17bbf06$var$mapStateToProps = (state)=>({
        isCreateModalShown: (0, $eVVoZ.isCreateOpen)(state),
        CreateModal: $7vDsW.default,
        operations: (0, $eVVoZ.getOperations)(state),
        OperationModal: $dXqrk.default
    });
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Modals' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$ad9e30bbc17bbf06$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($ad9e30bbc17bbf06$var$mapStateToProps, {})((0, $jd28H.default));

});
parcelRegister("7vDsW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d32de1c8b6343c$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $26mQL = parcelRequire("26mQL");

var $eVVoZ = parcelRequire("eVVoZ");

var $k3e3M = parcelRequire("k3e3M");
const $f7d32de1c8b6343c$var$mapStateToProps = (state)=>{
    const CreateModal = (0, $eVVoZ.getCreateModal)(state);
    if (!CreateModal) throw new Error('Invalid state - no Create Modal provided');
    return {
        CreateModal: CreateModal
    };
};
const $f7d32de1c8b6343c$var$mapDispatchToProps = {
    onCreated: (0, $26mQL.entityCreated),
    onCreateFailed: (0, $26mQL.entityCreateFailed),
    onCancel: (0, $26mQL.cancelled)
};
var $f7d32de1c8b6343c$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($f7d32de1c8b6343c$var$mapStateToProps, $f7d32de1c8b6343c$var$mapDispatchToProps, null, (0, $6E8KZ.storeOptions))((0, $k3e3M.default));

});
parcelRegister("k3e3M", function(module, exports) {

$parcel$export(module.exports, "default", () => $4842467b44d7e63d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $4842467b44d7e63d$export$2e2bcd8739ae039(props) {
    const { CreateModal: CreateModal, onCreated: onCreated, onCreateFailed: onCreateFailed, onCancel: onCancel } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CreateModal, {
        onCreated: onCreated,
        onCreateFailed: onCreateFailed,
        onCancel: onCancel
    });
}

});


parcelRegister("dXqrk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dde6756d9548826$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $6E8KZ = parcelRequire("6E8KZ");

var $lxmKy = parcelRequire("lxmKy");

var $eVVoZ = parcelRequire("eVVoZ");

var $1jyVQ = parcelRequire("1jyVQ");
const $5dde6756d9548826$var$mapStateToPropsFactory = ()=>{
    const onDataRetrievedFactory = (0, $8QpSo.default)((state, id)=>// @ts-expect-error - TS7031 - Binding element 'patch' implicitly has an 'any' type.
        ({ patch: patch })=>(0, $eVVoZ.getOnPatch)(state)({
                id: id,
                patch: patch
            }));
    return (state, ownProps)=>{
        const { id: id, operation: operation } = ownProps;
        return {
            OperationModal: (0, $eVVoZ.getOperationModal)(state, operation),
            onDataRetrieved: onDataRetrievedFactory(state, id)
        };
    };
};
const $5dde6756d9548826$var$mapDispatchToProps = (dispatch, ownProps)=>{
    const { id: id, operation: operation, childEntityId: childEntityId, isInitializing: isInitializing } = ownProps;
    return {
        entityId: id,
        isInitializing: isInitializing,
        onDialogShown: ()=>dispatch((0, $lxmKy.dialogShown)({
                id: id,
                operation: operation,
                childEntityId: childEntityId
            })),
        onDataRetrieveFailed: ()=>dispatch((0, $lxmKy.entityDataRetrieveFailed)({
                id: id,
                operation: operation
            })),
        // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
        onUpdated: ({ patch: patch } = {})=>dispatch((0, $lxmKy.entityUpdated)({
                id: id,
                operation: operation,
                patch: patch
            })),
        onUpdateFailed: ()=>dispatch((0, $lxmKy.entityUpdateFailed)({
                id: id,
                operation: operation
            })),
        onCancel: ()=>dispatch((0, $lxmKy.cancelled)({
                id: id,
                operation: operation
            }))
    };
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Operation' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$5dde6756d9548826$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($5dde6756d9548826$var$mapStateToPropsFactory, $5dde6756d9548826$var$mapDispatchToProps)((0, $1jyVQ.default));

});
parcelRegister("1jyVQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd144476f98eada3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $bd144476f98eada3$export$2e2bcd8739ae039(props) {
    const { OperationModal: OperationModal, ...modalProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OperationModal, modalProps);
}

});


parcelRegister("jd28H", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5c2b4eef0dc70b8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $a5c2b4eef0dc70b8$export$2e2bcd8739ae039(props) {
    const { isCreateModalShown: isCreateModalShown, CreateModal: CreateModal, operations: operations, OperationModal: OperationModal } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, isCreateModalShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CreateModal, null), operations.map(({ id: id, operation: operation, childEntityId: childEntityId, isInitializing: isInitializing })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OperationModal, {
            key: id,
            id: id,
            operation: operation,
            childEntityId: childEntityId,
            isInitializing: isInitializing
        })));
}

});


parcelRegister("1Evzn", function(module, exports) {

$parcel$export(module.exports, "default", () => $17f4de78934b94b3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $17f4de78934b94b3$export$2e2bcd8739ae039(props) {
    const { Content: Content, Modals: Modals } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Modals, null));
}

});



parcelRegister("3HKsZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f815c7479561ebc$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $7CwOv = parcelRequire("7CwOv");

var $bv1G0 = parcelRequire("bv1G0");

var $8BZxM = parcelRequire("8BZxM");

var $8RXs9 = parcelRequire("8RXs9");

var $1DrFO = parcelRequire("1DrFO");
var $6f815c7479561ebc$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $8RXs9.default), (0, $7CwOv.default)({
    CreateDialogLoader: $bv1G0.default,
    CreateButton: $8BZxM.default
}))((0, $1DrFO.default));

});
parcelRegister("7CwOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $391d7d0ab8daaa90$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $391d7d0ab8daaa90$var$isEmpty = (s)=>s === undefined || s === null || s === '';
const $391d7d0ab8daaa90$var$getDisplayName = (x)=>{
    // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    if (!$391d7d0ab8daaa90$var$isEmpty(x.displayName)) return x.displayName;
    if (!$391d7d0ab8daaa90$var$isEmpty(x.name)) return x.name;
    return 'Component';
};
const $391d7d0ab8daaa90$export$19c55c6cefb3b57 = (defaults)=>(Component)=>{
        const displayName = $391d7d0ab8daaa90$var$getDisplayName(Component);
        // @ts-expect-error - TS2698 - Spread types may only be created from object types. | TS2698 - Spread types may only be created from object types.
        const WithProps = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...defaults,
                ...props
            });
        WithProps.displayName = `WithProps(${displayName})`;
        // @ts-expect-error - TS2322 - Type '{ (props: Partial<A> & B): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<Partial<A> & B, unknown>'.
        return WithProps;
    };
var $391d7d0ab8daaa90$export$2e2bcd8739ae039 = $391d7d0ab8daaa90$export$19c55c6cefb3b57;

});

parcelRegister("bv1G0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4a1b4bcafdd4f91$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $dJl1T = parcelRequire("dJl1T");

var $7CwOv = parcelRequire("7CwOv");

var $1ADgn = parcelRequire("1ADgn");

var $eOezh = parcelRequire("eOezh");
const $c4a1b4bcafdd4f91$var$showCreateBoardDialog = ()=>(0, $1ADgn.default)().catch((error)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('directories.boards-v2.create-button.create-dialog-loader', error ? error.message : '', error));
var $c4a1b4bcafdd4f91$export$2e2bcd8739ae039 = (0, $7CwOv.default)({
    showCreateBoardDialog: $c4a1b4bcafdd4f91$var$showCreateBoardDialog
})((0, $eOezh.default));

});
parcelRegister("eOezh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e10a61d0e4a86dd3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
class $e10a61d0e4a86dd3$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    setLoadingState(isLoading) {
        this.setState({
            isLoading: isLoading
        });
    }
    render() {
        const { children: children } = this.props;
        const { isLoading: isLoading } = this.state;
        return children(this.load, isLoading);
    }
    constructor(...args){
        super(...args), this.state = {
            isLoading: false
        }, this.onCreateBoardDialogLoaded = ()=>this.setLoadingState(false), // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.load = ()=>{
            if (this.state.isLoading) return;
            this.setLoadingState(true);
            const { showCreateBoardDialog: showCreateBoardDialog } = this.props;
            showCreateBoardDialog().finally(this.onCreateBoardDialogLoaded);
        };
    }
}

});


parcelRegister("8BZxM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9e1265becead087$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $basmW = parcelRequire("basmW");

var $iQv12 = parcelRequire("iQv12");

var $az4zD = parcelRequire("az4zD");

var $bP1SJ = parcelRequire("bP1SJ");
var $e9e1265becead087$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: 'createBoard'
}), (0, $az4zD.injectIntlV2))((0, $bP1SJ.default));

});
parcelRegister("bP1SJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $995da68ee148ac4f$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $b0K5t = parcelRequire("b0K5t");
const $995da68ee148ac4f$var$StatelessButton = (props)=>{
    const { intl: { formatMessage: formatMessage }, onClick: onClick, isDisabled: isDisabled, withSpinner: withSpinner } = props;
    const showSpinner = withSpinner && isDisabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($995da68ee148ac4f$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onClick,
        appearance: "primary" // @ts-expect-error - TS2322 - Type '{ children: string; onClick: () => void; appearance: "primary"; externalId: string; isDisabled: boolean; isLoading: boolean; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
        ,
        externalId: "directory.boards-v2.create-button.stateless-button",
        isDisabled: isDisabled,
        isLoading: showSpinner
    }, formatMessage((0, $b0K5t.default).createBoard)));
};
$995da68ee148ac4f$var$StatelessButton.defaultProps = {
    withSpinner: true
};
var $995da68ee148ac4f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $995da68ee148ac4f$var$StatelessButton;
const $995da68ee148ac4f$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b0K5t", function(module, exports) {

$parcel$export(module.exports, "default", () => $1594881d89447897$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1594881d89447897$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createBoard: {
        "id": "directories.boards-v2.create-button.stateless-button.create-board",
        "defaultMessage": "Create board"
    }
});

});



parcelRegister("1DrFO", function(module, exports) {

$parcel$export(module.exports, "default", () => $10c803540fed3c32$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $mX4CK = parcelRequire("mX4CK");

var $aCcLY = parcelRequire("aCcLY");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$10c803540fed3c32$export$2e2bcd8739ae039 = (props)=>{
    const { intl: { formatMessage: formatMessage }, CreateDialogLoader: CreateDialogLoader, CreateButton: CreateButton } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CreateDialogLoader, null, (load, isLoading)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($mX4CK))),
            header: formatMessage((0, $aCcLY.default).header),
            description: formatMessage((0, $aCcLY.default).description),
            isLoading: isLoading,
            primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CreateButton, {
                onClick: load,
                isDisabled: isLoading,
                withSpinner: false
            })
        }));
};

});
parcelRegister("mX4CK", function(module, exports) {
module.exports = new URL("board.a55a3491.svg", import.meta.url).toString();

});

parcelRegister("aCcLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $64993aeedaf0b6ca$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $64993aeedaf0b6ca$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "directories.boards-v2.main.content.empty.header",
        "defaultMessage": "You don't have any boards, yet"
    },
    description: {
        "id": "directories.boards-v2.main.content.empty.description",
        "defaultMessage": "Create a board to start tracking your work."
    }
});

});



parcelRegister("lReEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe94c2a46c5756fb$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $3ZRYH = parcelRequire("3ZRYH");

var $3R8wU = parcelRequire("3R8wU");
const $fe94c2a46c5756fb$var$mapStateToProps = (state)=>({
        isLoading: (0, $3ZRYH.isLoading)(state)
    });
var $fe94c2a46c5756fb$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($fe94c2a46c5756fb$var$mapStateToProps, {})((0, $3R8wU.default));

});
parcelRegister("3R8wU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9273945f68669beb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eae50 = parcelRequire("eae50");

var $koVbs = parcelRequire("koVbs");

var $eIead = parcelRequire("eIead");
function $9273945f68669beb$var$Error(props) {
    const { isLoading: isLoading, onRetry: onRetry } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eae50.default), {
        header: formatMessage((0, $eIead.default).header),
        description: formatMessage((0, $eIead.default).description),
        isLoading: isLoading,
        onRetry: onRetry
    });
}
$9273945f68669beb$var$Error.defaultProps = {
    isLoading: false
};
var $9273945f68669beb$export$2e2bcd8739ae039 = $9273945f68669beb$var$Error;

});
parcelRegister("eae50", function(module, exports) {

$parcel$export(module.exports, "default", () => $da809c0c454ce05f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $lB1Xg = parcelRequire("lB1Xg");

var $9Le4I = parcelRequire("9Le4I");

var $63TJV = parcelRequire("63TJV");
function $da809c0c454ce05f$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage, headingLevel: headingLevel } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($lB1Xg))) : (0, (/*@__PURE__*/$parcel$interopDefault($9Le4I)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        testId: "common-components-error-state.empty-state",
        size: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: (0, $4R6GH.fg)('blu-4174-enghealth-13917-filters-dir-actions-title') ? headingLevel : undefined
    });
}
$da809c0c454ce05f$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $63TJV.default).retry
};
var $da809c0c454ce05f$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($da809c0c454ce05f$export$edf27be85e5f6da0);

});
parcelRegister("lB1Xg", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("9Le4I", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("63TJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbeb04399739f055$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cbeb04399739f055$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("eIead", function(module, exports) {

$parcel$export(module.exports, "default", () => $602e911e55518cea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $602e911e55518cea$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "directories.boards-v2.main.content.error.header",
        "defaultMessage": "We couldn't load your boards"
    },
    description: {
        "id": "directories.boards-v2.main.content.error.description",
        "defaultMessage": "Give it another try. If you run into more trouble, contact your admin for help."
    }
});

});



parcelRegister("lhBHc", function(module, exports) {

$parcel$export(module.exports, "default", () => $365f85ffbbe3f0c8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $iQv12 = parcelRequire("iQv12");

var $5JMh5 = parcelRequire("5JMh5");

var $fs8YG = parcelRequire("fs8YG");

var $bC2fB = parcelRequire("bC2fB");

var $4R6GH = parcelRequire("4R6GH");


var $jT5vh = parcelRequire("jT5vh");

var $c3ulr = parcelRequire("c3ulr");

var $6bVKc = parcelRequire("6bVKc");
const $365f85ffbbe3f0c8$var$FilterSearchWithAnalytics = (0, $iQv12.default)({
    onChange: 'filterSearch'
})((0, $5JMh5.default));
const $365f85ffbbe3f0c8$var$ProjectTypePickerWithAnalytics = (0, $iQv12.default)({
    onChange: 'projectSearch'
})((0, $fs8YG.default));
const $365f85ffbbe3f0c8$var$renderFilterSearch = (state)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($365f85ffbbe3f0c8$var$FilterSearchWithAnalytics, {
            ...props,
            value: (0, $c3ulr.getSearchText)(state)
        });
const $365f85ffbbe3f0c8$var$renderProjectPicker = (state)=>(props)=>/* @ts-expect-error - Type '{ selectedProject: Project | undefined; baseUrl: string; inputId: string; label?: string | undefined; width?: string | undefined; isDisabled?: boolean | undefined; placeholder?: string | undefined; ... 6 more ...; onChange: (arg1: Project, arg2: UIAnalyticsEvent) => void; }' is not assignable to type 'Omit<{ onChange: (arg1: Project | undefined, args_1: UIAnalyticsEvent) => void; baseUrl: string; placeholder?: string | undefined; selectedProject: Project | undefined; ... 10 more ...; forwardedRef?: Ref<...> | undefined; }, keyof WithAnalyticsEventsProps>'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($365f85ffbbe3f0c8$var$ProjectTypePickerWithAnalytics, {
            ...props,
            selectedProject: (0, $c3ulr.getSelectedProject)(state),
            baseUrl: (0, $jT5vh.getBaseUrl)(state),
            inputId: "board-filters-project-picker-select",
            width: (0, $4R6GH.fg)('blu-6146-responsive-directories') ? '100%' : `${0, $3ab203d2ecb98f35$export$a4477e829bcd1e02}px`
        });
const $365f85ffbbe3f0c8$var$mapStateToPropsFactory = ()=>{
    const renderFilterSearchFactory = (0, $8QpSo.default)($365f85ffbbe3f0c8$var$renderFilterSearch);
    const renderProjectPickerFactory = (0, $8QpSo.default)($365f85ffbbe3f0c8$var$renderProjectPicker);
    return (state, ownProps)=>({
            value: (0, $c3ulr.getFilter)(state),
            onChange: ownProps.onFilter,
            renderFilterSearch: renderFilterSearchFactory(state),
            renderProjectPicker: renderProjectPickerFactory(state)
        });
};
var $365f85ffbbe3f0c8$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($365f85ffbbe3f0c8$var$mapStateToPropsFactory, {})((0, $6bVKc.default));

});
parcelRegister("5JMh5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6c98eab5c64edc$export$2e2bcd8739ae039);

var $8oe80 = parcelRequire("8oe80");

var $3as6V = parcelRequire("3as6V");
var $1c6c98eab5c64edc$export$2e2bcd8739ae039 = (0, $8oe80.default)('filterSearch', {
    onChange: 'changed'
})((0, $3as6V.default));

});
parcelRegister("3as6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $466d610aa4e058b2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $2xSAL = parcelRequire("2xSAL");

var $dCm1o = parcelRequire("dCm1o");
const $466d610aa4e058b2$export$4c4c11a6ab1f5b09 = 1000;
const $466d610aa4e058b2$var$debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((value, callback)=>callback(value), $466d610aa4e058b2$export$4c4c11a6ab1f5b09);
// eslint-disable-next-line jira/react/no-class-components
class $466d610aa4e058b2$var$Filter extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            value: '',
            placeholder: '',
            describedById: '',
            hasAutoFocus: false,
            isCompact: true,
            increasedWidth: false,
            placeholderAlwaysVisible: false
        };
    }
    getSearchValue(value) {
        const searchValue = value === this.prevSearchValue ? this.prevQueryValue : value;
        if (value !== this.prevSearchValue) {
            this.prevSearchValue = value;
            this.prevQueryValue = value;
        }
        return searchValue;
    }
    render() {
        const searchValue = this.getSearchValue(this.props.value);
        const { hasAutoFocus: autoFocus, ariaLabelText: ariaLabelText, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
            ...props,
            autoFocus: autoFocus,
            value: searchValue,
            onChange: this.handleOnChange,
            onEnter: this.handleNewValue,
            ariaLabelText: ariaLabelText,
            showIconBeforeInput: (0, $dCm1o.isVisualRefreshEnabled)()
        });
    }
    constructor(...args){
        super(...args), this.prevQueryValue = this.props.value, this.prevSearchValue = this.props.value, this.handleNewValue = (newValue)=>{
            $466d610aa4e058b2$var$debouncedSearch.cancel();
            if (newValue !== this.props.value) this.props.onChange(newValue);
        }, this.handleOnChange = (newValue)=>{
            this.prevQueryValue = newValue;
            newValue === '' ? this.handleNewValue(newValue) : $466d610aa4e058b2$var$debouncedSearch(newValue, this.handleNewValue);
        };
    }
}
var $466d610aa4e058b2$export$2e2bcd8739ae039 = $466d610aa4e058b2$var$Filter;

});


parcelRegister("fs8YG", function(module, exports) {

$parcel$export(module.exports, "default", () => $90f47b7198869b8c$export$2e2bcd8739ae039);

var $8oe80 = parcelRequire("8oe80");

var $59ECx = parcelRequire("59ECx");
var $90f47b7198869b8c$export$2e2bcd8739ae039 = (0, $8oe80.default)('ProjectPicker', {
    onChange: 'changed'
})((0, $59ECx.default));

});
parcelRegister("59ECx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af03db95f8cb63b$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $4USKh = parcelRequire("4USKh");

var $6s1PB = parcelRequire("6s1PB");

var $az4zD = parcelRequire("az4zD");

var $5gPNV = parcelRequire("5gPNV");

var $2oK1T = parcelRequire("2oK1T");
class $1af03db95f8cb63b$export$a4519235a2ef9605 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isCompact: false,
            detailed: false,
            width: '200px',
            requireBrowsePermission: false,
            label: undefined,
            inputId: undefined,
            projectType: undefined
        };
    }
    constructor(props){
        super(props), this.state = {
            selectedProject: this.props.selectedProject,
            projects: [],
            prevSelectedProject: this.props.selectedProject
        }, this.onSelected = (selectedOption)=>{
            this.setState({
                selectedProject: selectedOption
            });
            this.props.onChange(selectedOption);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (project)=>{
            const { avatarUrl: avatarUrl, name: name } = project;
            const avatar = this.props.renderAvatar && (0, $6s1PB.expVal)('jpd_create_idea_template_experiment', 'ideaCreateFormExperimentEnabled', false) ? this.props.renderAvatar(avatarUrl) : avatarUrl;
            return {
                avatar: avatar,
                label: name
            };
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchOptions = async (filter)=>{
            const projects = await (0, $5gPNV.requestProjects)(this.props.baseUrl, filter, {
                detailed: this.props.detailed,
                requireBrowsePermission: this.props.requireBrowsePermission,
                projectType: this.props.projectType
            });
            this.setState({
                projects: projects
            });
            return projects;
        };
        this.projectPickerId = `project-picker.label.id-${(0, $7Jxgt.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentProjectId = props.selectedProject && props.selectedProject.value;
        const prevProjectId = state.prevSelectedProject && state.prevSelectedProject.value;
        if (currentProjectId !== prevProjectId) return {
            ...state,
            selectedProject: props.selectedProject,
            prevSelectedProject: props.selectedProject
        };
        return null;
    }
    componentDidMount() {
        const { selectedProject: selectedProject } = this.state;
        if (selectedProject && !selectedProject.name) this.fetchProject(selectedProject);
    }
    componentDidUpdate() {
        const { selectedProject: selectedProject } = this.state;
        if (selectedProject && !selectedProject.name) this.fetchProject(selectedProject);
    }
    fetchProject(selectedProject) {
        const { baseUrl: baseUrl } = this.props;
        const projectValue = selectedProject.value;
        // @ts-expect-error - TS7006 - Parameter 'newProject' implicitly has an 'any' type.
        const updateSelectedProject = (newProject)=>{
            const currentProject = this.state.selectedProject;
            const currentProjectValue = currentProject && currentProject.value;
            // Update the state only in case the project wasn't changed
            if (currentProjectValue === projectValue) {
                this.setState({
                    selectedProject: newProject
                });
                this.props.onChange(newProject);
            }
        };
        return (0, $5gPNV.requestProject)(baseUrl, projectValue).then((project)=>updateSelectedProject(project)).catch(()=>updateSelectedProject(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, baseUrl: baseUrl, selectedProject: selectedProject, onChange: onChange, ...props } = this.props;
        const { selectedProject: project, projects: projects } = this.state;
        // the selected option needs to have same object reference to be correctly announced by screen readers
        const selectedOptionWithObjectReference = projects?.find((projectInList)=>projectInList.value === project?.value);
        const selectedOption = selectedOptionWithObjectReference || (project && project.name ? project : null);
        return(// @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4USKh.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $2oK1T.default).labelText) : undefined,
            ...props,
            inputId: !this.props.inputId ? this.projectPickerId : this.props.inputId,
            errorMessage: formatMessage((0, $2oK1T.default).error),
            placeholder: this.props.placeholder || formatMessage((0, $2oK1T.default).placeholder),
            onSelected: this.onSelected,
            options: this.fetchOptions,
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: selectedOption,
            showFocusedAvatar: true
        }));
    }
}
var $1af03db95f8cb63b$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($1af03db95f8cb63b$export$a4519235a2ef9605);

});
parcelRegister("4USKh", function(module, exports) {

$parcel$export(module.exports, "PickerWithAvatar", () => $63c33924209c0872$export$e6b8a87858f7afd1);
$parcel$export(module.exports, "PickerWithAvatarAndAnalytics", () => $63c33924209c0872$export$3d409af828769e2e);
/**
 * This is the base for Picker that can be used to create any type of component:
 * 1) with a list of predefined options
 * 2) that dynamically fetches its options from external resource.
 */ 
var $8oe80 = parcelRequire("8oe80");

var $4U4qk = parcelRequire("4U4qk");

var $9M5Oz = parcelRequire("9M5Oz");
const $63c33924209c0872$export$e6b8a87858f7afd1 = (0, $9M5Oz.default);
const $63c33924209c0872$export$3d409af828769e2e = (0, $8oe80.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $9M5Oz.default));
const $63c33924209c0872$export$d8d9f25d80d89b16 = (0, $8oe80.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $4U4qk.default));

});
parcelRegister("4U4qk", function(module, exports) {

$parcel$export(module.exports, "getOptionBaseStyles", () => $0d1a93ba35d548ba$export$cef6e25059b681a);
$parcel$export(module.exports, "Picker", () => $0d1a93ba35d548ba$export$ba25329847403e11);
$parcel$export(module.exports, "default", () => $0d1a93ba35d548ba$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $ctg8C = parcelRequire("ctg8C");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1ZftP = parcelRequire("1ZftP");
var $94bNw = parcelRequire("94bNw");
var $bChGW = parcelRequire("bChGW");
var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");


var $3bDjY = parcelRequire("3bDjY");

var $VgvL1 = parcelRequire("VgvL1");

var $fVAPR = parcelRequire("fVAPR");

var $gwIPs = parcelRequire("gwIPs");

var $az4zD = parcelRequire("az4zD");

var $e239o = parcelRequire("e239o");
const $0d1a93ba35d548ba$export$3a3072dd741f354b = 500;
const $0d1a93ba35d548ba$export$cef6e25059b681a = (optionState)=>({
        ...optionState.isDisabled ? {
            cursor: 'not-allowed',
            color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N90})`,
            '&, :active': {
                backgroundColor: 'transparent'
            }
        } : {
            cursor: 'pointer'
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
class $0d1a93ba35d548ba$export$ba25329847403e11 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: false,
            isCompact: false,
            isCreatable: false,
            isMulti: false,
            noPortal: false,
            isCheckbox: false,
            label: '',
            defaultValue: undefined,
            width: 'auto',
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onMultiSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    static getDerivedStateFromProps(props) {
        if (props.menuIsOpen !== undefined) return {
            menuIsOpen: props.menuIsOpen
        };
        return null;
    }
    constructor(props){
        super(props), this.state = {
            validationState: 'default',
            showErrorMessage: false,
            menuWasOpen: false,
            menuIsOpen: false,
            initialFocusHandled: false
        }, this.onSelected = (selection, action, analyticsEvent)=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
            const { isMulti: isMulti } = this.props;
            if (Array.isArray(selection)) {
                if (isMulti) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                this.props.onMultiSelected(selection, analyticsEvent);
                else // When the selection is cleared in single select mode, selection is an array.
                this.props.onSelected(undefined, analyticsEvent);
            } else // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'SelectOption'.
            selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
        }, this.onMenuOpen = ()=>{
            this.setState(()=>({
                    menuIsOpen: true,
                    menuWasOpen: true
                }));
        }, this.onMenuClose = ()=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
        }, this.onBlur = (event)=>{
            this.hideErrorMessage();
            const { onBlur: onBlur } = this.props;
            if (onBlur && typeof onBlur === 'function') onBlur(event);
        }, this.onFocus = (event)=>{
            this.showErrorMessage();
            const { onFocus: onFocus } = this.props;
            if (onFocus && typeof onFocus === 'function') onFocus(event);
        }, this.setErrorState = ()=>{
            this.setState({
                showErrorMessage: true,
                validationState: 'error'
            });
        }, this.showErrorMessage = ()=>this.setState({
                showErrorMessage: true
            }), this.hideErrorMessage = ()=>this.setState({
                showErrorMessage: false
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.loadOptions = (filter, callback)=>{
            this.setState({
                validationState: 'default'
            });
            this.debouncedLoadOptions(filter, callback);
        }, this.renderOption = (props)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const propsData = props.data;
            const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                position: "right",
                content: disableReason
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , props));
        }, this.renderMenuList = (menuListProps)=>{
            const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
            return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; hasValue: boolean; clearValue: () => void; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': cx, getStyles, getValue, isMulti, and 6 more.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, menuListProps, isClearable && menuListProps.hasValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $0d1a93ba35d548ba$var$clearButtonWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                shouldFitContainer: true,
                onClick: menuListProps.clearValue
            }, formatMessage((0, $e239o.default).clearSelected))), menuListProps.children));
        }, this.renderValueContainer = (props)=>{
            const { onValueContainerClick: onValueContainerClick } = props.selectProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$StyledValueContainer, {
                "data-testid": "common-components-picker.base.react-dnd-and-select-focus-bug-fix",
                onClick: onValueContainerClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).ValueContainer, props));
        }; // This is initialized in constructor because when it is a class property then flow gets confused about the generic type in callback.
        // That is a known bug: https://github.com/facebook/flow/issues/6978
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter, callback)=>{
            // @ts-expect-error - TS2349 - This expression is not callable.
            this.props.options(filter).then(callback, ()=>{
                callback([]);
                this.setErrorState();
            });
        }, $0d1a93ba35d548ba$export$3a3072dd741f354b); // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
        this.selectRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
    }
    getSelectComponent(isAsync) {
        if (this.props.isCreatable) return isAsync ? (0, $1ZftP.default) : (0, $iOwNT.default);
        if (isAsync) return 0, $VgvL1.AsyncSelectWithAnalytics;
        return this.props.isCheckbox ? (0, $94bNw.default) : (0, $7K5PP.default);
    }
    getComponentOverrides() {
        const { menuWasOpen: menuWasOpen } = this.state;
        const Option = {
            Option: this.renderOption
        };
        const MenuList = {
            MenuList: this.renderMenuList
        };
        const LoadingIndicator = menuWasOpen ? {} : {
            LoadingIndicator: null
        };
        return {
            ...Option,
            ...MenuList,
            ...LoadingIndicator
        };
    }
    render() {
        const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, $e239o.default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
        const isAsync = typeof options === 'function';
        const SelectComponent = this.getSelectComponent(isAsync);
        const isErrorMessageOpened = showErrorMessage && validationState === 'error';
        let selectParams = {
            placeholder: placeholder,
            isDisabled: isDisabled,
            isClearable: isClearableWithCrossIcon || false,
            defaultValue: defaultValue,
            defaultOptions: true,
            autoFocus: !!this.props.autoFocus,
            loadOptions: isAsync && this.loadOptions,
            options: !isAsync && options,
            onChange: this.onSelected,
            noOptionsMessage: ()=>formatMessage((0, $e239o.default).noOptions),
            loadingMessage: ()=>formatMessage((0, $e239o.default).loading),
            validationState: this.state.validationState,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            menuPortalTarget: noPortal ? null : document.body,
            spacing: isCompact ? 'compact' : 'default',
            styles: {
                // without properly set zIndex value dropdown with options is cut inside modal dialogs
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $gwIPs.layers).modal
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                container: (base)=>({
                        ...base,
                        width: width,
                        minWidth: minWidth
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                option: (base, optionState)=>({
                        ...base,
                        ...$0d1a93ba35d548ba$export$cef6e25059b681a(optionState),
                        ...listItemCustomStyles
                    })
            }
        };
        if (!isCheckbox) selectParams = {
            ...selectParams,
            menuIsOpen: // @ts-expect-error - TS2322 - Type '{ menuIsOpen: boolean; onMenuOpen: () => void; onMenuClose: () => void; components: { LoadingIndicator?: undefined; MenuList: (menuListProps: MenuListProps) => JSX.Element; Option: (props: CommonProps<...> & ... 1 more ... & { ...; }) => JSX.Element; } | { ...; }; ... 16 more ...; styles: { ...; }; }' is not assignable to type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'.
            menuIsOpen,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            components: this.getComponentOverrides()
        };
         // When "hasDraggableParentComponent" is true, this means <Select /> is nested inside <Draggable /> from react-beautiful-dnd
        // This relationship prevents the dropdown menu from opening because of bugs in the default focus state and clicking in a particular area of <Select />
        // Context: https://hello.atlassian.net/wiki/spaces/~989411314/pages/2861097485/Investigation+Notes+for+atlaskit+select+react-beautiful-dnd#Temporary-Solution
        if (hasDraggableParentComponent) {
            const { initialFocusHandled: initialFocusHandled } = this.state;
            const handleClick = ()=>{
                if (initialFocusHandled) // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                this.setState((state)=>({
                        menuIsOpen: !state.menuIsOpen
                    }));
                else if (!menuIsOpen) {
                    // Trigger focus state when ValueContainer is clicked for the first time
                    // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                    // to manage the state of the dropdown menu
                    // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                    this.selectRef.current.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            selectParams = {
                ...selectParams,
                // @ts-expect-error - Object literal may only specify known properties, and 'ref' does not exist in type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'
                // + Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                ref: this.selectRef,
                components: {
                    ...this.getComponentOverrides,
                    ValueContainer: this.renderValueContainer
                },
                onValueContainerClick: handleClick,
                openMenuOnFocus: true
            };
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVAPR.FieldLabel), {
            htmlFor: this.props.inputId,
            label: label,
            isRequired: isRequired
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), {
            content: errorMessage,
            isOpen: isErrorMessageOpened,
            placement: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
            inputId: this.props.inputId,
            ...this.props,
            ...selectParams,
            options: isAsync ? undefined : this.props.options
        })));
    }
}
const $0d1a93ba35d548ba$var$PickerWithIntl = (0, $az4zD.injectIntlV2)($0d1a93ba35d548ba$export$ba25329847403e11);
const $0d1a93ba35d548ba$var$DefaultPicker = (props)=>{
    // this function exists only to "preserve" generic on the Picker that is lost at injectIntl
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$PickerWithIntl, props);
};
$0d1a93ba35d548ba$var$DefaultPicker.defaultProps = $0d1a93ba35d548ba$export$ba25329847403e11.defaultProps;
var $0d1a93ba35d548ba$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $0d1a93ba35d548ba$var$DefaultPicker;
const $0d1a93ba35d548ba$var$StyledValueContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $0d1a93ba35d548ba$var$clearButtonWrapperStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    borderBottom: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N40})`}`
});

});
parcelRegister("1ZftP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffe39b95a8bd43db$export$2e2bcd8739ae039);

var $isgat = parcelRequire("isgat");

var $3c98u = parcelRequire("3c98u");
const $ffe39b95a8bd43db$var$AsyncCreatableSelect = (0, $3c98u.default)((0, $isgat.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ffe39b95a8bd43db$export$2e2bcd8739ae039 = $ffe39b95a8bd43db$var$AsyncCreatableSelect;

});
parcelRegister("isgat", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6ce0d05b9e97e68$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $iaInK = parcelRequire("iaInK");

var $2HH7Y = parcelRequire("2HH7Y");

var $9uJ4X = parcelRequire("9uJ4X");
const $d6ce0d05b9e97e68$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $iaInK.default)(props);
    const creatableProps = (0, $9uJ4X.default)(stateManagerProps);
    const selectProps = (0, $2HH7Y.default)(creatableProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d6ce0d05b9e97e68$export$2e2bcd8739ae039 = $d6ce0d05b9e97e68$var$AsyncCreatableSelect;

});


parcelRegister("94bNw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf832c571222d72$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $itpgN = parcelRequire("itpgN");
const $ebf832c571222d72$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $5uXOq.useMemo)(()=>({
            ...components,
            Option: (0, $itpgN.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $ebf832c571222d72$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($ebf832c571222d72$var$CheckboxSelectInternal);
var $ebf832c571222d72$export$2e2bcd8739ae039 = $ebf832c571222d72$var$CheckboxSelect;

});

parcelRegister("VgvL1", function(module, exports) {

$parcel$export(module.exports, "AsyncSelectWithAnalytics", () => $462c399840da3e1c$export$ee664e5add893f9);

var $d7FF4 = parcelRequire("d7FF4");

var $8oe80 = parcelRequire("8oe80");
const $462c399840da3e1c$export$ee664e5add893f9 = (0, $8oe80.default)('select', {
    onChange: 'changed'
})((0, $d7FF4.default));

});

parcelRegister("fVAPR", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $97462970d1593b07$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");
const $97462970d1593b07$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1wmz _1e0c1ule _ca0qv47k _u5f3idpf _n3td1b66 _19bvidpf _ect41sbm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "presentation",
        className: (0, $bwpsq.default)([
            "_syaz1ick _19bvv77o _ect41sbm"
        ])
    }, "*") : null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97462970d1593b07$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $97462970d1593b07$var$labelStyle = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $97462970d1593b07$var$requiredIndicatorStyle = null;

});

parcelRegister("e239o", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6849afedcc0fa8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1c6849afedcc0fa8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noOptions: {
        "id": "common.components.picker.base.no-options",
        "defaultMessage": "No results"
    },
    loading: {
        "id": "common.components.picker.base.loading",
        "defaultMessage": "Searching..."
    },
    defaultPlaceholder: {
        "id": "common.components.picker.base.default-placeholder",
        "defaultMessage": "Select..."
    },
    clearSelected: {
        "id": "common.components.picker.base.clear-selected",
        "defaultMessage": "Clear selected"
    }
});

});


parcelRegister("9M5Oz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae2cb265c5b0a53f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $4U4qk = parcelRequire("4U4qk");
class $ae2cb265c5b0a53f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            showFocusedAvatar: false
        };
    }
    render() {
        const { formatOptionDataTransformer: formatOptionDataTransformer, showFocusedAvatar: showFocusedAvatar, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4U4qk.default), {
            ...props,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            formatOptionLabel: this.renderOption
        });
    }
    constructor(...args){
        super(...args), this.state = {
            canShowAvatar: true
        }, this.onBlur = (event)=>{
            this.setState(()=>({
                    canShowAvatar: true
                }));
            this.props.onBlur && this.props.onBlur(event);
        }, this.onFocus = (event)=>{
            if (!this.props.showFocusedAvatar) this.setState(()=>({
                    canShowAvatar: false
                }));
            this.props.onFocus && this.props.onFocus(event);
        }, this.renderOption = (option, { context: context // eslint-disable-next-line @typescript-eslint/no-explicit-any
         })=>{
            const { avatar: avatar, label: label } = this.props.formatOptionDataTransformer(option);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae2cb265c5b0a53f$var$OptionWrapper, null, typeof avatar !== 'undefined' && (context !== 'value' || this.state.canShowAvatar) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae2cb265c5b0a53f$var$AvatarWrapper, null, typeof avatar === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                src: avatar,
                size: "xsmall"
            }) : avatar) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae2cb265c5b0a53f$var$LabelWrapper, null, label));
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ae2cb265c5b0a53f$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ae2cb265c5b0a53f$var$AvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc _vwz4kb7n",
            __cmplp.className
        ])
    });
});
const $ae2cb265c5b0a53f$var$LabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("5gPNV", function(module, exports) {

$parcel$export(module.exports, "requestProjects", () => $cc6820a29e56f420$export$fd47004f2da106d6);
$parcel$export(module.exports, "requestProject", () => $cc6820a29e56f420$export$5fc96122a11240fa);

var $4SXEu = parcelRequire("4SXEu");

var $9V0kk = parcelRequire("9V0kk");
const $cc6820a29e56f420$export$fd47004f2da106d6 = (baseUrl, filter, { detailed: detailed, requireBrowsePermission: requireBrowsePermission, maxResults: maxResults, projectType: projectType })=>(0, $4SXEu.getProjects)(baseUrl, filter, detailed, requireBrowsePermission, maxResults, projectType).then((0, $9V0kk.transformProjects));
const $cc6820a29e56f420$export$5fc96122a11240fa = (baseUrl, projectId)=>(0, $4SXEu.getProject)(baseUrl, projectId).then((0, $9V0kk.transformProject));

});
parcelRegister("4SXEu", function(module, exports) {

$parcel$export(module.exports, "getProjects", () => $7b7f1e9303cf186f$export$b00a271f69f3d728);
$parcel$export(module.exports, "getProject", () => $7b7f1e9303cf186f$export$637b60a42bb03f06);

var $7f4tk = parcelRequire("7f4tk");
const $7b7f1e9303cf186f$var$MAX_PROJECTS = 5;
const $7b7f1e9303cf186f$var$VALID_PROJECT_TYPES = [
    'business',
    'service_desk',
    'software'
];
const $7b7f1e9303cf186f$export$897983d170945c20 = (baseUrl)=>`${baseUrl}/rest/api/2/project/search`;
const $7b7f1e9303cf186f$export$40e632ede9793c84 = (baseUrl)=>`${baseUrl}/rest/api/2/project`;
const $7b7f1e9303cf186f$export$3675f59ca23820db = (baseUrl, filter, detailed, requireBrowsePermission, maxResults = $7b7f1e9303cf186f$var$MAX_PROJECTS, projectType = '')=>{
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('orderBy', 'NAME');
    urlSearchParams.set('startAt', '0');
    urlSearchParams.set('query', filter);
    urlSearchParams.set('maxResults', maxResults.toString());
    if (detailed) urlSearchParams.set('expand', 'lead,issueTypes');
    if (requireBrowsePermission) urlSearchParams.set('action', 'browse');
    if ($7b7f1e9303cf186f$var$VALID_PROJECT_TYPES.includes(projectType)) urlSearchParams.set('typeKey', projectType);
    const urlParams = `?${urlSearchParams.toString()}`;
    return `${$7b7f1e9303cf186f$export$897983d170945c20(baseUrl)}${urlParams}`;
};
const $7b7f1e9303cf186f$export$42f2db4bad372151 = (baseUrl, projectId)=>`${$7b7f1e9303cf186f$export$40e632ede9793c84(baseUrl)}/${encodeURIComponent(projectId)}`;
const $7b7f1e9303cf186f$export$b00a271f69f3d728 = (baseUrl, filter = '', detailed = false, requireBrowsePermission = false, maxResults = $7b7f1e9303cf186f$var$MAX_PROJECTS, projectType = '')=>(0, $7f4tk.default)($7b7f1e9303cf186f$export$3675f59ca23820db(baseUrl, filter, detailed, requireBrowsePermission, maxResults, projectType));
const $7b7f1e9303cf186f$export$637b60a42bb03f06 = (baseUrl, projectId = '')=>(0, $7f4tk.default)($7b7f1e9303cf186f$export$42f2db4bad372151(baseUrl, projectId));

});

parcelRegister("9V0kk", function(module, exports) {

$parcel$export(module.exports, "transformProject", () => $6541540d335a62b4$export$e179869ce707f546);
$parcel$export(module.exports, "transformProjects", () => $6541540d335a62b4$export$227473965d2e27db);
const $6541540d335a62b4$var$transformLead = (leadResponse)=>leadResponse && {
        key: leadResponse.key,
        name: leadResponse.name,
        displayName: leadResponse.displayName,
        avatarUrl: leadResponse.avatarUrls['24x24']
    };
const $6541540d335a62b4$var$transformIssueTypes = (types)=>types.map((t)=>({
            id: t.id,
            name: t.name,
            description: t.description,
            iconUrl: t.iconUrl,
            subtask: t.subtask
        }));
const $6541540d335a62b4$var$transformDetails = (restResponse)=>({
        id: restResponse.id,
        key: restResponse.key,
        lead: $6541540d335a62b4$var$transformLead(restResponse.lead),
        issueTypes: restResponse.issueTypes ? $6541540d335a62b4$var$transformIssueTypes(restResponse.issueTypes) : [],
        projectTypeKey: restResponse.projectTypeKey,
        simplified: restResponse.simplified
    });
const $6541540d335a62b4$export$e179869ce707f546 = (restResponse)=>restResponse && {
        value: restResponse.id,
        name: restResponse.name,
        label: restResponse.name,
        avatarUrl: restResponse.avatarUrls['24x24'],
        details: $6541540d335a62b4$var$transformDetails(restResponse)
    };
const $6541540d335a62b4$export$227473965d2e27db = (restResponse)=>restResponse && restResponse.values && restResponse.values.map($6541540d335a62b4$export$e179869ce707f546);

});


parcelRegister("2oK1T", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a2fad71e32e9ef5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5a2fad71e32e9ef5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "project-picker.error",
        "defaultMessage": "We couldn't retrieve projects"
    },
    placeholder: {
        "id": "project-picker.placeholder",
        "defaultMessage": "Project"
    },
    labelText: {
        "id": "project-picker.label-text",
        "defaultMessage": "Project"
    }
});

});



const $3ab203d2ecb98f35$export$54280d191a58e9f6 = 420;
const $3ab203d2ecb98f35$export$99041d531d62aef9 = 640;
const $3ab203d2ecb98f35$export$9cc428d7e02a0e8b = 850;
const $3ab203d2ecb98f35$export$a4477e829bcd1e02 = 200;

parcelRegister("6bVKc", function(module, exports) {

$parcel$export(module.exports, "default", () => $70b17b2f1f1c1afd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $eneeA = parcelRequire("eneeA");

var $ijnJK = parcelRequire("ijnJK");

var $93ftO = parcelRequire("93ftO");
const $70b17b2f1f1c1afd$var$Filter = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { renderFilterSearch: renderFilterSearch, onChange: onChange, renderProjectPicker: renderProjectPicker, value: value } = props;
    return (0, $4R6GH.fg)('blu-6146-responsive-directories') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eneeA.FilterBar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $70b17b2f1f1c1afd$var$searchWrapperStyles
    }, renderFilterSearch({
        placeholder: formatMessage((0, $93ftO.default).searchPlaceholder),
        value: '',
        hasAutoFocus: false,
        isCompact: true,
        increasedWidth: false,
        placeholderAlwaysVisible: true,
        isAlwaysExpanded: false,
        shouldFitContainerWidth: true,
        onChange: (text, analyticsEvent)=>{
            onChange({
                ...value,
                text: text
            }, analyticsEvent);
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijnJK.FilterItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: !(0, $dCm1o.isVisualRefreshEnabled)() && !(0, $4R6GH.fg)('visual-refresh_drop_2') && $70b17b2f1f1c1afd$var$filterLabelStyles
    }, renderProjectPicker({
        onChange: (project, analyticsEvent)=>{
            onChange({
                ...value,
                project: project
            }, analyticsEvent);
        },
        placeholder: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_2') ? formatMessage((0, $93ftO.default).projectPlaceholder) : formatMessage((0, $93ftO.default).projectPlaceholderOld),
        label: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_2') ? undefined : formatMessage((0, $93ftO.default).projectLabel),
        selectedProject: undefined,
        baseUrl: '',
        isCompact: true
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "end",
        gap: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_3') ? 'space.100' : 'space.200'
    }, renderFilterSearch({
        placeholder: formatMessage((0, $93ftO.default).searchPlaceholder),
        value: '',
        hasAutoFocus: false,
        isCompact: true,
        increasedWidth: false,
        placeholderAlwaysVisible: true,
        isAlwaysExpanded: true,
        onChange: (text, analyticsEvent)=>{
            onChange({
                ...value,
                text: text
            }, analyticsEvent);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $70b17b2f1f1c1afd$var$filterLabelStyles
    }, renderProjectPicker({
        onChange: (project, analyticsEvent)=>{
            onChange({
                ...value,
                project: project
            }, analyticsEvent);
        },
        placeholder: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_2') ? formatMessage((0, $93ftO.default).projectPlaceholder) : formatMessage((0, $93ftO.default).projectPlaceholderOld),
        label: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_2') ? undefined : formatMessage((0, $93ftO.default).projectLabel),
        selectedProject: undefined,
        baseUrl: '',
        isCompact: true
    })));
};
const $70b17b2f1f1c1afd$var$searchWrapperStyles = (0, $8CUq3.xcss)({
    flexBasis: '200px'
});
const $70b17b2f1f1c1afd$var$filterLabelStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.negative.250'
});
var $70b17b2f1f1c1afd$export$2e2bcd8739ae039 = $70b17b2f1f1c1afd$var$Filter;

});
parcelRegister("eneeA", function(module, exports) {

$parcel$export(module.exports, "FilterBar", () => $b95c1e2c9fc07d20$export$56a20ec2552ffba2);

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gJlZe = parcelRequire("gJlZe");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

const $b95c1e2c9fc07d20$export$56a20ec2552ffba2 = ({ children: children })=>{
    const [containerWidth, setContainerWidth] = (0, $5uXOq.useState)(900);
    const handleWidth = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setContainerWidth, 50);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b95c1e2c9fc07d20$var$relativeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJlZe.WidthObserver), {
        setWidth: handleWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $b95c1e2c9fc07d20$var$filterBarSharedStyles,
            (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_3') && $b95c1e2c9fc07d20$var$filterBarSharedStylesVisualRefresh,
            containerWidth > (0, $3ab203d2ecb98f35$export$9cc428d7e02a0e8b) && $b95c1e2c9fc07d20$var$filterBarLargeStyles,
            containerWidth <= (0, $3ab203d2ecb98f35$export$9cc428d7e02a0e8b) && containerWidth > (0, $3ab203d2ecb98f35$export$99041d531d62aef9) && $b95c1e2c9fc07d20$var$filterBarMidStyles,
            containerWidth <= (0, $3ab203d2ecb98f35$export$99041d531d62aef9) && containerWidth > (0, $3ab203d2ecb98f35$export$54280d191a58e9f6) && $b95c1e2c9fc07d20$var$filterBarSmallStyles
        ]
    }, children));
};
const $b95c1e2c9fc07d20$var$relativeWrapperStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});
const $b95c1e2c9fc07d20$var$filterBarSharedStyles = (0, $8CUq3.xcss)({
    width: '100%',
    display: 'grid',
    columnGap: 'space.200',
    rowGap: 'space.100',
    alignItems: 'flex-end'
});
const $b95c1e2c9fc07d20$var$filterBarSharedStylesVisualRefresh = (0, $8CUq3.xcss)({
    columnGap: 'space.100'
});
const $b95c1e2c9fc07d20$var$filterBarSmallStyles = (0, $8CUq3.xcss)({
    gridTemplateColumns: 'repeat(2, 1fr)'
});
const $b95c1e2c9fc07d20$var$filterBarMidStyles = (0, $8CUq3.xcss)({
    gridTemplateColumns: 'repeat(3, 1fr)'
});
const $b95c1e2c9fc07d20$var$filterBarLargeStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexWrap: 'wrap'
});

});

parcelRegister("ijnJK", function(module, exports) {

$parcel$export(module.exports, "FilterItem", () => $82ad612f888d18b7$export$3cf161fcd24b6b4f);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $82ad612f888d18b7$export$3cf161fcd24b6b4f = ({ expandOnSmall: expandOnSmall, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: expandOnSmall ? [
            $82ad612f888d18b7$var$filterItemContainerStyles,
            $82ad612f888d18b7$var$filterItemContainerExpandedStyles
        ] : $82ad612f888d18b7$var$filterItemContainerStyles
    }, children);
};
const $82ad612f888d18b7$var$filterItemContainerStyles = (0, $8CUq3.xcss)({
    // 200px is the width commonly used for directory filters, so including it here helps
    // to ensure consistency with the existing design and gives us predictability for responsive behaviour
    minWidth: '200px'
});
const $82ad612f888d18b7$var$filterItemContainerExpandedStyles = (0, $8CUq3.xcss)({
    gridColumn: '1 / -1'
});

});

parcelRegister("93ftO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cd31b9c0364bd67$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5cd31b9c0364bd67$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    searchPlaceholder: {
        "id": "directories.boards-v2.main.content.filter.search-placeholder",
        "defaultMessage": "Search boards"
    },
    projectPlaceholder: {
        "id": "directories.boards-v2.main.content.filter.project-placeholder",
        "defaultMessage": "Project"
    },
    projectPlaceholderOld: {
        "id": "directories.boards-v2.main.content.filter.project-placeholder-old",
        "defaultMessage": "Select project"
    },
    projectLabel: {
        "id": "directories.boards-v2.main.content.filter.project-label",
        "defaultMessage": "Project"
    }
});

});



parcelRegister("lzmCo", function(module, exports) {

$parcel$export(module.exports, "operationModals", () => $5b04e2ae5c32882b$export$fee8081fa482dfbf);
$parcel$export(module.exports, "emptyFilterResultConfiguration", () => $5b04e2ae5c32882b$export$972f54d0cb76a888);
$parcel$export(module.exports, "getTableConfiguration", () => $5b04e2ae5c32882b$export$6847365bea1c5392);
$parcel$export(module.exports, "getTableLabel", () => $5b04e2ae5c32882b$export$b2d196af18e06ad6);
$parcel$export(module.exports, "getResultsAnnouncerMessage", () => $5b04e2ae5c32882b$export$64df75861e57fb7f);

var $dGvGJ = parcelRequire("dGvGJ");

var $epVKM = parcelRequire("epVKM");


var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $fEtUJ = parcelRequire("fEtUJ");

var $jT5vh = parcelRequire("jT5vh");

var $6mCLy = parcelRequire("6mCLy");

var $8q5Hf = parcelRequire("8q5Hf");

var $81DJu = parcelRequire("81DJu");

var $40ra5 = parcelRequire("40ra5");

var $3LoLX = parcelRequire("3LoLX");

var $iP8IV = parcelRequire("iP8IV");

var $hupmX = parcelRequire("hupmX");

var $iIIlo = parcelRequire("iIIlo");

var $lbxSX = parcelRequire("lbxSX");

var $4G0vG = parcelRequire("4G0vG");
const $5b04e2ae5c32882b$export$fee8081fa482dfbf = {
    [(0, $088bf273559ead46$export$4bd2facc4a3e6aa1)]: (0, $iIIlo.default),
    [(0, $088bf273559ead46$export$92f9e1ed9114d3a6)]: (0, $hupmX.default),
    [(0, $088bf273559ead46$export$346f08c1f0d0fe41)]: (0, $4G0vG.default)
};
const $5b04e2ae5c32882b$export$972f54d0cb76a888 = {
    message: (0, $lbxSX.default).emptyFilterResultMessage
};
const $5b04e2ae5c32882b$export$6847365bea1c5392 = (0, $dGvGJ.createSelector)((0, $jT5vh.getLoggedInUserAccountId), (loggedInUserAccountId)=>[
        loggedInUserAccountId !== null ? {
            title: (0, $epVKM.default),
            Cell: (0, $81DJu.default),
            width: 3
        } : undefined,
        {
            title: (0, $lbxSX.default).name,
            Cell: (0, $iP8IV.default),
            sortField: (0, $fEtUJ.NAME),
            width: loggedInUserAccountId ? 49 : 55
        },
        {
            title: (0, $lbxSX.default).administrators,
            Cell: (0, $8q5Hf.default),
            width: 20
        },
        {
            title: (0, $lbxSX.default).location,
            Cell: loggedInUserAccountId !== null && (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_4') ? (0, $40ra5.default) : (0, $3LoLX.default),
            width: loggedInUserAccountId !== null && (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_4') ? 28 : 25
        },
        // delete this when cleaning up visual-refresh_drop_4 FG
        loggedInUserAccountId !== null && !((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_4')) ? {
            title: (0, $lbxSX.default).actions,
            Cell: (0, $6mCLy.default),
            width: 3,
            dataTestId: 'boards-main.content.headerCell.actions.container'
        } : undefined
    ].filter(Boolean));
const $5b04e2ae5c32882b$export$b2d196af18e06ad6 = ()=>(0, $lbxSX.default).tableAriaLabel;
const $5b04e2ae5c32882b$export$64df75861e57fb7f = ()=>(0, $lbxSX.default).filterResultsAnnouncement;

});
parcelRegister("epVKM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7b567d1c855c884$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dAf5R = parcelRequire("dAf5R");

var $bH1hf = parcelRequire("bH1hf");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $75Uq1 = parcelRequire("75Uq1");
const $f7b567d1c855c884$var$StarTitleCell = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // Remove isVisualRefreshEnabled when fg is removed
    if ((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAf5R))), {
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bH1hf))),
        LEGACY_size: "small",
        label: formatMessage((0, $75Uq1.messages).starred)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bH1hf))), {
        size: "small",
        label: formatMessage((0, $75Uq1.messages).starred)
    });
};
var $f7b567d1c855c884$export$2e2bcd8739ae039 = $f7b567d1c855c884$var$StarTitleCell;

});
parcelRegister("75Uq1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8eb82dc6fef00b40$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8eb82dc6fef00b40$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "directories.common.components.star-title-cell.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("6mCLy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe4eeda225e85791$export$2e2bcd8739ae039);
// delete this entire file when cleaning up visual-refresh_drop_4 FG

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $iQv12 = parcelRequire("iQv12");



var $bC2fB = parcelRequire("bC2fB");

var $3ZRYH = parcelRequire("3ZRYH");

var $3MgL5 = parcelRequire("3MgL5");
const $fe4eeda225e85791$var$mapStateToPropsFactory = ()=>{
    const onDeleteFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$4bd2facc4a3e6aa1)));
    const onCopyFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$92f9e1ed9114d3a6)));
    const onMoveFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$346f08c1f0d0fe41)));
    return (state, ownProps)=>({
            isPrivate: (0, $3ZRYH.isPrivate)(state, ownProps.id),
            editBoardUrl: (0, $3ZRYH.getEditBoardUrl)(state, ownProps.id),
            onDelete: onDeleteFactory(ownProps.onOperationRequested),
            onCopy: onCopyFactory(ownProps.onOperationRequested),
            onMove: onMoveFactory(ownProps.onOperationRequested),
            showSpinner: ownProps.isOperationInProgress,
            isSimple: !(0, $3ZRYH.isPrivate)(state, ownProps.id) && (0, $3ZRYH.getType)(state, ownProps.id) === (0, $8f9d7295a53f46ca$export$aca095bc476d426f),
            canEdit: (0, $3ZRYH.canEdit)(state, ownProps.id)
        });
};
var $fe4eeda225e85791$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onEdit: 'edit',
    onDelete: 'delete',
    onCopy: 'copy',
    onMove: 'move'
}), (0, $bC2fB.connect)($fe4eeda225e85791$var$mapStateToPropsFactory, {}))((0, $3MgL5.default));

});
const $8f9d7295a53f46ca$export$b75edebf0c64f31e = 'scrum';
const $8f9d7295a53f46ca$export$eff0efe8746a33f = 'kanban';
const $8f9d7295a53f46ca$export$aca095bc476d426f = 'simple';

parcelRegister("3MgL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7473d5818f99343a$export$2e2bcd8739ae039);
// delete this entire file when cleaning up visual-refresh_drop_4 FG

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $3oUqw = parcelRequire("3oUqw");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $8oe80 = parcelRequire("8oe80");

var $asoHC = parcelRequire("asoHC");

var $4R6GH = parcelRequire("4R6GH");

var $8RXs9 = parcelRequire("8RXs9");

var $dCm1o = parcelRequire("dCm1o");

var $4J011 = parcelRequire("4J011");
const $7473d5818f99343a$var$DropdownMenuWithAnalytics = (0, $8oe80.default)('dropdownMenu', {
    onOpenChange: 'open'
})((0, $BLPHT.default));
const $7473d5818f99343a$var$DropdownItemWithAnalytics = (0, $8oe80.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $6B7KL.default));
// eslint-disable-next-line jira/react/no-class-components
class $7473d5818f99343a$var$ActionsOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isPrivate: false,
            isSimple: false,
            canEdit: true,
            defaultOpen: false,
            showSpinner: false,
            editBoardUrl: '',
            onEdit: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCopy: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onMove: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    /**
   * Close the menu with a minimal delay so the inner handlers are able to react on keypress properly.
   * In its current implementation if we close the menu right away it won't open the focused `href`.
   * Ideally we have to get right of this and few more methods when the bug linked below is fixed.
   * @see https://ecosystem.atlassian.net/browse/AK-4467
   */ delayedClose() {
        setTimeout(()=>this.setState(()=>({
                    isOpen: false
                })));
    }
    renderSettingsAction() {
        const { intl: { formatMessage: formatMessage }, editBoardUrl: editBoardUrl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $asoHC.TransitionComponent), {
            href: editBoardUrl,
            onClick: this.onEdit
        }, (props)=>/* @ts-expect-error - Type '{ children: string; href: string; onClick: OnClick; }' is not assignable to type 'Omit<{ children: ReactNode; component?: ComponentType<PropsWithChildren<CustomItemComponentProps>> | undefined; ... 14 more ...; key?: Key | ... 1 more ... | undefined; }, keyof WithAnalyticsEventsProps>'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7473d5818f99343a$var$DropdownItemWithAnalytics, props, formatMessage((0, $4J011.default).editAction)));
    }
    renderCopyAction() {
        const { intl: { formatMessage: formatMessage }, onCopy: onCopy } = this.props;
        return /* @ts-expect-error - Type '(arg1: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7473d5818f99343a$var$DropdownItemWithAnalytics, {
            onClick: onCopy
        }, formatMessage((0, $4J011.default).copyAction));
    }
    renderMoveAction() {
        const { intl: { formatMessage: formatMessage }, onMove: onMove } = this.props;
        return /* @ts-expect-error - Type '(arg1: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7473d5818f99343a$var$DropdownItemWithAnalytics, {
            onClick: onMove
        }, formatMessage((0, $4J011.default).moveAction));
    }
    renderDeleteAction() {
        const { intl: { formatMessage: formatMessage }, onDelete: onDelete } = this.props;
        return /* @ts-expect-error - Type '(arg1: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7473d5818f99343a$var$DropdownItemWithAnalytics, {
            onClick: onDelete
        }, formatMessage((0, $4J011.default).deleteAction));
    }
    render() {
        const { isOpen: isOpen } = this.state;
        const { showSpinner: showSpinner, intl: { formatMessage: formatMessage }, isSimple: isSimple, isPrivate: isPrivate, canEdit: canEdit } = this.props;
        if (isSimple) return null;
        // legacy logic: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-plugins/jira-agile/greenhopper/src/main/resources/includes/js/rapid/configuration/ManageBoards.soy
        // check boards spec for more informations: https://extranet.atlassian.com/pages/viewpage.action?pageId=3540485825
        // corresponding issue: https://jdog.jira-dev.com/browse/KITKAT-274
        let moveItem = null;
        let deleteItem = null;
        let copyItem = null;
        let settingsItem = null;
        if (isPrivate) {
            if (canEdit) moveItem = this.renderMoveAction();
            deleteItem = this.renderDeleteAction();
        } else {
            if (canEdit) {
                moveItem = this.renderMoveAction();
                deleteItem = this.renderDeleteAction();
            }
            copyItem = this.renderCopyAction();
            settingsItem = this.renderSettingsAction();
        }
        // @ts-expect-error - TS7031 - Binding element 'triggerRef' implicitly has an 'any' type.
        const triggerFunction = ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...props,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))),
                ref: triggerRef,
                label: formatMessage((0, $4J011.default).tooltip),
                isLoading: showSpinner
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            justifyContent: "end",
            xcss: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_2') ? undefined : $7473d5818f99343a$var$ContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7473d5818f99343a$var$DropdownMenuWithAnalytics, {
            placement: "bottom-end",
            isOpen: isOpen,
            onOpenChange: this.onOpenChange,
            trigger: triggerFunction,
            shouldRenderToParent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, settingsItem, copyItem, moveItem, deleteItem)));
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: this.props.defaultOpen
        }, // @ts-expect-error - TS7031 - Binding element 'isOpen' implicitly has an 'any' type.
        this.onOpenChange = ({ isOpen: isOpen })=>{
            this.setState(()=>({
                    isOpen: isOpen
                }));
        }, this.onEdit = (e, analytics)=>{
            this.props.onEdit(analytics);
            this.delayedClose();
        };
    }
}
var // @ts-expect-error - TS2769 - No overload matches this call.
$7473d5818f99343a$export$2e2bcd8739ae039 = (0, $8RXs9.default)($7473d5818f99343a$var$ActionsOld);
const $7473d5818f99343a$var$ContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.050',
    paddingRight: 'space.025',
    paddingBottom: 'space.0',
    paddingLeft: 'space.0'
});

});
parcelRegister("asoHC", function(module, exports) {

$parcel$export(module.exports, "TransitionComponent", () => $f14567bdbac8ba9f$export$3c61ec5cd62a42f9);

var $5uXOq = parcelRequire("5uXOq");

var $5y0F0 = parcelRequire("5y0F0");
const $f14567bdbac8ba9f$export$3c61ec5cd62a42f9 = ({ children: children, onClick: onClick, href: href })=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ push: push })=>{
        const clickHandler = (e, analyticsEvent)=>{
            if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey || e.button === 1) return;
            e.preventDefault();
            onClick && onClick(e, analyticsEvent);
            push(href);
        };
        return children({
            href: href,
            onClick: clickHandler
        });
    }) : children({
        href: href,
        onClick: onClick
    });

});

parcelRegister("4J011", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0042be87f0842cb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d0042be87f0842cb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editAction: {
        "id": "directories.boards-v2.main.content.cells.actions.edit-action",
        "defaultMessage": "Edit settings"
    },
    deleteAction: {
        "id": "directories.boards-v2.main.content.cells.actions.delete-action",
        "defaultMessage": "Delete"
    },
    copyAction: {
        "id": "directories.boards-v2.main.content.cells.actions.copy-action",
        "defaultMessage": "Copy"
    },
    moveAction: {
        "id": "directories.boards-v2.main.content.cells.actions.move-action",
        "defaultMessage": "Move"
    },
    tooltip: {
        "id": "directories.boards-v2.main.content.cells.actions.tooltip",
        "defaultMessage": "More"
    }
});

});



parcelRegister("8q5Hf", function(module, exports) {

$parcel$export(module.exports, "default", () => $697f2279ef6e4a52$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $jT5vh = parcelRequire("jT5vh");

var $3ZRYH = parcelRequire("3ZRYH");

var $lcTsI = parcelRequire("lcTsI");
// @ts-expect-error - 2345 - Type 'undefined' is not assignable to type 'User[]'
const $697f2279ef6e4a52$var$mapStateToProps = (state, ownProps)=>({
        baseUrl: (0, $jT5vh.getBaseUrl)(state),
        ...(0, $3ZRYH.getAdministrators)(state, ownProps.id)
    });
var $697f2279ef6e4a52$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($697f2279ef6e4a52$var$mapStateToProps, {})((0, $lcTsI.default));

});
parcelRegister("lcTsI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e85686393a45f330$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7OFAf = parcelRequire("7OFAf");

var $jnhNB = parcelRequire("jnhNB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $9nJ7V = parcelRequire("9nJ7V");

var $7dpkb = parcelRequire("7dpkb");

var $aHJ7D = parcelRequire("aHJ7D");
function $e85686393a45f330$export$2e2bcd8739ae039(props) {
    const { baseUrl: baseUrl, users: users, groups: groups } = props;
    if (users?.length === 0 && groups?.length === 0) return null;
    if (users?.length === 1 && groups?.length === 0) // @ts-expect-error - Type '{ user: User; baseUrl: string; }' is not assignable to type 'IntrinsicAttributes & Props & { onClick?: (() => void | null | undefined) | undefined; }'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7dpkb.default), {
        user: users[0],
        baseUrl: baseUrl
    });
    if (users?.length === 0 && groups?.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9nJ7V.default), {
        appearance: "circle",
        displayName: groups[0].name,
        avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($aHJ7D)))
    });
    const data = (0, (/*@__PURE__*/$parcel$interopDefault($7OFAf)))(users?.map((user)=>({
            name: user.displayName,
            src: user.avatarUrl
        })), groups?.map((group)=>({
            name: group.name,
            src: (0, (/*@__PURE__*/$parcel$interopDefault($aHJ7D)))
        }))).filter(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e85686393a45f330$var$avatarGroupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jnhNB.default), {
        appearance: "stack",
        size: "small",
        data: data
    }));
}
const $e85686393a45f330$var$avatarGroupContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.075',
    paddingBottom: 'space.075'
});

});
parcelRegister("7OFAf", function(module, exports) {

var $2Z8Cv = parcelRequire("2Z8Cv");

var $ekcP3 = parcelRequire("ekcP3");

var $jHlUS = parcelRequire("jHlUS");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */ function $5b0d7592c3de24e2$var$concat() {
    var length = arguments.length;
    if (!length) return [];
    var args = Array(length - 1), array = arguments[0], index = length;
    while(index--)args[index - 1] = arguments[index];
    return $2Z8Cv($8LQ84(array) ? $jHlUS(array) : [
        array
    ], $ekcP3(args, 1));
}
module.exports = $5b0d7592c3de24e2$var$concat;

});

parcelRegister("9nJ7V", function(module, exports) {

$parcel$export(module.exports, "default", () => $37198d620d9c114f$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $41j30 = parcelRequire("41j30");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");
const $37198d620d9c114f$var$styles = {
    avatarContainer: "_16jlidpf _1o9zidpf _i0dl1wug _u5f3u2gc _vwz4idpf",
    container: "_16jlkb7n _1o9zkb7n _i0dl1wug _ca0q12x7 _n3td12x7 _1e0c1txw",
    contentContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1bsb1osq",
    contentContainerOld: "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bsb1osq",
    accessibleContentContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _ca0qu2gc _n3tdu2gc _1e0c1txw _4cvr1h6o _1bsb1osq",
    link: "_1bsb1osq",
    textContainer: "_1reo15vq _18m915vq _slp31hna _o5721q9c _1bto1l2s"
};
function $37198d620d9c114f$export$2e2bcd8739ae039(props) {
    const { avatarUrl: avatarUrl, displayName: displayName, href: href, appearance: appearance, onClick: onClick } = props;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37198d620d9c114f$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.avatarContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: avatarUrl,
        size: "small",
        appearance: appearance
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.textContainer
        ])
    }, displayName));
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.link
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        href: href,
        onClick: onClick
    }, content)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_4') ? $37198d620d9c114f$var$styles.contentContainer : $37198d620d9c114f$var$styles.contentContainerOld
        ])
    }, content);
}
$37198d620d9c114f$export$2e2bcd8739ae039.defaultProps = {
    avatarUrl: undefined,
    href: undefined,
    appearance: 'circle',
    onClick: undefined
};
const $37198d620d9c114f$var$Content = (props)=>{
    return (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $37198d620d9c114f$var$accessibleContentContainerStyles
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.accessibleContentContainer
        ])
    }, props.children);
};
const $37198d620d9c114f$var$accessibleContentContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    display: 'flex',
    alignItems: 'center',
    flex: '1 1 auto',
    width: '100%',
    height: '40px'
});

});

parcelRegister("7dpkb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b027fe8ebdaa54a8$export$2e2bcd8739ae039);

var $iQv12 = parcelRequire("iQv12");

var $dqcdn = parcelRequire("dqcdn");
var $b027fe8ebdaa54a8$export$2e2bcd8739ae039 = (0, $iQv12.default)({
    onClick: 'userProfile'
})((0, $dqcdn.default));

});
parcelRegister("dqcdn", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc1d1c3ed200d230$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kYYfm = parcelRequire("kYYfm");

var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");

var $9nJ7V = parcelRequire("9nJ7V");
function $dc1d1c3ed200d230$export$2e2bcd8739ae039(props) {
    const { user: user } = props;
    if (!user) return null;
    const { accountId: accountId, displayName: displayName, avatarUrl: avatarUrl } = user;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9nJ7V.default), {
        displayName: displayName,
        avatarUrl: avatarUrl
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kYYfm.AsyncProfileCardNext), {
        accountId: accountId,
        TenantContextSubscriber: (0, $4R6GH.fg)('empanada_nin_concurrent_mode_fixes') ? undefined : (0, $9OXo1.TenantContextSubscriber)
    }, content);
}

});
parcelRegister("kYYfm", function(module, exports) {

$parcel$export(module.exports, "AsyncProfileCardNext", () => $15521008cc986085$export$a3c0845f856d4292);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $gcl1l = parcelRequire("gcl1l");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $15521008cc986085$var$LazyComponent = (0, $kxZPA.lazy)(()=>(parcelRequire("2RBpK")).then((module)=>module.ProfileCard), {
    moduleId: "./src/packages/profilecard-next/src/main.tsx"
});
const $15521008cc986085$export$a3c0845f856d4292 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "AsyncProfileCardNext",
        packageName: "jiraProfilecardNext",
        render: ()=>// props.children in this context is the code being wrapped
            // in a <ProfileCardTrigger> (I.e. it is the thing a user hovers over to
            // display a profile card).
            // In the event of an unexpected error within @atlaskit/profilecard,
            // just render the unwrapped children (I.e. they will render but nothing
            // happens on hover)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada",
        attributes: (0, $gcl1l.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-profile-card-next-view",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15521008cc986085$var$LazyComponent, props)));
var $15521008cc986085$export$2e2bcd8739ae039 = $15521008cc986085$export$a3c0845f856d4292;

});
parcelRegister("2RBpK", function(module, exports) {

let $215d8db980a3912e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $215d8db980a3912e$var$load("cM9em"),
    $215d8db980a3912e$var$load("fr9NE"),
    $215d8db980a3912e$var$load("h2MrD"),
    $215d8db980a3912e$var$load("bYT2S"),
    $215d8db980a3912e$var$load("ek7ue")
]).then(()=>parcelRequire('jO6eK'));

});




parcelRegister("aHJ7D", function(module, exports) {
module.exports = new URL("group-avatar.46fc45c1.svg", import.meta.url).toString();

});



parcelRegister("81DJu", function(module, exports) {

$parcel$export(module.exports, "default", () => $366c573c72de2faf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iTStj = parcelRequire("iTStj");

var $bg9Cj = parcelRequire("bg9Cj");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$366c573c72de2faf$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iTStj.default), props, ({ isPrivate: isPrivate })=>isPrivate ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bg9Cj.default), props));

});
parcelRegister("iTStj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a4d61648ca826dd$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $3ZRYH = parcelRequire("3ZRYH");

var $e3ABH = parcelRequire("e3ABH");
const $3a4d61648ca826dd$var$mapStateToProps = ()=>(state, ownProps)=>({
            isPrivate: (0, $3ZRYH.isPrivate)(state, ownProps.id)
        });
var $3a4d61648ca826dd$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($3a4d61648ca826dd$var$mapStateToProps, {})((0, $e3ABH.default));

});
parcelRegister("e3ABH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1f2a36232c36084$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f1f2a36232c36084$export$2e2bcd8739ae039 = (props)=>{
    const { isPrivate: isPrivate, children: children } = props;
    return children({
        isPrivate: isPrivate
    });
};

});


parcelRegister("bg9Cj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9b5f68b66167729$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $jzjy1 = parcelRequire("jzjy1");

var $in0Fz = parcelRequire("in0Fz");

var $bC2fB = parcelRequire("bC2fB");

var $3ZRYH = parcelRequire("3ZRYH");
const $a9b5f68b66167729$var$mapStateToPropsFactory = ()=>{
    const onClickFactory = (0, $8QpSo.default)((state, id)=>(analyticsEvent)=>{
            const changeFavorite = (0, $3ZRYH.getChangeFavorite)(state);
            return changeFavorite({
                id: id,
                type: 'boards',
                value: !(0, $3ZRYH.isFavorite)(state, id)
            }, analyticsEvent);
        });
    return (state, ownProps)=>({
            isFavorite: (0, $3ZRYH.isFavorite)(state, ownProps.id),
            favoriteItemName: (0, $3ZRYH.getName)(state, ownProps.id),
            pending: (0, $3ZRYH.isPending)(state, ownProps.id),
            onClick: onClickFactory(state, ownProps.id),
            isShownInList: true
        });
};
var $a9b5f68b66167729$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $jzjy1.AnalyticsSubject)('board'), // @ts-expect-error - TS2589 - Type instantiation is excessively deep and possibly infinite.
(0, $bC2fB.connect)($a9b5f68b66167729$var$mapStateToPropsFactory, {}))((0, $in0Fz.FavoriteCellView));

});
parcelRegister("in0Fz", function(module, exports) {

$parcel$export(module.exports, "FavoriteCellView", () => $6abb13e9102dee85$export$7e4dcb8ef4c4afcd);
/* view.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $hcObS = parcelRequire("hcObS");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");
const $6abb13e9102dee85$var$styles = {
    root: "_1e0c1txw _1bah1h6o _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
function $6abb13e9102dee85$export$7e4dcb8ef4c4afcd(props) {
    return (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6abb13e9102dee85$var$rootStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $6abb13e9102dee85$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), props));
}
$6abb13e9102dee85$export$7e4dcb8ef4c4afcd.defaultProps = {
    isFavorite: undefined
};
const $6abb13e9102dee85$var$rootStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    paddingInline: 'space.050',
    paddingBlock: 'space.100',
    alignItems: 'center',
    height: '40px',
    width: '32px'
});

});



parcelRegister("40ra5", function(module, exports) {

$parcel$export(module.exports, "default", () => $69be047c9f8a6ebe$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $iQv12 = parcelRequire("iQv12");



var $bC2fB = parcelRequire("bC2fB");

var $3ZRYH = parcelRequire("3ZRYH");

var $5t0MH = parcelRequire("5t0MH");
const $69be047c9f8a6ebe$var$mapStateToPropsFactory = ()=>{
    const onDeleteFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$4bd2facc4a3e6aa1)));
    const onCopyFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$92f9e1ed9114d3a6)));
    const onMoveFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$346f08c1f0d0fe41)));
    return (state, ownProps)=>({
            isPrivate: (0, $3ZRYH.isPrivate)(state, ownProps.id),
            editBoardUrl: (0, $3ZRYH.getEditBoardUrl)(state, ownProps.id),
            onDelete: onDeleteFactory(ownProps.onOperationRequested),
            onCopy: onCopyFactory(ownProps.onOperationRequested),
            onMove: onMoveFactory(ownProps.onOperationRequested),
            showSpinner: ownProps.isOperationInProgress,
            isSimple: !(0, $3ZRYH.isPrivate)(state, ownProps.id) && (0, $3ZRYH.getType)(state, ownProps.id) === (0, $8f9d7295a53f46ca$export$aca095bc476d426f),
            canEdit: (0, $3ZRYH.canEdit)(state, ownProps.id),
            location: (0, $3ZRYH.getLocation)(state, ownProps.id)
        });
};
var $69be047c9f8a6ebe$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onEdit: 'edit',
    onDelete: 'delete',
    onCopy: 'copy',
    onMove: 'move'
}), (0, $bC2fB.connect)($69be047c9f8a6ebe$var$mapStateToPropsFactory, {}))((0, $5t0MH.default));

});
parcelRegister("5t0MH", function(module, exports) {

$parcel$export(module.exports, "default", () => $21aeffd2822e0a5d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");

var $9nJ7V = parcelRequire("9nJ7V");

var $dxxxz = parcelRequire("dxxxz");
function $21aeffd2822e0a5d$export$2e2bcd8739ae039(props) {
    const { location: location } = props;
    if (location) {
        const appearance = location.type === 'user' ? 'circle' : 'square';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9nJ7V.default), {
            displayName: location.displayName,
            avatarUrl: location.avatarURI,
            appearance: appearance
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dxxxz.default), props));
    }
    return null;
}

});
parcelRegister("dxxxz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d766c288debb13ac$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $3oUqw = parcelRequire("3oUqw");

var $kgoHi = parcelRequire("kgoHi");

var $8oe80 = parcelRequire("8oe80");

var $asoHC = parcelRequire("asoHC");

var $koVbs = parcelRequire("koVbs");

var $4J011 = parcelRequire("4J011");
const $d766c288debb13ac$var$DropdownMenuWithAnalytics = (0, $8oe80.default)('dropdownMenu', {
    onOpenChange: 'open'
})((0, $BLPHT.default));
const $d766c288debb13ac$var$DropdownItemWithAnalytics = (0, $8oe80.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $6B7KL.default));
function $d766c288debb13ac$export$2e2bcd8739ae039(props) {
    const { isPrivate: isPrivate = false, isSimple: isSimple = false, canEdit: canEdit = true, defaultOpen: defaultOpen = false, showSpinner: showSpinner = false, editBoardUrl: editBoardUrl = '', onEdit: onEdit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onDelete: onDelete = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCopy: onCopy = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onMove: onMove = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(defaultOpen);
    const onOpenChange = (0, $5uXOq.useCallback)(({ isOpen: isOpen })=>{
        setIsDropdownOpen(isOpen);
    }, []); /**
           * Close the menu with a minimal delay so the inner handlers are able to react on keypress properly.
           * In its current implementation if we close the menu right away it won't open the focused `href`.
           * Ideally we have to get right of this and few more methods when the bug linked below is fixed.
           * @see https://ecosystem.atlassian.net/browse/AK-4467
           */ 
    const deyaledClose = (0, $5uXOq.useCallback)(()=>{
        setTimeout(()=>setIsDropdownOpen(false));
    }, []);
    const handleEdit = (0, $5uXOq.useCallback)((e, analytics)=>{
        onEdit(analytics);
        deyaledClose();
    }, [
        deyaledClose,
        onEdit
    ]);
    const renderSettingsAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $asoHC.TransitionComponent), {
            href: editBoardUrl,
            onClick: handleEdit
        }, (dropdownProps)=>/* @ts-expect-error - Type '{ children: string; href: string; onClick: OnClick; }' is not assignable to type 'Omit<{ children: ReactNode; component?: ComponentType<PropsWithChildren<CustomItemComponentProps>> | undefined; ... 14 more ...; key?: Key | ... 1 more ... | undefined; }, keyof WithAnalyticsEventsProps>'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d766c288debb13ac$var$DropdownItemWithAnalytics, dropdownProps, formatMessage((0, $4J011.default).editAction)));
    const renderCopyAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d766c288debb13ac$var$DropdownItemWithAnalytics, {
            onClick: onCopy
        }, formatMessage((0, $4J011.default).copyAction));
    const renderMoveAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d766c288debb13ac$var$DropdownItemWithAnalytics, {
            onClick: onMove
        }, formatMessage((0, $4J011.default).moveAction));
    const renderDeleteAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d766c288debb13ac$var$DropdownItemWithAnalytics, {
            onClick: onDelete
        }, formatMessage((0, $4J011.default).deleteAction));
    const renderActions = ()=>{
        if (isSimple) return null;
         /**
       * legacy logic: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-plugins/jira-agile/greenhopper/src/main/resources/includes/js/rapid/configuration/ManageBoards.soy
       * check boards spec for more informations: https://extranet.atlassian.com/pages/viewpage.action?pageId=3540485825
       * corresponding issue: https://jdog.jira-dev.com/browse/KITKAT-274
       */ 
        let moveItem = null;
        let deleteItem = null;
        let copyItem = null;
        let settingsItem = null;
        if (isPrivate) {
            if (canEdit) moveItem = renderMoveAction();
            deleteItem = renderDeleteAction();
        } else {
            if (canEdit) {
                moveItem = renderMoveAction();
                deleteItem = renderDeleteAction();
            }
            copyItem = renderCopyAction();
            settingsItem = renderSettingsAction();
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const triggerFunction = ({ triggerRef: triggerRef, ...buttonProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...buttonProps,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))),
                ref: triggerRef,
                label: formatMessage((0, $4J011.default).tooltip),
                isLoading: showSpinner,
                spacing: "compact"
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d766c288debb13ac$var$DropdownMenuWithAnalytics, {
            placement: "bottom-end",
            isOpen: isDropdownOpen,
            onOpenChange: onOpenChange,
            trigger: triggerFunction,
            shouldRenderToParent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, settingsItem, copyItem, moveItem, deleteItem));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "end",
        xcss: $d766c288debb13ac$var$styles.container,
        testId: "boards-main.content.cells.actions.container"
    }, renderActions());
}
const $d766c288debb13ac$var$styles = {
    container: "_1rjcu2gc _19bvu2gc _u5f3utpp"
};

});



parcelRegister("3LoLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e663be7ae7fd30f$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $3ZRYH = parcelRequire("3ZRYH");

var $lP59q = parcelRequire("lP59q");
const $2e663be7ae7fd30f$var$mapStateToProps = ()=>(state, ownProps)=>({
            location: (0, $3ZRYH.getLocation)(state, ownProps.id)
        });
var $2e663be7ae7fd30f$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($2e663be7ae7fd30f$var$mapStateToProps, {})((0, $lP59q.default));

});
parcelRegister("lP59q", function(module, exports) {

$parcel$export(module.exports, "default", () => $db950915d871d1f0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9nJ7V = parcelRequire("9nJ7V");
function $db950915d871d1f0$export$2e2bcd8739ae039(props) {
    const { location: location } = props;
    if (location) {
        const appearance = location.type === 'user' ? 'circle' : 'square';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9nJ7V.default), {
            displayName: location.displayName,
            avatarUrl: location.avatarURI,
            appearance: appearance
        });
    }
    return null;
}

});


parcelRegister("iP8IV", function(module, exports) {

$parcel$export(module.exports, "default", () => $22a333e596b1db5a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iTStj = parcelRequire("iTStj");

var $aNq9c = parcelRequire("aNq9c");

var $bVucm = parcelRequire("bVucm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$22a333e596b1db5a$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iTStj.default), props, ({ isPrivate: isPrivate })=>isPrivate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNq9c.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bVucm.default), props));

});
parcelRegister("aNq9c", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6d91f940c5629be$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lj8SI = parcelRequire("lj8SI");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $az4zD = parcelRequire("az4zD");

var $edLLy = parcelRequire("edLLy");
function $a6d91f940c5629be$var$Private(props) {
    const { intl: { formatMessage: formatMessage } } = props;
    const tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a6d91f940c5629be$var$TooltipContent, null, formatMessage((0, $edLLy.default).tooltip));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a6d91f940c5629be$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        isBold: true
    }, formatMessage((0, $edLLy.default).lozenge))));
}
var $a6d91f940c5629be$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($a6d91f940c5629be$var$Private);
const $a6d91f940c5629be$var$TooltipContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _p12f1llu",
            __cmplp.className
        ])
    });
});
const $a6d91f940c5629be$var$containerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
});

});
parcelRegister("edLLy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d9eaf0adc8f694d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8d9eaf0adc8f694d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    lozenge: {
        "id": "directories.boards-v2.main.content.cells.title.private.lozenge",
        "defaultMessage": "Private"
    },
    tooltip: {
        "id": "directories.boards-v2.main.content.cells.title.private.tooltip",
        "defaultMessage": "You don't have permission to view this board"
    }
});

});


parcelRegister("bVucm", function(module, exports) {

$parcel$export(module.exports, "default", () => $91817babe9bfad63$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8lxl7 = parcelRequire("8lxl7");

var $iQv12 = parcelRequire("iQv12");


var $bC2fB = parcelRequire("bC2fB");

var $jT5vh = parcelRequire("jT5vh");

var $3ZRYH = parcelRequire("3ZRYH");

var $4Pnc4 = parcelRequire("4Pnc4");
const $91817babe9bfad63$var$getNextGenBoardPrettyUrl = (state, id)=>{
    const location = (0, $3ZRYH.getLocation)(state, id);
    // @ts-expect-error - TS2339 - Property 'projectKey' does not exist on type 'Location'.
    if (location && location.projectKey) // @ts-expect-error - TS2339 - Property 'projectKey' does not exist on type 'Location'.
    return `${(0, $jT5vh.getBaseUrl)(state)}/jira/software/projects/${location.projectKey}/boards/${id}`;
    return null;
};
const $91817babe9bfad63$export$505a9f131607d070 = (state, id)=>{
    if ((0, $3ZRYH.getType)(state, id) === (0, $8f9d7295a53f46ca$export$aca095bc476d426f)) return $91817babe9bfad63$var$getNextGenBoardPrettyUrl(state, id);
    return (0, $3ZRYH.getRapidBoardUrlForSavedBoard)(state, id);
};
const $91817babe9bfad63$var$mapStateToProps = ()=>(state, ownProps)=>({
            caption: (0, $3ZRYH.getName)(state, ownProps.id),
            href: $91817babe9bfad63$export$505a9f131607d070(state, ownProps.id),
            type: (0, $3ZRYH.getType)(state, ownProps.id)
        });
var $91817babe9bfad63$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $8lxl7.default)((state, ownProps)=>({
        attributes: {
            boardType: (0, $3ZRYH.getType)(state, ownProps.id)
        }
    })), (0, $iQv12.default)({
    onClick: 'board'
}), (0, $bC2fB.connect)($91817babe9bfad63$var$mapStateToProps, {}))((0, $4Pnc4.default));

});
parcelRegister("8lxl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3768e8b105140d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $daJ0i = parcelRequire("daJ0i");

var $bC2fB = parcelRequire("bC2fB");

var $cAj1I = parcelRequire("cAj1I");

var $i4iBk = parcelRequire("i4iBk");
const $d3768e8b105140d5$var$ReduxAnalyticsData = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToAnalytics, connectOptions = {})=>(WrappedComponent)=>{
        // eslint-disable-next-line jira/react/no-class-components
        class ComponentWrappedInAnalytics extends (0, $5uXOq.Component) {
            static{
                this.displayName = `ReduxAnalyticsData(${WrappedComponent.displayName || WrappedComponent.name})`;
            }
            static{
                this.defaultProps = {
                    analyticsContext: {}
                };
            }
            render() {
                const { analyticsContext: analyticsContext, ...componentProps } = this.props;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
                    data: analyticsContext
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, componentProps));
            }
        }
        const mapStateToPropsFactory = ()=>{
            const analyticsContextSelectorInstance = (0, $8QpSo.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (state, ownProps)=>(0, $i4iBk.default)(mapStateToAnalytics(state, ownProps)));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (state, ownProps)=>({
                    analyticsContext: analyticsContextSelectorInstance(state, ownProps)
                });
        };
        return (0, $bC2fB.connect)(mapStateToPropsFactory, ()=>({}), null, {
            // to prevent connected component from unnecessary re-render
            areStatePropsEqual: (nextProps, prevProps)=>{
                const { attributes: prevAttributes, ...prevFields } = prevProps.analyticsContext;
                const { attributes: nextAttributes, ...nextFields } = nextProps.analyticsContext;
                return (0, $cAj1I.default)(prevAttributes, nextAttributes) && (0, $cAj1I.default)(prevFields, nextFields);
            },
            ...connectOptions
        })(ComponentWrappedInAnalytics);
    };
var $d3768e8b105140d5$export$2e2bcd8739ae039 = $d3768e8b105140d5$var$ReduxAnalyticsData;

});
parcelRegister("cAj1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d580e76a13b783$export$2e2bcd8739ae039);
const $95d580e76a13b783$var$isArrayEqual = (array1 = [], array2 = [])=>{
    if (array1 === array2) return true;
    // check one level deep
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};
var // one level check to see if object references are equal
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$95d580e76a13b783$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'never[]'.
    if (!$95d580e76a13b783$var$isArrayEqual(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        const value = obj1[key];
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        // @ts-expect-error - TS2345 - Argument of type 'any[]' is not assignable to parameter of type 'never[]'.
        return Array.isArray(nextValue) && Array.isArray(value) && $95d580e76a13b783$var$isArrayEqual(value, nextValue);
    });
    return areValuesEqual;
};

});


parcelRegister("4Pnc4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f92e546445b8e3d0$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $ff0tU = parcelRequire("ff0tU");

var $asoHC = parcelRequire("asoHC");
const $f92e546445b8e3d0$var$Public = ({ caption: caption, href: href, type: type, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $asoHC.TransitionComponent), {
        href: href,
        onClick: onClick
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ff0tU.default), {
            ...props,
            caption: caption,
            "data-item-board-type": type
        }));
var $f92e546445b8e3d0$export$2e2bcd8739ae039 = $f92e546445b8e3d0$var$Public;

});
parcelRegister("ff0tU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9c2d361e5e2d6e3$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $41j30 = parcelRequire("41j30");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");
function $c9c2d361e5e2d6e3$export$2e2bcd8739ae039({ caption: caption, href: href, onClick: onClick, ...props }) {
    const content = href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        href: href,
        onClick: onClick
    }, caption) : caption;
    if ((0, $dCm1o.isVisualRefreshEnabled)()) {
        if ((0, $4R6GH.fg)('visual-refresh_drop_3')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c9c2d361e5e2d6e3$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c9c2d361e5e2d6e3$var$wrapperStyles
        }, content));
        if ((0, $4R6GH.fg)('visual-refresh_drop_2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            wrap: "nowrap",
            direction: "row",
            xcss: $c9c2d361e5e2d6e3$var$containerStylesOld
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c9c2d361e5e2d6e3$var$wrapperStylesOld
        }, content));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9c2d361e5e2d6e3$var$Container, props, content);
}
const $c9c2d361e5e2d6e3$var$containerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    paddingBlock: 'space.100',
    flex: '1 1 auto',
    flexDirection: 'row',
    display: 'flex',
    height: '40px'
});
const $c9c2d361e5e2d6e3$var$wrapperStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.025',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $c9c2d361e5e2d6e3$var$containerStylesOld = (0, $8CUq3.xcss)({
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingBlock: 'space.100',
    flex: '1 1 auto'
});
const $c9c2d361e5e2d6e3$var$wrapperStylesOld = (0, $8CUq3.xcss)({
    paddingBlock: 'space.025'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $c9c2d361e5e2d6e3$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _1bsb1osq _o5721q9c _1bto1l2s _ca0qutpp _n3tdutpp",
            __cmplp.className
        ])
    });
});

});




parcelRegister("hupmX", function(module, exports) {

$parcel$export(module.exports, "default", () => $683a8b0c16ca4914$export$2e2bcd8739ae039);

var $4cOup = parcelRequire("4cOup");

var $bC2fB = parcelRequire("bC2fB");

var $3MMOA = parcelRequire("3MMOA");

var $jT5vh = parcelRequire("jT5vh");

var $3ZRYH = parcelRequire("3ZRYH");
const $683a8b0c16ca4914$var$mapStateToProps = (state, ownProps)=>{
    const board = (0, $3ZRYH.getBoard)(state, ownProps.entityId);
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    if (board.isPrivate) throw new Error("Unexpected state: Private board can't be copied.");
    return {
        baseUrl: (0, $jT5vh.getBaseUrl)(state),
        board: board
    };
};
const $683a8b0c16ca4914$var$mapDispatchToProps = (dispatch, ownProps)=>({
        onInitialised: ownProps.onDialogShown,
        onBoardCopied: (board, copiedBoardSummary)=>{
            dispatch((0, $3MMOA.copied)(board, copiedBoardSummary));
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            ownProps.onUpdated();
        },
        onBoardCopyFailed: (board, reason)=>dispatch((0, $3MMOA.copyFailed)(board, reason)),
        onCancel: ownProps.onCancel
    });
var // @ts-expect-error - TS2345 - Argument of type 'typeof CopyModal' is not assignable to parameter of type 'Component<{ baseUrl: string; board: Board; } & { onInitialised: () => void; onBoardCopied: (board: PublicBoard, copiedBoardSummary: CopiedBoardSummary) => void; onBoardCopyFailed: (board: PublicBoard, reason: OperationFailureReason) => CopyFailedAction; onCancel: () => void; } & OperationModalProps<...>>'.
$683a8b0c16ca4914$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($683a8b0c16ca4914$var$mapStateToProps, $683a8b0c16ca4914$var$mapDispatchToProps)((0, $4cOup.default));

});
parcelRegister("4cOup", function(module, exports) {

$parcel$export(module.exports, "default", () => $22b585f2f11193a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jzjy1 = parcelRequire("jzjy1");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $7iJwP = parcelRequire("7iJwP");


var $lnOcg = parcelRequire("lnOcg");

var $3A5Nb = parcelRequire("3A5Nb");

var $3gpYE = parcelRequire("3gpYE");

var $1JUNH = parcelRequire("1JUNH");
// eslint-disable-next-line jira/react/no-class-components
class $22b585f2f11193a9$var$CopyModal extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onInitialised: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onBoardCopied: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props);
        this.props.onInitialised();
        this.store = (0, $3gpYE.default)((0, $lnOcg.default));
        this.store.dispatch((0, $3A5Nb.setAppProps)(this.props));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store,
            hasErrorBoundary: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
            id: "unhandled",
            packageName: "jiraCopyBoardsModal",
            teamName: "jira-cosmos"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1JUNH.default), null))));
    }
}
var $22b585f2f11193a9$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('copyBoard', (0, $4d5e0871c06cee03$export$1171103ea9083ffa))($22b585f2f11193a9$var$CopyModal);

});
parcelRegister("lnOcg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b46e1429f71c387$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $kak9T = parcelRequire("kak9T");
var $2b46e1429f71c387$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $kak9T.default));

});
parcelRegister("kak9T", function(module, exports) {

$parcel$export(module.exports, "default", () => $1379d9b1ef36eb0a$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");


var $fsh9d = parcelRequire("fsh9d");

var $cZOLQ = parcelRequire("cZOLQ");

var $3A5Nb = parcelRequire("3A5Nb");

var $4b5Pl = parcelRequire("4b5Pl");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1379d9b1ef36eb0a$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3A5Nb.COPY_BOARD)).mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $4b5Pl.getBaseUrl)(state);
        const board = (0, $4b5Pl.getBoard)(state);
        return (0, $kVLXA.Observable).fromPromise((0, $cZOLQ.default)(baseUrl, board.id)).mergeMap((copiedBoardSummary)=>{
            (0, $4b5Pl.getOnBoardCopied)(state)(board, copiedBoardSummary);
            return (0, $kVLXA.Observable).of((0, $3A5Nb.boardCopied)());
        }).catch((error)=>{
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'directories.boards-v2.copy-modal.ops.copy-board', (0, $cb28450c2d487e75$export$f1a2e76e49f3534e));
            const reason = error.statusCode === 404 ? 'board-not-found' : 'unknown';
            (0, $4b5Pl.getOnBoardCopyFailed)(state)(board, reason);
            return (0, $kVLXA.Observable).of((0, $3A5Nb.copyBoardFailed)({
                reason: reason
            }));
        });
    });

});
const $cb28450c2d487e75$export$f1a2e76e49f3534e = 'directories.boards.error';

parcelRegister("cZOLQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cef098c6749f529c$export$2e2bcd8739ae039);

var $7f4tk = parcelRequire("7f4tk");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cef098c6749f529c$export$2e2bcd8739ae039 = (baseUrl, boardId)=>{
    const url = `/rest/greenhopper/1.0/rapidview/${boardId}/copy`;
    const options = {
        method: 'PUT'
    };
    return (0, $7f4tk.default)(url, options);
};

});

parcelRegister("3A5Nb", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $fd9f3b052a928b92$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $fd9f3b052a928b92$export$cfda7627848a58cd);
$parcel$export(module.exports, "COPY_BOARD", () => $fd9f3b052a928b92$export$e4dd009772b7198e);
$parcel$export(module.exports, "copyBoard", () => $fd9f3b052a928b92$export$12660397a6f72b4d);
$parcel$export(module.exports, "COPY_BOARD_FAILED", () => $fd9f3b052a928b92$export$1afd87d9525e6a2d);
$parcel$export(module.exports, "copyBoardFailed", () => $fd9f3b052a928b92$export$eba000c6ef05bd6a);
$parcel$export(module.exports, "BOARD_COPIED", () => $fd9f3b052a928b92$export$f9a805c22e2247f3);
$parcel$export(module.exports, "boardCopied", () => $fd9f3b052a928b92$export$fcf4bd3839096db);
const $fd9f3b052a928b92$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
const $fd9f3b052a928b92$export$cfda7627848a58cd = (payload)=>({
        type: $fd9f3b052a928b92$export$8aefe701a6f431e0,
        payload: payload
    });
const $fd9f3b052a928b92$export$e4dd009772b7198e = 'state.COPY_BOARD';
const $fd9f3b052a928b92$export$12660397a6f72b4d = ()=>({
        type: $fd9f3b052a928b92$export$e4dd009772b7198e
    });
const $fd9f3b052a928b92$export$1afd87d9525e6a2d = 'state.COPY_BOARD_FAILED';
const $fd9f3b052a928b92$export$eba000c6ef05bd6a = (payload)=>({
        type: $fd9f3b052a928b92$export$1afd87d9525e6a2d,
        payload: payload
    });
const $fd9f3b052a928b92$export$f9a805c22e2247f3 = 'state.BOARD_COPIED';
const $fd9f3b052a928b92$export$fcf4bd3839096db = ()=>({
        type: $fd9f3b052a928b92$export$f9a805c22e2247f3
    });

});

parcelRegister("4b5Pl", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $fcc01c6472c8c066$export$f654b28f82155665);
$parcel$export(module.exports, "getBoard", () => $fcc01c6472c8c066$export$2223f2dfcfd77cef);
$parcel$export(module.exports, "getOnBoardCopied", () => $fcc01c6472c8c066$export$3f4f5af9bb8916f0);
$parcel$export(module.exports, "getOnBoardCopyFailed", () => $fcc01c6472c8c066$export$8c8fcdd1185d1774);
$parcel$export(module.exports, "getOnCancel", () => $fcc01c6472c8c066$export$2c6267c00ffc9906);
$parcel$export(module.exports, "isCopyInProgress", () => $fcc01c6472c8c066$export$c4e95745078f70d6);
const $fcc01c6472c8c066$export$f654b28f82155665 = (state)=>state.appProps.baseUrl;
const $fcc01c6472c8c066$export$2223f2dfcfd77cef = (state)=>state.appProps.board;
const $fcc01c6472c8c066$export$3f4f5af9bb8916f0 = (state)=>state.appProps.onBoardCopied;
const $fcc01c6472c8c066$export$8c8fcdd1185d1774 = (state)=>state.appProps.onBoardCopyFailed;
const $fcc01c6472c8c066$export$2c6267c00ffc9906 = (state)=>state.appProps.onCancel;
const $fcc01c6472c8c066$export$c4e95745078f70d6 = (state)=>state.isCopyInProgress;

});



parcelRegister("3gpYE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e4e67465e4ebbfc$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $gR84Q = parcelRequire("gR84Q");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4e4e67465e4ebbfc$export$2e2bcd8739ae039 = (rootEpic)=>(0, $F2Mxm.default)({
        appName: 'directories/boards-v2/copy-modal',
        rootReducer: $gR84Q.default,
        rootEpic: rootEpic
    });

});
parcelRegister("gR84Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $dec60586dd197440$export$2e2bcd8739ae039);

var $3A5Nb = parcelRequire("3A5Nb");
const $dec60586dd197440$var$defaultState = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    appProps: undefined,
    isCopyInProgress: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dec60586dd197440$export$2e2bcd8739ae039 = (state = $dec60586dd197440$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3A5Nb.SET_APP_PROPS:
            return {
                ...$dec60586dd197440$var$defaultState,
                appProps: action.payload
            };
        case 0, $3A5Nb.COPY_BOARD:
            return {
                ...state,
                isCopyInProgress: true
            };
        case 0, $3A5Nb.COPY_BOARD_FAILED:
            return {
                ...state,
                isCopyInProgress: false
            };
        case 0, $3A5Nb.BOARD_COPIED:
            return state;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("1JUNH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc91001fd31c6181$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $3A5Nb = parcelRequire("3A5Nb");

var $4b5Pl = parcelRequire("4b5Pl");

var $bJbcn = parcelRequire("bJbcn");
const $bc91001fd31c6181$var$mapStateToProps = (state)=>({
        board: (0, $4b5Pl.getBoard)(state),
        copyInProgress: (0, $4b5Pl.isCopyInProgress)(state),
        onCancel: (0, $4b5Pl.getOnCancel)(state)
    });
var $bc91001fd31c6181$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($bc91001fd31c6181$var$mapStateToProps, {
    onCopy: (0, $3A5Nb.copyBoard)
})((0, $bJbcn.default));

});
parcelRegister("bJbcn", function(module, exports) {

$parcel$export(module.exports, "default", () => $72cb48a4e8265e25$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $hZHze = parcelRequire("hZHze");

var $9fuVs = parcelRequire("9fuVs");

var $koVbs = parcelRequire("koVbs");

var $forMM = parcelRequire("forMM");
function $72cb48a4e8265e25$var$CopyBoardsModal(props) {
    const { board: board, copyInProgress: copyInProgress, onCancel: onCancel, onCopy: onCopy } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onCancelOrNoop = !copyInProgress ? onCancel : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        onClose: onCancelOrNoop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: "warning"
    }, formatMessage((0, $forMM.default).heading, {
        boardName: board.name
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $forMM.default).settingsAndFilterInfoMessage, {
        boardName: board.name
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $forMM.default).ownerMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "warning",
        onClick: onCopy,
        isDisabled: copyInProgress
    }, formatMessage((0, $forMM.default).copyButtonCaption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        onClick: onCancelOrNoop,
        isDisabled: copyInProgress
    }, formatMessage((0, $forMM.default).cancelButtonCaption)))));
}
$72cb48a4e8265e25$var$CopyBoardsModal.defaultProps = {
    copyInProgress: false,
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCopy: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $72cb48a4e8265e25$export$2e2bcd8739ae039 = $72cb48a4e8265e25$var$CopyBoardsModal;

});
parcelRegister("forMM", function(module, exports) {

$parcel$export(module.exports, "default", () => $cabca5d70e13eeea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cabca5d70e13eeea$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "directories.boards-v2.copy-modal.heading",
        "defaultMessage": "Copy {boardName}"
    },
    settingsAndFilterInfoMessage: {
        "id": "directories.boards-v2.copy-modal.settings-and-filter-info-message",
        "defaultMessage": "Your copied board will use the same settings and filter as {boardName}."
    },
    ownerMessage: {
        "id": "directories.boards-v2.copy-modal.owner-message",
        "defaultMessage": "As the owner, you can change these later."
    },
    copyButtonCaption: {
        "id": "directories.boards-v2.copy-modal.copy-button-caption",
        "defaultMessage": "Copy"
    },
    cancelButtonCaption: {
        "id": "directories.boards-v2.copy-modal.cancel-button-caption",
        "defaultMessage": "Cancel"
    }
});

});





parcelRegister("iIIlo", function(module, exports) {

$parcel$export(module.exports, "default", () => $534b3146f7550c4b$export$2e2bcd8739ae039);

var $9BBUA = parcelRequire("9BBUA");

var $bC2fB = parcelRequire("bC2fB");

var $3MMOA = parcelRequire("3MMOA");

var $jT5vh = parcelRequire("jT5vh");

var $3ZRYH = parcelRequire("3ZRYH");
const $534b3146f7550c4b$var$mapStateToProps = (state, ownProps)=>({
        baseUrl: (0, $jT5vh.getBaseUrl)(state),
        board: (0, $3ZRYH.getBoard)(state, ownProps.entityId)
    });
const $534b3146f7550c4b$var$mapDispatchToProps = (dispatch, ownProps)=>({
        onInitialised: ownProps.onDialogShown,
        onBoardDeleted: (board)=>{
            dispatch((0, $3MMOA.deleted)(board));
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            ownProps.onUpdated();
        },
        onBoardDeleteFailed: (board, reason)=>dispatch((0, $3MMOA.deleteFailed)(board, reason)),
        onCancel: ownProps.onCancel
    });
var // @ts-expect-error – (2345) - Type 'undefined' is not assignable to type 'Board'
$534b3146f7550c4b$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($534b3146f7550c4b$var$mapStateToProps, $534b3146f7550c4b$var$mapDispatchToProps)((0, $9BBUA.default));

});
parcelRegister("9BBUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $22a0504256a529d4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jzjy1 = parcelRequire("jzjy1");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");


var $1tXsX = parcelRequire("1tXsX");

var $49qY2 = parcelRequire("49qY2");

var $ck8Za = parcelRequire("ck8Za");

var $iAAcr = parcelRequire("iAAcr");
// eslint-disable-next-line jira/react/no-class-components
class $22a0504256a529d4$var$DeleteModal extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onInitialised: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onBoardDeleted: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $ck8Za.default)((0, $1tXsX.default));
        this.store.dispatch((0, $49qY2.setAppProps)(this.props));
        this.store.dispatch((0, $49qY2.getActiveSprints)());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iAAcr.default), null)));
    }
}
var $22a0504256a529d4$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('deleteBoard', (0, $4d5e0871c06cee03$export$1171103ea9083ffa))($22a0504256a529d4$var$DeleteModal);

});
parcelRegister("1tXsX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b51ccb85a14bd3c5$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $3pHol = parcelRequire("3pHol");

var $jxD18 = parcelRequire("jxD18");
var // @ts-expect-error - TS2769 - No overload matches this call.
$b51ccb85a14bd3c5$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $3pHol.default), (0, $jxD18.default));

});
parcelRegister("3pHol", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b51828983128039$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");


var $fsh9d = parcelRequire("fsh9d");

var $9xsrV = parcelRequire("9xsrV");

var $49qY2 = parcelRequire("49qY2");

var $8ojMd = parcelRequire("8ojMd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b51828983128039$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $49qY2.DELETE_BOARD)).mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $8ojMd.getBaseUrl)(state);
        const board = (0, $8ojMd.getBoard)(state);
        return (0, $9xsrV.default)(baseUrl, board.id).mergeMap(()=>{
            (0, $8ojMd.getOnBoardDeleted)(state)(board);
            return (0, $kVLXA.Observable).of((0, $49qY2.boardDeleted)());
        }).catch((error)=>{
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'directories.boards-v2.delete-modal.ops.delete-board', (0, $cb28450c2d487e75$export$f1a2e76e49f3534e));
            const reason = error.statusCode === 404 ? 'board-not-found' : 'unknown';
            (0, $8ojMd.getOnBoardDeleteFailed)(state)(board, reason);
            return (0, $kVLXA.Observable).of((0, $49qY2.deleteBoardFailed)({
                reason: reason
            }));
        });
    });

});
parcelRegister("9xsrV", function(module, exports) {

$parcel$export(module.exports, "default", () => $30eef91be03ea0d6$export$2e2bcd8739ae039);

var $487fd = parcelRequire("487fd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$30eef91be03ea0d6$export$2e2bcd8739ae039 = (baseUrl, boardId)=>{
    const url = `/rest/agile/1.0/board/${boardId}`;
    const options = {
        method: 'delete'
    };
    return (0, $487fd.default)(url, options);
};

});
parcelRegister("487fd", function(module, exports) {

$parcel$export(module.exports, "default", () => $96196282ac54fa24$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $x9xyg = parcelRequire("x9xyg");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $96196282ac54fa24$var$noContentStatus = 204;
const $96196282ac54fa24$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $x9xyg.setMark)(`BEGIN_${key}`);
    }
    return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), opts), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $x9xyg.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, str, traceId);
                else throw new (0, $jJZqs.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $96196282ac54fa24$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        return response.json();
    });
}
var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;

});


parcelRegister("49qY2", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $d54547bc1c4d086f$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $d54547bc1c4d086f$export$cfda7627848a58cd);
$parcel$export(module.exports, "GET_ACTIVE_SPRINTS", () => $d54547bc1c4d086f$export$590db52f99257537);
$parcel$export(module.exports, "getActiveSprints", () => $d54547bc1c4d086f$export$2893b8608d2a6d6a);
$parcel$export(module.exports, "ACTIVE_SPRINTS_RETRIEVED", () => $d54547bc1c4d086f$export$215dde409662413);
$parcel$export(module.exports, "activeSprintsRetrieved", () => $d54547bc1c4d086f$export$12dcad2fd94d0a72);
$parcel$export(module.exports, "GET_ACTIVE_SPRINTS_FAILED", () => $d54547bc1c4d086f$export$14cf35077b6f85f7);
$parcel$export(module.exports, "getActiveSprintsFailed", () => $d54547bc1c4d086f$export$694c6ee523cd87cb);
$parcel$export(module.exports, "DELETE_BOARD", () => $d54547bc1c4d086f$export$a68d619e7022f2c3);
$parcel$export(module.exports, "deleteBoard", () => $d54547bc1c4d086f$export$fc0ef3a3a9b2b3cd);
$parcel$export(module.exports, "DELETE_BOARD_FAILED", () => $d54547bc1c4d086f$export$8cad23f5fe7e6ff3);
$parcel$export(module.exports, "deleteBoardFailed", () => $d54547bc1c4d086f$export$983279b2aa6031b0);
$parcel$export(module.exports, "BOARD_DELETED", () => $d54547bc1c4d086f$export$aea8ac0fecc03cf6);
$parcel$export(module.exports, "boardDeleted", () => $d54547bc1c4d086f$export$d6d2ce109de8e68b);
const $d54547bc1c4d086f$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
const $d54547bc1c4d086f$export$cfda7627848a58cd = (payload)=>({
        type: $d54547bc1c4d086f$export$8aefe701a6f431e0,
        payload: payload
    });
const $d54547bc1c4d086f$export$590db52f99257537 = 'state.GET_ACTIVE_SPRINTS';
const $d54547bc1c4d086f$export$2893b8608d2a6d6a = ()=>({
        type: $d54547bc1c4d086f$export$590db52f99257537
    });
const $d54547bc1c4d086f$export$215dde409662413 = 'state.ACTIVE_SPRINTS_RETRIEVED';
const $d54547bc1c4d086f$export$12dcad2fd94d0a72 = (payload)=>({
        type: $d54547bc1c4d086f$export$215dde409662413,
        payload: payload
    });
const $d54547bc1c4d086f$export$14cf35077b6f85f7 = 'state.GET_ACTIVE_SPRINTS_FAILED';
const $d54547bc1c4d086f$export$694c6ee523cd87cb = ()=>({
        type: $d54547bc1c4d086f$export$14cf35077b6f85f7
    });
const $d54547bc1c4d086f$export$a68d619e7022f2c3 = 'state.DELETE_BOARD';
const $d54547bc1c4d086f$export$fc0ef3a3a9b2b3cd = ()=>({
        type: $d54547bc1c4d086f$export$a68d619e7022f2c3
    });
const $d54547bc1c4d086f$export$8cad23f5fe7e6ff3 = 'state.DELETE_BOARD_FAILED';
const $d54547bc1c4d086f$export$983279b2aa6031b0 = (payload)=>({
        type: $d54547bc1c4d086f$export$8cad23f5fe7e6ff3,
        payload: payload
    });
const $d54547bc1c4d086f$export$aea8ac0fecc03cf6 = 'state.BOARD_DELETED';
const $d54547bc1c4d086f$export$d6d2ce109de8e68b = ()=>({
        type: $d54547bc1c4d086f$export$aea8ac0fecc03cf6
    });

});

parcelRegister("8ojMd", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $fd5d0e91a7503729$export$f654b28f82155665);
$parcel$export(module.exports, "getBoard", () => $fd5d0e91a7503729$export$2223f2dfcfd77cef);
$parcel$export(module.exports, "getOnInitialised", () => $fd5d0e91a7503729$export$47263859bc15a8b8);
$parcel$export(module.exports, "getOnBoardDeleted", () => $fd5d0e91a7503729$export$3efb56c7750e8ce1);
$parcel$export(module.exports, "getOnBoardDeleteFailed", () => $fd5d0e91a7503729$export$311506722a7438bc);
$parcel$export(module.exports, "getOnCancel", () => $fd5d0e91a7503729$export$2c6267c00ffc9906);
$parcel$export(module.exports, "isDeleteInProgress", () => $fd5d0e91a7503729$export$906c0d65e4ece39d);
$parcel$export(module.exports, "getSprintInformation", () => $fd5d0e91a7503729$export$4e64490e97fad74a);
const $fd5d0e91a7503729$export$f654b28f82155665 = (state)=>state.appProps.baseUrl;
const $fd5d0e91a7503729$export$2223f2dfcfd77cef = (state)=>state.appProps.board;
const $fd5d0e91a7503729$export$47263859bc15a8b8 = (state)=>state.appProps.onInitialised;
const $fd5d0e91a7503729$export$3efb56c7750e8ce1 = (state)=>state.appProps.onBoardDeleted;
const $fd5d0e91a7503729$export$311506722a7438bc = (state)=>state.appProps.onBoardDeleteFailed;
const $fd5d0e91a7503729$export$2c6267c00ffc9906 = (state)=>state.appProps.onCancel;
const $fd5d0e91a7503729$export$906c0d65e4ece39d = (state)=>state.isDeleteInProgress;
const $fd5d0e91a7503729$export$4e64490e97fad74a = (state)=>state.sprintInformation;

});


parcelRegister("jxD18", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b8e1cebd0698b37$export$2e2bcd8739ae039);
parcelRequire("9o0uh");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");



var $fsh9d = parcelRequire("fsh9d");

var $1o0mA = parcelRequire("1o0mA");

var $49qY2 = parcelRequire("49qY2");

var $8ojMd = parcelRequire("8ojMd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8b8e1cebd0698b37$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $49qY2.GET_ACTIVE_SPRINTS)).mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $8ojMd.getBaseUrl)(state);
        const board = (0, $8ojMd.getBoard)(state);
        // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'. | TS2339 - Property 'type' does not exist on type 'Board'.
        const shouldSkipCheckingActiveSprints = board.isPrivate || board.type !== (0, $8f9d7295a53f46ca$export$b75edebf0c64f31e);
        if (shouldSkipCheckingActiveSprints) {
            (0, $8ojMd.getOnInitialised)(state)();
            return (0, $kVLXA.Observable).of((0, $49qY2.activeSprintsRetrieved)([]));
        }
        return (0, $kVLXA.Observable).fromPromise((0, $1o0mA.default)(baseUrl, board.id)).mergeMap((sprints)=>{
            (0, $8ojMd.getOnInitialised)(state)();
            return (0, $kVLXA.Observable).of((0, $49qY2.activeSprintsRetrieved)(sprints));
        })// @ts-expect-error - TS2345 - Argument of type '(error: FetchError) => Observable<ActiveSprintsRetrievedAction> | Observable<GetActiveSprintsFailedAction>' is not assignable to parameter of type '(err: any, caught: Observable<ActiveSprintsRetrievedAction>) => ObservableInput<ActiveSprintsRetrievedAction>'.
        .catch((error)=>{
            if (error.statusCode === 404) return (0, $kVLXA.Observable).of((0, $49qY2.activeSprintsRetrieved)([]));
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'directories.boards-v2.delete-modal.ops.get-active-sprints', (0, $cb28450c2d487e75$export$f1a2e76e49f3534e));
            return (0, $kVLXA.Observable).of((0, $49qY2.getActiveSprintsFailed)());
        });
    });

});
parcelRegister("1o0mA", function(module, exports) {

$parcel$export(module.exports, "default", () => $593a1371127faca1$export$2e2bcd8739ae039);

var $cVp8I = parcelRequire("cVp8I");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$593a1371127faca1$export$2e2bcd8739ae039 = async (baseUrl, boardId)=>{
    const activeSprints = await (0, $cVp8I.default)(baseUrl, boardId);
    return activeSprints.values;
};

});
parcelRegister("cVp8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f7120231aa21daa$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8f7120231aa21daa$export$2e2bcd8739ae039 = (baseUrl, boardId)=>{
    const params = (0, $ebyGx.stringify)({
        state: 'active'
    });
    return (0, $7f4tk.default)(`/rest/agile/1.0/board/${boardId}/sprint?${params}`);
};

});




parcelRegister("ck8Za", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ca4b6202c29f451$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $0jPL7 = parcelRequire("0jPL7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5ca4b6202c29f451$export$2e2bcd8739ae039 = (rootEpic)=>(0, $F2Mxm.default)({
        appName: 'directories/boards-v2/delete-modal',
        rootReducer: $0jPL7.default,
        rootEpic: rootEpic
    });

});
parcelRegister("0jPL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2fd5f8b2e6ddfae$export$2e2bcd8739ae039);

var $49qY2 = parcelRequire("49qY2");
const $e2fd5f8b2e6ddfae$var$defaultState = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    appProps: undefined,
    sprintInformation: undefined,
    isDeleteInProgress: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e2fd5f8b2e6ddfae$export$2e2bcd8739ae039 = (state = $e2fd5f8b2e6ddfae$var$defaultState, action)=>{
    switch(action.type){
        case 0, $49qY2.SET_APP_PROPS:
            return {
                ...state,
                appProps: action.payload
            };
        case 0, $49qY2.DELETE_BOARD:
            return {
                ...state,
                isDeleteInProgress: true
            };
        case 0, $49qY2.DELETE_BOARD_FAILED:
            return {
                ...state,
                isDeleteInProgress: false
            };
        case 0, $49qY2.ACTIVE_SPRINTS_RETRIEVED:
            return {
                ...state,
                sprintInformation: {
                    sprints: action.payload
                }
            };
        case 0, $49qY2.GET_ACTIVE_SPRINTS_FAILED:
            return {
                ...state,
                sprintInformation: {
                    error: true
                }
            };
        case 0, $49qY2.GET_ACTIVE_SPRINTS:
        case 0, $49qY2.BOARD_DELETED:
            return state;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("iAAcr", function(module, exports) {

$parcel$export(module.exports, "default", () => $af343ed9c16b8de5$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $az4zD = parcelRequire("az4zD");

var $bC2fB = parcelRequire("bC2fB");

var $49qY2 = parcelRequire("49qY2");

var $8ojMd = parcelRequire("8ojMd");

var $i89gU = parcelRequire("i89gU");

var $kzAuQ = parcelRequire("kzAuQ");
const $af343ed9c16b8de5$var$mapStateToProps = (state)=>({
        Content: $i89gU.default,
        board: (0, $8ojMd.getBoard)(state),
        sprintInformation: (0, $8ojMd.getSprintInformation)(state),
        deleteInProgress: (0, $8ojMd.isDeleteInProgress)(state),
        onCancel: (0, $8ojMd.getOnCancel)(state)
    });
var $af343ed9c16b8de5$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $az4zD.injectIntlV2), (0, $bC2fB.connect)($af343ed9c16b8de5$var$mapStateToProps, {
    onDelete: (0, $49qY2.deleteBoard)
}))(// @ts-expect-error - Argument of type 'typeof DeleteBoardsModal' is not assignable to parameter of type 'ComponentType<{ intl: IntlShapeV2 | IntlShape | undefined; }>'.
(0, $kzAuQ.default));

});
parcelRegister("i89gU", function(module, exports) {

$parcel$export(module.exports, "default", () => $54da6d40f32d7800$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $8ojMd = parcelRequire("8ojMd");

var $igKvW = parcelRequire("igKvW");
const $54da6d40f32d7800$var$mapStateToProps = (state)=>({
        board: (0, $8ojMd.getBoard)(state),
        sprintInformation: (0, $8ojMd.getSprintInformation)(state)
    });
var // @ts-expect-error - Argument of type 'ComponentType<WithIntlProps<Props>>' is not assignable to parameter of type 'ComponentType<Matching<{ board: Board; sprintInformation: SprintInformation | undefined; } & {}, WithIntlProps<Props>>>'.
$54da6d40f32d7800$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($54da6d40f32d7800$var$mapStateToProps, {})((0, $igKvW.default));

});
parcelRegister("igKvW", function(module, exports) {

$parcel$export(module.exports, "default", () => $45b0115c410cf51a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cgL5K = parcelRequire("cgL5K");

var $ousew = parcelRequire("ousew");

var $az4zD = parcelRequire("az4zD");

var $45XQ3 = parcelRequire("45XQ3");
// eslint-disable-next-line jira/react/no-class-components
class $45b0115c410cf51a$var$Content extends (0, $5uXOq.Component) {
    renderContentForPrivateBoard() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $45XQ3.default).privateBoardMessage));
    }
    renderLearnMoreLink(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, formatMessage((0, $45XQ3.default).activeSprintsRecommendation, {
            boardName: board.name
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "em"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: "https://confluence.atlassian.com/jirasoftwarecloud/running-sprints-in-a-scrum-project-764478111.html"
        }, formatMessage((0, $45XQ3.default).link)))));
    }
    renderContentForNoSprints(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $45XQ3.default).noSprintsMessage, {
            boardName: board.name
        }));
    }
    renderContentForSingleSprint(board, sprint) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $45XQ3.default).singleSprintMessage,
            values: {
                sprintName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                    href: sprint.url
                }, sprint.name)
            }
        })), this.renderLearnMoreLink(board));
    }
    renderContentForMultipleSprints(board, sprints) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $45XQ3.default).multipleSprintsMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", null, sprints.map(({ name: name, url: url }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                href: url
            }, name)))), this.renderLearnMoreLink(board));
    }
    renderContentForSprintRetrievalError(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $45XQ3.default).retrievalFailedMessage, {
            boardName: board.name
        })), this.renderLearnMoreLink(board));
    }
    render() {
        const { board: board, sprintInformation: sprintInformation } = this.props;
        // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
        if (board.isPrivate) return this.renderContentForPrivateBoard();
        // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'SprintInformation'.
        if (sprintInformation.error) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'.
        return this.renderContentForSprintRetrievalError(board);
        // @ts-expect-error - TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        if (sprintInformation.sprints.length === 1) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'. | TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        return this.renderContentForSingleSprint(board, sprintInformation.sprints[0]);
        // @ts-expect-error - TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        if (sprintInformation.sprints.length > 1) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'. | TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        return this.renderContentForMultipleSprints(board, sprintInformation.sprints);
        // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'.
        return this.renderContentForNoSprints(board);
    }
}
var $45b0115c410cf51a$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($45b0115c410cf51a$var$Content);

});
parcelRegister("45XQ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d141b44f5ce2e32$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1d141b44f5ce2e32$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    singleSprintMessage: {
        "id": "directories.boards-v2.delete-modal.content.single-sprint-message",
        "defaultMessage": "This board contains issues from {sprintName}, and that sprint is currently active."
    },
    multipleSprintsMessage: {
        "id": "directories.boards-v2.delete-modal.content.multiple-sprints-message",
        "defaultMessage": "This board contains issues from these active sprints:"
    },
    retrievalFailedMessage: {
        "id": "directories.boards-v2.delete-modal.content.retrieval-failed-message",
        "defaultMessage": "Just a heads up, we're having trouble getting information about active sprints. Issues on {boardName} might be part of one."
    },
    activeSprintsRecommendation: {
        "id": "directories.boards-v2.delete-modal.content.active-sprints-recommendation",
        "defaultMessage": "We recommend completing or deleting active sprints before deleting {boardName}."
    },
    noSprintsMessage: {
        "id": "directories.boards-v2.delete-modal.content.no-sprints-message",
        "defaultMessage": "Deleting {boardName} doesn't affect the issues on the board. And, it won't complete or delete any active sprints."
    },
    privateBoardMessage: {
        "id": "directories.boards-v2.delete-modal.content.private-board-message",
        "defaultMessage": "Deleting this board doesn't affect the issues on the board. And, it won't complete or delete any active sprints."
    },
    link: {
        "id": "directories.boards-v2.delete-modal.content.link",
        "defaultMessage": "Learn more about running sprints."
    }
});

});



parcelRegister("kzAuQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9258234539a783c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $1WQct = parcelRequire("1WQct");

var $hZHze = parcelRequire("hZHze");

var $9fuVs = parcelRequire("9fuVs");

var $3HwlS = parcelRequire("3HwlS");

var $koeKL = parcelRequire("koeKL");

var $iJZ8l = parcelRequire("iJZ8l");

var $ehcCJ = parcelRequire("ehcCJ");

var $iT7TT = parcelRequire("iT7TT");
function $c9258234539a783c$var$DeleteBoardsModal(props) {
    const { Content: Content, board: board, sprintInformation: sprintInformation, deleteInProgress: deleteInProgress, onCancel: onCancel, onDelete: onDelete } = props;
    const { intl: { formatMessage: formatMessage } } = props;
    const tenantId = (0, $koeKL.useCloudId)();
    const { deleteBoard: deleteBoard } = (0, $ehcCJ.useDeleteBoard)();
    if (!sprintInformation) return null;
    const onCancelOrNoop = !deleteInProgress ? onCancel : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    const heading = board.isPrivate ? formatMessage((0, $iT7TT.default).deletePrivateBoard) : // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
    formatMessage((0, $iT7TT.default).deleteBoard, {
        boardName: board.name
    });
    const handleDelete = ()=>{
        const boardARI = (0, $1WQct.JiraSoftwareBoardAri).create({
            siteId: tenantId,
            boardId: board.id.toString() ?? ''
        }).toString();
        const dataId = (0, $iJZ8l.default)({
            id: boardARI
        }, 'JiraBoard');
        onDelete();
        if (dataId) deleteBoard(dataId);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        onClose: onCancelOrNoop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: "danger"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "danger",
        onClick: (0, $3HwlS.getWillShowNav4)() ? handleDelete : onDelete,
        isDisabled: deleteInProgress
    }, formatMessage((0, $iT7TT.default).deleteCaption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        onClick: onCancelOrNoop,
        isDisabled: deleteInProgress
    }, formatMessage((0, $iT7TT.default).cancel)))));
}
$c9258234539a783c$var$DeleteBoardsModal.defaultProps = {
    deleteInProgress: false,
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $c9258234539a783c$export$2e2bcd8739ae039 = $c9258234539a783c$var$DeleteBoardsModal;

});
parcelRegister("ehcCJ", function(module, exports) {

$parcel$export(module.exports, "useDeleteBoard", () => $f597fd2c84db3563$export$abd16ada93ebfa6a);

var $8Uumt = parcelRequire("8Uumt");
const $f597fd2c84db3563$export$16ded94db5ddbcd7 = ({ environment: environment })=>{
    const deleteBoard = (boardDataId)=>{
        (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
            store.delete(boardDataId);
        });
    };
    return {
        deleteBoard: deleteBoard
    };
};
const $f597fd2c84db3563$export$abd16ada93ebfa6a = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return $f597fd2c84db3563$export$16ded94db5ddbcd7({
        environment: environment
    });
};

});

parcelRegister("iT7TT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7cc28168885a575$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f7cc28168885a575$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    deleteBoard: {
        "id": "directories.boards-v2.delete-modal.delete-board",
        "defaultMessage": "Delete {boardName}"
    },
    deletePrivateBoard: {
        "id": "directories.boards-v2.delete-modal.delete-private-board",
        "defaultMessage": "Delete board"
    },
    cancel: {
        "id": "directories.boards-v2.delete-modal.cancel",
        "defaultMessage": "Cancel"
    },
    deleteCaption: {
        "id": "directories.boards-v2.delete-modal.delete-caption",
        "defaultMessage": "Delete"
    }
});

});





parcelRegister("lbxSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1979180eaa05acb2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1979180eaa05acb2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    name: {
        "id": "directories.boards-v2.main.name",
        "defaultMessage": "Name"
    },
    type: {
        "id": "directories.boards-v2.main.type",
        "defaultMessage": "Type"
    },
    administrators: {
        "id": "directories.boards-v2.main.administrators",
        "defaultMessage": "Admin"
    },
    location: {
        "id": "directories.boards-v2.main.location",
        "defaultMessage": "Location"
    },
    emptyFilterResultMessage: {
        "id": "directories.boards-v2.main.empty-filter-result-message",
        "defaultMessage": "No boards were found that match your search"
    },
    tableAriaLabel: {
        "id": "directories.boards-v2.main.table-aria-label",
        "defaultMessage": "Boards details"
    },
    filterResultsAnnouncement: {
        "id": "directories.boards-v2.main.filter-results-announcement",
        "defaultMessage": "{itemCount, plural, =0 {No boards were found that match your search} one {{itemCount} board found} other {{itemCount} boards found}}"
    },
    // delete actions message when cleaning up visual-refresh_drop_4 FG
    actions: {
        "id": "directories.boards-v2.main.actions",
        "defaultMessage": "More actions"
    }
});

});

parcelRegister("4G0vG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e0d3176c10cd289$export$2e2bcd8739ae039);

var $hQVg0 = parcelRequire("hQVg0");

var $bC2fB = parcelRequire("bC2fB");

var $3MMOA = parcelRequire("3MMOA");

var $jT5vh = parcelRequire("jT5vh");

var $3ZRYH = parcelRequire("3ZRYH");

var $biuDJ = parcelRequire("biuDJ");
const $1e0d3176c10cd289$var$mapStateToProps = (state, ownProps)=>({
        baseUrl: (0, $jT5vh.getBaseUrl)(state),
        board: (0, $3ZRYH.getBoard)(state, ownProps.entityId),
        MoveSingleBoardDialog: $hQVg0.default
    });
const $1e0d3176c10cd289$var$mapDispatchToProps = (dispatch, ownProps)=>({
        onCancel: ownProps.onCancel,
        onBoardMoved: (board)=>{
            dispatch((0, $3MMOA.moved)(board));
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            ownProps.onUpdated();
        },
        onBoardMoveFailed: (board)=>dispatch((0, $3MMOA.moveFailed)(board)),
        onInitialDataFetchFailed: (board)=>{
            dispatch((0, $3MMOA.moveFailed)(board));
            ownProps.onDataRetrieveFailed();
        },
        onInitialDataFetched: ownProps.onDialogShown
    });
var // @ts-expect-error - TS2345 - Argument of type 'typeof MoveModal' is not assignable to parameter of type 'Component<{ baseUrl: string; board: Board; MoveSingleBoardDialog: typeof MoveSingleBoardDialogApp; } & { onCancel: () => void; onBoardMoved: (board: Board) => void; onBoardMoveFailed: (board: Board) => MoveFailedAction; onInitialDataFetchFailed: (board: Board) => void; onInitialDataFetched: () => void; } & Operation...'.
$1e0d3176c10cd289$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($1e0d3176c10cd289$var$mapStateToProps, $1e0d3176c10cd289$var$mapDispatchToProps)((0, $biuDJ.default));

});
parcelRegister("hQVg0", function(module, exports) {

$parcel$export(module.exports, "default", () => $090186e894d05144$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jD5no = parcelRequire("jD5no");

var $5iwUo = parcelRequire("5iwUo");

var $deV8l = parcelRequire("deV8l");

var $lc3ff = parcelRequire("lc3ff");
class $090186e894d05144$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onLocationSet: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onSetLocationError: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onFetchDataError: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onFetchDataSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            showErrorMessage: true,
            boardName: ''
        };
    }
    constructor(props){
        super(props);
        const { baseUrl: baseUrl, rapidViewId: rapidViewId, currentLocation: currentLocation, store: store } = this.props;
        // creates a separate store for each dialog instance
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        this.store = store || (0, $lc3ff.default)();
        this.store.dispatch((0, $5iwUo.setContext)({
            baseUrl: baseUrl,
            rapidViewId: rapidViewId,
            currentLocation: currentLocation
        }));
    }
    render() {
        const { onLocationSet: onLocationSet, onCancel: onCancel, onSetLocationError: onSetLocationError, onFetchDataError: onFetchDataError, onFetchDataSuccess: onFetchDataSuccess, showErrorMessage: showErrorMessage, boardName: boardName } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store,
            id: "move-single-board-dialog-app",
            teamName: "a4t-pandora",
            packageName: "jiraBoardLocationDialogsMoveSingle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $deV8l.default), {
            onLocationSet: onLocationSet,
            onCancel: onCancel,
            onSetLocationError: onSetLocationError,
            onFetchDataError: onFetchDataError,
            onFetchDataSuccess: onFetchDataSuccess,
            // @ts-expect-error - Property 'showErrorMessage' does not exist on props
            showErrorMessage: showErrorMessage,
            boardName: boardName
        }));
    }
}

});
parcelRegister("5iwUo", function(module, exports) {

$parcel$export(module.exports, "setContext", () => $6e1f124e2924ccbf$export$2f04de43fe27971a);

const $6e1f124e2924ccbf$export$2f04de43fe27971a = (context)=>({
        type: (0, $e843d49b436e09f8$export$4bc4e62e7d72b94b),
        payload: context
    });

});
const $e843d49b436e09f8$export$4bc4e62e7d72b94b = 'SET_CONTEXT';


parcelRegister("deV8l", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f17cc02e4d53e7d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fId2C = parcelRequire("fId2C");

var $cO5M1 = parcelRequire("cO5M1");

var $7VHMR = parcelRequire("7VHMR");

var $az4zD = parcelRequire("az4zD");

var $bC2fB = parcelRequire("bC2fB");

var $RYNEX = parcelRequire("RYNEX");

var $lVn0F = parcelRequire("lVn0F");

var $kXILf = parcelRequire("kXILf");

var $1KRvE = parcelRequire("1KRvE");

var $89S6R = parcelRequire("89S6R");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3f17cc02e4d53e7d$var$i18n = (0, $7VHMR.defineMessages)({
    cancel: {
        "id": "move-single-board.label-for-cancel-button",
        "defaultMessage": "Cancel"
    },
    setLocation: {
        "id": "move-single-board.label-for-set-location-button",
        "defaultMessage": "Set location"
    },
    title: {
        "id": "move-single-board.modal-title",
        "defaultMessage": "Move {boardName}"
    },
    location: {
        "id": "move-single-board.label-for-location",
        "defaultMessage": "New location"
    },
    selectLocation: {
        "id": "move-single-board.placeholder-for-location",
        "defaultMessage": "Select location"
    },
    description: {
        "id": "move-single-board.description",
        "defaultMessage": "Move the board to a different project or your profile. We'll notify the board's admins."
    },
    defaultBoardName: {
        "id": "move-single-board.default-board-name",
        "defaultMessage": "board"
    }
});
// eslint-disable-next-line jira/react/no-class-components
class $3f17cc02e4d53e7d$var$MoveSingleBoardDialogImpl extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            showErrorMessage: true,
            onFetchDataSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    render() {
        const { baseUrl: baseUrl, rapidViewId: rapidViewId, onCancel: onCancel, onConfirm: onConfirm, intl: intl, currentLocationName: currentLocationName, currentLocationAvatarUrl: currentLocationAvatarUrl, onFetchDataSuccess: onFetchDataSuccess } = this.props;
        if (!intl) return null;
        const boardName = this.props.boardName ? this.props.boardName : intl.formatMessage($3f17cc02e4d53e7d$var$i18n.defaultBoardName);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fId2C.default), {
            isOpen: this.props.isOpen,
            baseUrl: baseUrl,
            rapidViewId: rapidViewId,
            onLocationSet: onConfirm,
            onLocationSetError: this.handleOnLocationSetError,
            onFetchDataError: this.handleFetchDataError,
            onFetchDataSuccess: onFetchDataSuccess,
            onProjectSelected: this.clearError,
            onUserSelected: this.clearError,
            errorElement: this.renderErrorMessage(),
            onCancel: onCancel,
            confirmActionText: intl.formatMessage($3f17cc02e4d53e7d$var$i18n.setLocation),
            cancelActionText: intl.formatMessage($3f17cc02e4d53e7d$var$i18n.cancel),
            locationPickerLabel: intl.formatMessage($3f17cc02e4d53e7d$var$i18n.location),
            locationPickerPlaceholder: intl.formatMessage($3f17cc02e4d53e7d$var$i18n.selectLocation),
            title: intl.formatMessage($3f17cc02e4d53e7d$var$i18n.title, {
                boardName: boardName
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, intl.formatMessage($3f17cc02e4d53e7d$var$i18n.description), currentLocationName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXILf.default), {
            locationName: currentLocationName,
            avatarUrl: currentLocationAvatarUrl
        })));
    }
    constructor(...args){
        super(...args), this.state = {
            error: false
        }, this.handleOnLocationSetError = ()=>{
            this.setState({
                error: true
            });
            this.props.onSetLocationError && this.props.onSetLocationError();
        }, this.handleFetchDataError = ()=>this.props.onFetchDataError && this.props.onFetchDataError(), this.clearError = ()=>this.setState({
                error: false
            }), // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.renderErrorMessage = ()=>this.state.error && this.props.showErrorMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cO5M1.default), null) : null;
    }
}
const $3f17cc02e4d53e7d$export$9319c430b829d4fb = (0, $az4zD.injectIntlV2)($3f17cc02e4d53e7d$var$MoveSingleBoardDialogImpl);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3f17cc02e4d53e7d$var$mapStateToProps = (state)=>({
        baseUrl: (0, $RYNEX.baseUrlSelector)(state),
        rapidViewId: (0, $RYNEX.rapidViewIdSelector)(state),
        isOpen: (0, $89S6R.isOpenSelector)(state),
        currentLocationName: (0, $RYNEX.currentLocationDisplayNameSelector)(state),
        currentLocationAvatarUrl: (0, $RYNEX.currentLocationAvatarSelector)(state)
    });
const $3f17cc02e4d53e7d$var$mapDispatchToProps = (dispatch, ownProps)=>({
        onCancel: ()=>{
            dispatch((0, $1KRvE.cancelDialog)());
            ownProps.onCancel && ownProps.onCancel();
        },
        onConfirm: (location)=>{
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            dispatch((0, $lVn0F.setLocationSuccess)(location));
            ownProps.onLocationSet && ownProps.onLocationSet(location);
        }
    });
var $3f17cc02e4d53e7d$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($3f17cc02e4d53e7d$var$mapStateToProps, $3f17cc02e4d53e7d$var$mapDispatchToProps)($3f17cc02e4d53e7d$export$9319c430b829d4fb);

});
parcelRegister("fId2C", function(module, exports) {

$parcel$export(module.exports, "default", () => $2053b7bba4064762$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jD5no = parcelRequire("jD5no");

var $8ZURg = parcelRequire("8ZURg");

var $8gAiA = parcelRequire("8gAiA");

var $2ydCb = parcelRequire("2ydCb");
class $2053b7bba4064762$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isOpen: false,
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onLocationSet: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onLocationSetError: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onFetchDataError: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onFetchDataSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onUserSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onProjectSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            errorElement: null,
            classicLocationless: false,
            boardId: null
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $8gAiA.default)();
        const { baseUrl: baseUrl, rapidViewId: rapidViewId } = this.props;
        this.store.dispatch((0, $8ZURg.setContext)({
            baseUrl: baseUrl,
            rapidViewId: rapidViewId
        }));
        this.store.dispatch((0, $8ZURg.fetchDataRequest)());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store,
            id: "single-board-frame-app",
            teamName: "a4t-pandora",
            packageName: "jiraBoardLocationDialogsCommon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ydCb.default), {
            onCancel: this.props.onCancel,
            isOpen: this.props.isOpen,
            title: this.props.title,
            onLocationSet: this.props.onLocationSet,
            onLocationSetError: this.props.onLocationSetError,
            onFetchDataError: this.props.onFetchDataError,
            onFetchDataSuccess: this.props.onFetchDataSuccess,
            onUserSelected: this.props.onUserSelected,
            onProjectSelected: this.props.onProjectSelected,
            confirmActionText: this.props.confirmActionText,
            cancelActionText: this.props.cancelActionText,
            locationPickerLabel: this.props.locationPickerLabel,
            locationPickerPlaceholder: this.props.locationPickerPlaceholder,
            errorElement: this.props.errorElement,
            classicLocationless: this.props.classicLocationless,
            boardId: this.props.boardId
        }, this.props.children));
    }
}

});
parcelRegister("8ZURg", function(module, exports) {

$parcel$export(module.exports, "initDialog", () => $d0a57a6348442968$export$10e19ed2936eea31);
$parcel$export(module.exports, "selectLocation", () => $d0a57a6348442968$export$7c999b8dd6b194a1);
$parcel$export(module.exports, "unselectLocation", () => $d0a57a6348442968$export$7da9e132cacfc4b7);
$parcel$export(module.exports, "setContext", () => $d0a57a6348442968$export$2f04de43fe27971a);
$parcel$export(module.exports, "fetchDataRequest", () => $d0a57a6348442968$export$d94427b1b5a072d2);
$parcel$export(module.exports, "fetchLocationsDataSuccess", () => $d0a57a6348442968$export$16dcf042ca32eda8);
$parcel$export(module.exports, "fetchDataFailure", () => $d0a57a6348442968$export$56f344f43f493ad5);
$parcel$export(module.exports, "setNewLocation", () => $d0a57a6348442968$export$3c46cf2539fd14d7);
$parcel$export(module.exports, "setLocationSuccess", () => $d0a57a6348442968$export$5daab09d8e3809e0);
$parcel$export(module.exports, "setLocationFailure", () => $d0a57a6348442968$export$e97c62ad868ad2c3);
$parcel$export(module.exports, "cancelDialog", () => $d0a57a6348442968$export$d8e990c7994e01bd);

const $d0a57a6348442968$export$10e19ed2936eea31 = ()=>({
        type: $39115590bc5b17d7$export$10b25390e6826dd4
    });
const $d0a57a6348442968$export$7c999b8dd6b194a1 = (payload)=>({
        type: $39115590bc5b17d7$export$478424fe4f82b403,
        payload: payload
    });
const $d0a57a6348442968$export$7da9e132cacfc4b7 = ()=>({
        type: $39115590bc5b17d7$export$be0eb6a22c665151
    });
const $d0a57a6348442968$export$2f04de43fe27971a = (payload)=>({
        type: $39115590bc5b17d7$export$4bc4e62e7d72b94b,
        payload: payload
    });
const $d0a57a6348442968$export$d94427b1b5a072d2 = ()=>({
        type: $39115590bc5b17d7$export$8caa30ec786cd60b
    });
const $d0a57a6348442968$export$16dcf042ca32eda8 = (payload)=>({
        type: $39115590bc5b17d7$export$a3e42002fa3c8d45,
        payload: payload
    });
const $d0a57a6348442968$export$56f344f43f493ad5 = ()=>({
        type: $39115590bc5b17d7$export$ce1f7e009152c20f
    });
const $d0a57a6348442968$export$3c46cf2539fd14d7 = (payload, analyticsEvent)=>({
        type: $39115590bc5b17d7$export$7811c5a6339c0d38,
        payload: payload,
        meta: {
            analytics: analyticsEvent
        }
    });
const $d0a57a6348442968$export$5daab09d8e3809e0 = ()=>({
        type: $39115590bc5b17d7$export$9d8d4e6ce2e6a21
    });
const $d0a57a6348442968$export$e97c62ad868ad2c3 = ()=>({
        type: $39115590bc5b17d7$export$e2872d87ddcb5b4a
    });
const $d0a57a6348442968$export$d8e990c7994e01bd = ()=>({
        type: $39115590bc5b17d7$export$b58c79b7f2d0f102
    });

});
const $39115590bc5b17d7$export$10b25390e6826dd4 = 'single-board-frame/INIT_DIALOG';
const $39115590bc5b17d7$export$4bc4e62e7d72b94b = 'single-board-frame/SET_CONTEXT';
const $39115590bc5b17d7$export$478424fe4f82b403 = 'single-board-frame/SELECT_LOCATION';
const $39115590bc5b17d7$export$be0eb6a22c665151 = 'single-board-frame/UNSELECT_LOCATION';
const $39115590bc5b17d7$export$8caa30ec786cd60b = 'single-board-frame/FETCH_DATA_REQUEST';
const $39115590bc5b17d7$export$a3e42002fa3c8d45 = 'single-board-frame/FETCH_LOCATIONS_DATA_SUCCESS';
const $39115590bc5b17d7$export$ce1f7e009152c20f = 'single-board-frame/FETCH_DATA_FAILURE';
const $39115590bc5b17d7$export$7811c5a6339c0d38 = 'single-board-frame/SET_NEW_LOCATION';
const $39115590bc5b17d7$export$9d8d4e6ce2e6a21 = 'single-board-frame/SET_LOCATION_SUCCESS';
const $39115590bc5b17d7$export$e2872d87ddcb5b4a = 'single-board-frame/SET_LOCATION_FAILURE';
const $39115590bc5b17d7$export$b58c79b7f2d0f102 = 'single-board-frame/CANCEL_DIALOG';


parcelRegister("8gAiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad77742876b06ed6$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $e1AU2 = parcelRequire("e1AU2");

var $hkadP = parcelRequire("hkadP");

var $3fHrH = parcelRequire("3fHrH");

var $bLhzw = parcelRequire("bLhzw");

var $7sdig = parcelRequire("7sdig");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad77742876b06ed6$export$2e2bcd8739ae039 = (initialState = (0, $3fHrH.defaultState))=>(0, $3f2cs.createStore)((0, $7sdig.default), initialState, (0, $hkadP.default)({
        name: 'SingleBoardFrame'
    })((0, $3f2cs.applyMiddleware)((0, $e1AU2.createEpicMiddleware)((0, $bLhzw.default)))));

});
parcelRegister("3fHrH", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $532f08e6591ab070$export$49d5fc8cba920a0);
const $532f08e6591ab070$export$49d5fc8cba920a0 = {
    isLocationSet: false,
    errorOnLocationSet: false,
    errorOnFetchData: false,
    selectedLocation: {},
    context: undefined,
    locations: {},
    recentProjects: 5,
    isSettingLocation: false
};

});

parcelRegister("bLhzw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4717ebecea4aed8a$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $b4ux3 = parcelRequire("b4ux3");

var $efpwB = parcelRequire("efpwB");
var $4717ebecea4aed8a$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $b4ux3.default), (0, $efpwB.default));

});
parcelRegister("b4ux3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8788611a80e7672$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $2J8or = parcelRequire("2J8or");

var $8ZURg = parcelRequire("8ZURg");


var $4jz6l = parcelRequire("4jz6l");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$d8788611a80e7672$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $39115590bc5b17d7$export$8caa30ec786cd60b)).switchMap(()=>{
        const state = store.getState();
        return (0, $2J8or.default)((0, $4jz6l.baseUrlSelector)(state), (0, $4jz6l.recentProjectsSelector)(state)).map((0, $8ZURg.fetchLocationsDataSuccess))// @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
        .catch((anotherError)=>(0, $kVLXA.Observable).of((0, $8ZURg.fetchDataFailure)(anotherError)));
    });

});
parcelRegister("2J8or", function(module, exports) {

$parcel$export(module.exports, "default", () => $5979826d4c946b8e$export$2e2bcd8739ae039);
parcelRequire("d0pqD");

var $487fd = parcelRequire("487fd");
const $5979826d4c946b8e$var$getEndPointUrl = (numberOfRecentProjects)=>{
    const sortByRecent = numberOfRecentProjects ? `sortByRecent=${numberOfRecentProjects}` : '';
    return `/rest/greenhopper/1.0/boardLocation.json?${sortByRecent}`;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5979826d4c946b8e$export$2e2bcd8739ae039 = (baseUrl, numberOfRecentProjects)=>(0, $487fd.default)($5979826d4c946b8e$var$getEndPointUrl(numberOfRecentProjects)).map((payload)=>({
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            projects: payload.projects,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            user: payload.user
        }));

});

parcelRegister("4jz6l", function(module, exports) {

$parcel$export(module.exports, "selectedLocationSelector", () => $37d855b277408d20$export$ec884117f79a7081);
$parcel$export(module.exports, "baseUrlSelector", () => $37d855b277408d20$export$1ca9a92a5f28e233);
$parcel$export(module.exports, "rapidViewIdSelector", () => $37d855b277408d20$export$718e830000b27a0e);
$parcel$export(module.exports, "isPendingSelector", () => $37d855b277408d20$export$74ce67c99a85589);
$parcel$export(module.exports, "locationsSelector", () => $37d855b277408d20$export$650f111025ecf6fd);
$parcel$export(module.exports, "selectedLocationIdSelector", () => $37d855b277408d20$export$98d0273890cef57c);
$parcel$export(module.exports, "selectedLocationTypeSelector", () => $37d855b277408d20$export$eb3d83c6cfc0f640);
$parcel$export(module.exports, "errorOnLocationSetSelector", () => $37d855b277408d20$export$c0952aa2d9e55812);
$parcel$export(module.exports, "errorOnFetchDataSelector", () => $37d855b277408d20$export$487bc5acf30eeb6f);
$parcel$export(module.exports, "recentProjectsSelector", () => $37d855b277408d20$export$465e3de95c2a60e2);
$parcel$export(module.exports, "isLocationSetSelector", () => $37d855b277408d20$export$5ec69d4f3270587b);
$parcel$export(module.exports, "isSettingLocationSelector", () => $37d855b277408d20$export$29381c1563c40ad);

var $dGvGJ = parcelRequire("dGvGJ");

var $gccSB = parcelRequire("gccSB");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $37d855b277408d20$var$contextSelector = (state)=>state.context;
const $37d855b277408d20$export$ec884117f79a7081 = (state)=>state.selectedLocation;
const $37d855b277408d20$export$1ca9a92a5f28e233 = (_)=>'';
const $37d855b277408d20$export$718e830000b27a0e = (0, $dGvGJ.createSelector)($37d855b277408d20$var$contextSelector, (context)=>context.rapidViewId);
const $37d855b277408d20$export$74ce67c99a85589 = (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(state.locations);
const $37d855b277408d20$export$650f111025ecf6fd = (state)=>state.locations;
const $37d855b277408d20$export$98d0273890cef57c = (0, $dGvGJ.createSelector)($37d855b277408d20$export$ec884117f79a7081, (selectedLocation)=>selectedLocation?.location.id);
const $37d855b277408d20$export$eb3d83c6cfc0f640 = (0, $dGvGJ.createSelector)($37d855b277408d20$export$ec884117f79a7081, (selectedLocation)=>selectedLocation?.type);
const $37d855b277408d20$export$c0952aa2d9e55812 = (state)=>state.errorOnLocationSet;
const $37d855b277408d20$export$487bc5acf30eeb6f = (state)=>state.errorOnFetchData;
const $37d855b277408d20$export$465e3de95c2a60e2 = (state)=>state.recentProjects;
const $37d855b277408d20$export$5ec69d4f3270587b = (state)=>state.isLocationSet;
const $37d855b277408d20$export$29381c1563c40ad = (state)=>state.isSettingLocation;

});


parcelRegister("efpwB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b91190e954fcc896$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $hhweD = parcelRequire("hhweD");

var $14I6Y = parcelRequire("14I6Y");

var $8ZURg = parcelRequire("8ZURg");


var $4jz6l = parcelRequire("4jz6l");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$b91190e954fcc896$export$2e2bcd8739ae039 = (action$, store)=>// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
    action$.ofType((0, $39115590bc5b17d7$export$7811c5a6339c0d38)).switchMap((action)=>{
        const state = store.getState();
        const baseUrl = (0, $4jz6l.baseUrlSelector)(state);
        const selectedlocationType = (0, $4jz6l.selectedLocationTypeSelector)(state);
        const selectedLocationId = (0, $4jz6l.selectedLocationIdSelector)(state);
        const boardId = (0, $4jz6l.rapidViewIdSelector)(state);
        const data = {
            rapidViewId: boardId,
            locationType: selectedlocationType
        };
        if (selectedlocationType === 'project') // @ts-expect-error - TS2339 - Property 'locationId' does not exist on type '{ rapidViewId: any; locationType: any; }'.
        data.locationId = selectedLocationId;
        return(// @ts-expect-error - TS2345 - Argument of type '{ rapidViewId: any; locationType: any; }' is not assignable to parameter of type 'string'.
        (0, $14I6Y.default)(baseUrl, data).map(()=>{
            // @ts-expect-error - TS2345 - Argument of type '{ objectId: any; objectType: string; containerType: any; containerId: any; actionSubjectId: any; attributes: { boardId: any; updatedItems: { name: string; newValId: any; newValName: any; }[]; }; }' is not assignable to parameter of type 'Readonly<Readonly<{ name?: string | undefined; containerId?: string | undefined; containers?: Containers | undefined; containerType?: string | undefined; objectType?: string | undefined; objectId?: string | undefined; readonly tags?: readonly string[] | undefined; attributes?: Readonly<...> | undefined; }> & { ...; }>'.
            (0, $hhweD.fireTrackAnalytics)(action.meta.analytics, {
                objectId: boardId,
                objectType: 'board',
                containerType: selectedlocationType,
                containerId: selectedLocationId,
                actionSubjectId: boardId,
                attributes: {
                    boardId: boardId,
                    updatedItems: [
                        {
                            name: 'boardLocation',
                            newValId: selectedLocationId,
                            newValName: selectedlocationType
                        }
                    ]
                }
            });
            return (0, $8ZURg.setLocationSuccess)();
        })// @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
        .catch((anotherError)=>(0, $kVLXA.Observable).of((0, $8ZURg.setLocationFailure)(anotherError))));
    });

});
parcelRegister("14I6Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $c45aa1c19c06e78c$export$2e2bcd8739ae039);

var $487fd = parcelRequire("487fd");
const $c45aa1c19c06e78c$var$getEndPointUrl = ()=>'/rest/greenhopper/1.0/rapidviewconfig/boardLocation';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c45aa1c19c06e78c$export$2e2bcd8739ae039 = (_, data)=>{
    const options = {
        method: 'PUT',
        body: JSON.stringify(data)
    };
    return (0, $487fd.default)($c45aa1c19c06e78c$var$getEndPointUrl(), options);
};

});



parcelRegister("7sdig", function(module, exports) {

$parcel$export(module.exports, "default", () => $c23e8e61fe108905$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");


var $3fHrH = parcelRequire("3fHrH");
var // @ts-expect-error - TS7031 - Binding element 'type' implicitly has an 'any' type. | TS7031 - Binding element 'payload' implicitly has an 'any' type.
// eslint-disable-next-line jira/import/no-anonymous-default-export
$c23e8e61fe108905$export$2e2bcd8739ae039 = (state = (0, $3fHrH.defaultState), { type: type, payload: payload })=>{
    switch(type){
        case $39115590bc5b17d7$export$10b25390e6826dd4:
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            return (0, $7uUwQ.assoc)(state, (0, $3fHrH.defaultState));
        case $39115590bc5b17d7$export$4bc4e62e7d72b94b:
            return (0, $7uUwQ.assocIn)(state, [
                'context'
            ], payload);
        case $39115590bc5b17d7$export$478424fe4f82b403:
            return (0, $7uUwQ.merge)(state, {
                errorOnLocationSet: false,
                isLocationSet: false,
                selectedLocation: payload
            });
        case $39115590bc5b17d7$export$be0eb6a22c665151:
            return (0, $7uUwQ.chain)(state).assoc('errorOnLocationSet', false).assoc('isLocationSet', false).assoc('selectedLocation', {}).value();
        case $39115590bc5b17d7$export$a3e42002fa3c8d45:
            return (0, $7uUwQ.assocIn)(state, [
                'locations'
            ], payload);
        case $39115590bc5b17d7$export$9d8d4e6ce2e6a21:
            return (0, $7uUwQ.merge)(state, {
                errorOnLocationSet: false,
                isLocationSet: true,
                isSettingLocation: false
            });
        case $39115590bc5b17d7$export$e2872d87ddcb5b4a:
            return (0, $7uUwQ.merge)(state, {
                errorOnLocationSet: true,
                isLocationSet: false,
                isSettingLocation: false
            });
        case $39115590bc5b17d7$export$ce1f7e009152c20f:
            return (0, $7uUwQ.merge)(state, {
                errorOnFetchData: true
            });
        case $39115590bc5b17d7$export$b58c79b7f2d0f102:
            return (0, $7uUwQ.chain)(state).assoc('errorOnLocationSet', false).assoc('isLocationSet', false).assoc('selectedLocation', {}).value();
        case $39115590bc5b17d7$export$7811c5a6339c0d38:
            return (0, $7uUwQ.merge)(state, {
                errorOnLocationSet: false,
                isLocationSet: false,
                isSettingLocation: true
            });
        default:
            break;
    }
    return state;
};

});


parcelRegister("2ydCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8513f3fa83f3e8be$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $gccSB = parcelRequire("gccSB");

var $8Rkzz = parcelRequire("8Rkzz");

var $cb25w = parcelRequire("cb25w");

var $fVnbM = parcelRequire("fVnbM");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $eZJjh = parcelRequire("eZJjh");

var $jzjy1 = parcelRequire("jzjy1");

var $hZHze = parcelRequire("hZHze");

var $9fuVs = parcelRequire("9fuVs");

var $ousew = parcelRequire("ousew");


var $bC2fB = parcelRequire("bC2fB");

var $bfxKw = parcelRequire("bfxKw");

var $l4EnJ = parcelRequire("l4EnJ");

var $bqnjv = parcelRequire("bqnjv");

var $dKK8a = parcelRequire("dKK8a");

var $1qOIr = parcelRequire("1qOIr");

var $8ZURg = parcelRequire("8ZURg");

var $4jz6l = parcelRequire("4jz6l");

var $a1epm = parcelRequire("a1epm");
class $8513f3fa83f3e8be$export$63d5de293e655f86 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            initDialog: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onLocationSet: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onLocationSetError: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onFetchDataError: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onFetchDataSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onProjectSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onUserSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            errorElement: null,
            // @ts-expect-error - TS2322 - Type '{ initDialog: (...args: any[]) => void; onCancel: (...args: any[]) => void; onConfirm: (...args: any[]) => void; onLocationSet: (...args: any[]) => void; onLocationSetError: (...args: any[]) => void; onFetchDataError: (...args: any[]) => void; ... 6 more ...; isSettingLocation: boolean; }' is not assignable to type 'DefaultProps'.
            selectedLocation: null,
            errorOnFetchData: false,
            isSettingLocation: false,
            classicLocationless: false,
            boardId: null
        };
    }
    componentDidMount() {
        this.props.initDialog();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isLocationSet && !this.props.isLocationSet) this.props.onLocationSet(this.props.selectedLocation);
        if (nextProps.errorOnLocationSet && !this.props.errorOnLocationSet) this.props.onLocationSetError();
        if (nextProps.errorOnFetchData && !this.props.errorOnFetchData) this.props.onFetchDataError();
        if (!nextProps.isPending && this.props.isPending) this.props.onFetchDataSuccess();
    }
    render() {
        if (this.props.isPending) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bqnjv.default), null);
        return this.props.isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
            testId: "board-location-dialogs-common.apps.single-board-frame.modal-dialog",
            width: "medium",
            onClose: this.props.onCancel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, this.renderHeader()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l4EnJ.default), null, this.props.children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dKK8a.default), {
            baseUrl: this.props.baseUrl,
            recentProjectsLimit: this.props.recentProjectsLimit,
            label: this.props.locationPickerLabel,
            placeholder: this.props.locationPickerPlaceholder,
            locations: this.props.locations,
            onProjectSelected: this.handleOnProjectSelected,
            onUserSelected: this.handleOnUserSelected,
            onItemUnselected: this.handleOnItemUnselected
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1qOIr.default).classicLocationlessActionPromptText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, this.renderButtons())));
    }
    constructor(...args){
        super(...args), this.handleOnProjectSelected = (location)=>{
            const selectedLocation = {
                location: location,
                type: 'project'
            };
            this.props.onProjectSelected(selectedLocation);
        }, this.handleOnUserSelected = (location)=>{
            const selectedLocation = {
                location: location,
                type: 'user'
            };
            this.props.onUserSelected(selectedLocation);
        }, this.handleOnItemUnselected = ()=>{
            this.props.onLocationUnselected();
        }, this.handleOnCancel = ()=>{
            this.props.onCancel();
        }, this.renderHeader = ()=>{
            const { errorElement: errorElement } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
                appearance: "warning"
            }, this.props.title, errorElement);
        }, this.renderButtons = ()=>{
            const { onConfirm: onConfirm, confirmActionText: confirmActionText, cancelActionText: cancelActionText, selectedLocation: selectedLocation, isSettingLocation: isSettingLocation } = this.props;
            const spinner = isSettingLocation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "small"
            }) : null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bfxKw.default), {
                spinner: spinner,
                secondaryButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    appearance: "subtle-link",
                    onClick: this.handleOnCancel,
                    isDisabled: isSettingLocation
                }, cancelActionText),
                primaryButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    appearance: "warning",
                    onClick: ()=>onConfirm(event, {
                            classicLocationless: this.props.classicLocationless,
                            selectedLocation: selectedLocation,
                            boardId: this.props.boardId
                        }),
                    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(selectedLocation) || isSettingLocation
                }, confirmActionText)
            });
        };
    }
}
const $8513f3fa83f3e8be$var$mapStateToProps = (state)=>({
        locations: (0, $4jz6l.locationsSelector)(state),
        baseUrl: (0, $4jz6l.baseUrlSelector)(state),
        recentProjectsLimit: (0, $4jz6l.recentProjectsSelector)(state),
        isPending: (0, $4jz6l.isPendingSelector)(state),
        isLocationSet: (0, $4jz6l.isLocationSetSelector)(state),
        selectedLocation: (0, $4jz6l.selectedLocationSelector)(state),
        errorOnLocationSet: (0, $4jz6l.errorOnLocationSetSelector)(state),
        errorOnFetchData: (0, $4jz6l.errorOnFetchDataSelector)(state),
        isSettingLocation: (0, $4jz6l.isSettingLocationSelector)(state)
    });
const $8513f3fa83f3e8be$var$mapDispatchToProps = (dispatch, ownProps)=>({
        initDialog: ()=>{
            dispatch((0, $8ZURg.initDialog)());
        },
        onConfirm: (event1, classicLocationlessData, analyticsEvent)=>{
            const { classicLocationless: classicLocationless } = classicLocationlessData ?? {};
            if (classicLocationless) {
                const redirectUrl = classicLocationlessData && (0, $a1epm.getClassicLocationlessRedirectUrl)(classicLocationlessData);
                if (redirectUrl && typeof window !== 'undefined') window.location.href = redirectUrl;
            }
            dispatch((0, $8ZURg.setNewLocation)({}, analyticsEvent));
        },
        onCancel: ()=>{
            dispatch((0, $8ZURg.cancelDialog)());
            ownProps.onCancel && ownProps.onCancel();
        },
        onProjectSelected: (location)=>{
            dispatch((0, $8ZURg.selectLocation)(location));
            ownProps.onProjectSelected && ownProps.onProjectSelected(location);
        },
        onUserSelected: (location)=>{
            dispatch((0, $8ZURg.selectLocation)(location));
            ownProps.onUserSelected && ownProps.onUserSelected(location);
        },
        onLocationUnselected: ()=>dispatch((0, $8ZURg.unselectLocation)())
    });
const $8513f3fa83f3e8be$export$2480db8408930187 = (0, $bC2fB.connect)($8513f3fa83f3e8be$var$mapStateToProps, $8513f3fa83f3e8be$var$mapDispatchToProps)($8513f3fa83f3e8be$export$63d5de293e655f86);
var $8513f3fa83f3e8be$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $cb25w.default)({
    onConfirm: {
        action: 'updated'
    }
}), (0, $bC2fB.connect)($8513f3fa83f3e8be$var$mapStateToProps, $8513f3fa83f3e8be$var$mapDispatchToProps), (0, $jzjy1.AnalyticsSource)('moveBoard', (0, $4d5e0871c06cee03$export$1171103ea9083ffa)), (0, $jzjy1.AnalyticsSubject)('board'))($8513f3fa83f3e8be$export$63d5de293e655f86);

});
parcelRegister("bfxKw", function(module, exports) {

$parcel$export(module.exports, "default", () => $49a8143ac950b2aa$export$2e2bcd8739ae039);
/* action-buttons.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49a8143ac950b2aa$var$SpinnerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxpxbi _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $49a8143ac950b2aa$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _otyru2gc _19pku2gc",
            __cmplp.className
        ])
    });
});
const $49a8143ac950b2aa$var$cancelButtonWrapperStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.050'
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$49a8143ac950b2aa$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($49a8143ac950b2aa$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($49a8143ac950b2aa$var$SpinnerWrapper, null, props.spinner), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $49a8143ac950b2aa$var$cancelButtonWrapperStyles
    }, props.secondaryButton), props.primaryButton);

});

parcelRegister("l4EnJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c3b6c0f765ebe9e$export$2e2bcd8739ae039);
/* content-wrapper.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2c3b6c0f765ebe9e$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
var $2c3b6c0f765ebe9e$export$2e2bcd8739ae039 = $2c3b6c0f765ebe9e$var$ContentWrapper;

});

parcelRegister("bqnjv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0899539ded26524$export$2e2bcd8739ae039);
/* loading-screen.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $j55bS = parcelRequire("j55bS");

var $eZJjh = parcelRequire("eZJjh");
const $d0899539ded26524$var$LoadingScreen = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d0899539ded26524$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j55bS.default), {
        isTinted: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d0899539ded26524$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    })));
var $d0899539ded26524$export$2e2bcd8739ae039 = $d0899539ded26524$var$LoadingScreen;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $d0899539ded26524$var$SpinnerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1n9t _1ltv1ssb _19pk1eca",
            __cmplp.className
        ])
    });
});
const $d0899539ded26524$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1ltvidpf _kqsw1n9t _154iidpf _1bsb1osq _1pbybfng",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dKK8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $6641c6df75fd8632$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $8Rkzz = parcelRequire("8Rkzz");

var $jD5no = parcelRequire("jD5no");

var $krfOi = parcelRequire("krfOi");

var $4Oxh8 = parcelRequire("4Oxh8");

var $9dC6e = parcelRequire("9dC6e");
class $6641c6df75fd8632$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            placeholder: '',
            label: '',
            onItemUnselected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $4Oxh8.default)();
        const { baseUrl: baseUrl, locations: locations, recentProjectsLimit: recentProjectsLimit } = this.props;
        this.store.dispatch((0, $krfOi.setContext)({
            baseUrl: baseUrl,
            recentProjectsLimit: recentProjectsLimit
        }));
        (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(locations) || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(locations.projects) && (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(locations.user) ? this.store.dispatch((0, $krfOi.fetchDataRequest)()) : this.store.dispatch((0, $krfOi.fetchDataSuccess)(locations));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store,
            id: "location-picker-app",
            teamName: "a4t-pandora",
            packageName: "jiraBoardLocationDialogsCommon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dC6e.default), {
            onProjectSelected: this.props.onProjectSelected,
            onUserSelected: this.props.onUserSelected,
            onItemUnselected: this.props.onItemUnselected,
            label: this.props.label,
            placeholder: this.props.placeholder
        }));
    }
}

});
parcelRegister("krfOi", function(module, exports) {

$parcel$export(module.exports, "fetchDataRequest", () => $fa86a09f5feb07d1$export$d94427b1b5a072d2);
$parcel$export(module.exports, "fetchDataSuccess", () => $fa86a09f5feb07d1$export$f2604acf0d813dfd);
$parcel$export(module.exports, "fetchDataFailure", () => $fa86a09f5feb07d1$export$56f344f43f493ad5);
$parcel$export(module.exports, "setContext", () => $fa86a09f5feb07d1$export$2f04de43fe27971a);

const $fa86a09f5feb07d1$export$d94427b1b5a072d2 = ()=>({
        type: $04c5b3364edd2fe1$export$8caa30ec786cd60b
    });
const $fa86a09f5feb07d1$export$f2604acf0d813dfd = (payload)=>({
        type: $04c5b3364edd2fe1$export$f133dd62d8438ea6,
        payload: payload
    });
const $fa86a09f5feb07d1$export$56f344f43f493ad5 = ()=>({
        type: $04c5b3364edd2fe1$export$ce1f7e009152c20f
    });
const $fa86a09f5feb07d1$export$2f04de43fe27971a = (payload)=>({
        type: $04c5b3364edd2fe1$export$4bc4e62e7d72b94b,
        payload: payload
    });
const $fa86a09f5feb07d1$export$d8e990c7994e01bd = ()=>({
        type: $04c5b3364edd2fe1$export$b58c79b7f2d0f102
    });

});
const $04c5b3364edd2fe1$export$8caa30ec786cd60b = 'location-picker/FETCH_DATA_REQUEST';
const $04c5b3364edd2fe1$export$f133dd62d8438ea6 = 'location-picker/FETCH_DATA_SUCCESS';
const $04c5b3364edd2fe1$export$ce1f7e009152c20f = 'location-picker/FETCH_DATA_FAILURE';
const $04c5b3364edd2fe1$export$4bc4e62e7d72b94b = 'location-picker/SET_CONTEXT';
const $04c5b3364edd2fe1$export$b58c79b7f2d0f102 = 'location-picker/CANCEL_DIALOG';


parcelRegister("4Oxh8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cc3caa93fbaf68c$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $e1AU2 = parcelRequire("e1AU2");

var $hkadP = parcelRequire("hkadP");

var $49jwG = parcelRequire("49jwG");

var $hAKnO = parcelRequire("hAKnO");

var $9HvmD = parcelRequire("9HvmD");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1cc3caa93fbaf68c$export$2e2bcd8739ae039 = (initialState = (0, $49jwG.defaultState))=>{
    const store = (0, $3f2cs.createStore)((0, $9HvmD.default), initialState, (0, $hkadP.default)({
        name: 'LocationPicker'
    })((0, $3f2cs.applyMiddleware)((0, $e1AU2.createEpicMiddleware)((0, $hAKnO.default)))));
    return store;
};

});
parcelRegister("49jwG", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $7d3225a1e13a81e3$export$49d5fc8cba920a0);
const $7d3225a1e13a81e3$export$49d5fc8cba920a0 = {
    locations: {
        projects: [],
        // @ts-expect-error - TS2739 - Type '{}' is missing the following properties from type 'Location': displayName, name, id, avatar
        user: {}
    },
    context: {
        baseUrl: '',
        recentProjectsLimit: 0
    }
};

});

parcelRegister("hAKnO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b79005cd100ecea$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $2J8or = parcelRequire("2J8or");

var $krfOi = parcelRequire("krfOi");


var $72OFd = parcelRequire("72OFd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6b79005cd100ecea$export$2e2bcd8739ae039 = (action$, store)=>// @ts-expect-error - TS2741 - Property 'ofType' is missing in type 'Observable<FetchDataSuccessAction | FetchDataFailureAction>' but required in type 'ActionsObservable<Action>'.
    action$.ofType((0, $04c5b3364edd2fe1$export$8caa30ec786cd60b)).switchMap(()=>{
        const state = store.getState();
        return (0, $2J8or.default)((0, $72OFd.baseUrlSelector)(state), (0, $72OFd.recentProjectsLimitSelector)(state));
    }).map((0, $krfOi.fetchDataSuccess)).catch(()=>(0, $kVLXA.Observable).of((0, $krfOi.fetchDataFailure)()));

});
parcelRegister("72OFd", function(module, exports) {

$parcel$export(module.exports, "userSelector", () => $9fb4a5dbd5ddb980$export$210c0a88ec4709b);
$parcel$export(module.exports, "projectsSelector", () => $9fb4a5dbd5ddb980$export$7be58ee3880dbd5c);
$parcel$export(module.exports, "isPendingSelector", () => $9fb4a5dbd5ddb980$export$74ce67c99a85589);
$parcel$export(module.exports, "baseUrlSelector", () => $9fb4a5dbd5ddb980$export$1ca9a92a5f28e233);
$parcel$export(module.exports, "recentProjectsLimitSelector", () => $9fb4a5dbd5ddb980$export$e86bc093bee44a9a);

var $dGvGJ = parcelRequire("dGvGJ");
const $9fb4a5dbd5ddb980$var$contextSelector = (state)=>state.context;
const $9fb4a5dbd5ddb980$var$locationsSelector = (state)=>state.locations;
const $9fb4a5dbd5ddb980$export$210c0a88ec4709b = (0, $dGvGJ.createSelector)($9fb4a5dbd5ddb980$var$locationsSelector, (locations)=>locations.user);
const $9fb4a5dbd5ddb980$export$7be58ee3880dbd5c = (0, $dGvGJ.createSelector)($9fb4a5dbd5ddb980$var$locationsSelector, (locations)=>locations.projects);
const $9fb4a5dbd5ddb980$export$74ce67c99a85589 = (0, $dGvGJ.createSelector)($9fb4a5dbd5ddb980$export$7be58ee3880dbd5c, (projects)=>!projects || projects.length <= 0);
const $9fb4a5dbd5ddb980$export$1ca9a92a5f28e233 = (_)=>'';
const $9fb4a5dbd5ddb980$export$e86bc093bee44a9a = (0, $dGvGJ.createSelector)($9fb4a5dbd5ddb980$var$contextSelector, (context)=>context.recentProjectsLimit);

});


parcelRegister("9HvmD", function(module, exports) {

$parcel$export(module.exports, "default", () => $882d0cb6392d476b$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");


var $49jwG = parcelRequire("49jwG");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$882d0cb6392d476b$export$2e2bcd8739ae039 = (state = (0, $49jwG.defaultState), action)=>{
    switch(action.type){
        case $04c5b3364edd2fe1$export$f133dd62d8438ea6:
            return (0, $7uUwQ.assocIn)(state, [
                'locations'
            ], action.payload);
        case $04c5b3364edd2fe1$export$4bc4e62e7d72b94b:
            return (0, $7uUwQ.assocIn)(state, [
                'context'
            ], action.payload);
        case $04c5b3364edd2fe1$export$b58c79b7f2d0f102:
            return (0, $7uUwQ.assocIn)(state, [
                'locations'
            ], {});
        default:
            break;
    }
    return state;
};

});


parcelRegister("9dC6e", function(module, exports) {

$parcel$export(module.exports, "default", () => $add42d3d5e1acad2$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $72OFd = parcelRequire("72OFd");

var $9EyUU = parcelRequire("9EyUU");
const $add42d3d5e1acad2$var$mapStateToProps = (state)=>({
        isPending: (0, $72OFd.isPendingSelector)(state),
        projects: (0, $72OFd.projectsSelector)(state),
        user: (0, $72OFd.userSelector)(state),
        recentProjectsLimit: (0, $72OFd.recentProjectsLimitSelector)(state)
    });
var $add42d3d5e1acad2$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($add42d3d5e1acad2$var$mapStateToProps, {})((0, $9EyUU.default));

});
parcelRegister("9EyUU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a6ddd68ec9f2eb5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $chc6P = parcelRequire("chc6P");

var $gccSB = parcelRequire("gccSB");

var $ujWmd = parcelRequire("ujWmd");

var $7O4UO = parcelRequire("7O4UO");
var $qfj8c = parcelRequire("qfj8c");

var $7K5PP = parcelRequire("7K5PP");

var $lcCsd = parcelRequire("lcCsd");

var $8RXs9 = parcelRequire("8RXs9");

var $jt9Qd = parcelRequire("jt9Qd");
const $2a6ddd68ec9f2eb5$var$key = Symbol('item-context');
const $2a6ddd68ec9f2eb5$var$ITEM_LIMIT = 30;
const $2a6ddd68ec9f2eb5$var$MENU_CONTEXT = 'menu';
const $2a6ddd68ec9f2eb5$var$filterProjects = (projects, value)=>projects.filter((project)=>(0, $lcCsd.default)(project.displayName, value));
const $2a6ddd68ec9f2eb5$var$projectsToItems = (projects)=>projects.map((project)=>({
            [$2a6ddd68ec9f2eb5$var$key]: 'project',
            value: project.id,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                size: "small",
                appearance: "square",
                src: project.avatar
            }),
            content: project.displayName
        })); // @ts-expect-error - TS7031 - Binding element 'context' implicitly has an 'any' type.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2a6ddd68ec9f2eb5$var$formatOptionLabel = (option, { context: context })=>{
    if (context === $2a6ddd68ec9f2eb5$var$MENU_CONTEXT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a6ddd68ec9f2eb5$var$OptionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        size: "small",
        appearance: option.type === 'project' ? 'square' : 'circle',
        src: option.avatar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a6ddd68ec9f2eb5$var$OptionLabel, null, option.label));
    return option.label;
};
// eslint-disable-next-line jira/react/no-class-components
class $2a6ddd68ec9f2eb5$var$LocationPicker extends (0, $5uXOq.Component) {
    getProjectsGroup() {
        const { projects: projects } = this.props;
        const { filterValue: filterValue } = this.state;
        const items = $2a6ddd68ec9f2eb5$var$projectsToItems($2a6ddd68ec9f2eb5$var$filterProjects(projects, filterValue));
        return {
            heading: this.props.intl.formatMessage(this.shouldLimitItems() ? (0, $jt9Qd.default).recentProjectsSelectGroup : (0, $jt9Qd.default).projectsSelectGroup),
            items: items.slice(0, this.shouldLimitItems() ? Math.min(this.props.recentProjectsLimit, $2a6ddd68ec9f2eb5$var$ITEM_LIMIT) : $2a6ddd68ec9f2eb5$var$ITEM_LIMIT)
        };
    }
    getUserGroup() {
        const { id: id, displayName: displayName, avatar: avatar } = this.props.user;
        return {
            heading: this.props.intl.formatMessage((0, $jt9Qd.default).userSelectGroup),
            items: [
                {
                    [$2a6ddd68ec9f2eb5$var$key]: 'user',
                    value: id,
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                        size: "small",
                        appearance: "circle",
                        src: avatar
                    }),
                    content: displayName
                }
            ]
        };
    }
    getProjectOptions() {
        const { projects: projects } = this.props;
        const { filterValue: filterValue } = this.state;
        const options = $2a6ddd68ec9f2eb5$var$filterProjects(projects, filterValue).map((project)=>({
                label: project.displayName,
                value: project.id,
                avatar: project.avatar,
                type: 'project'
            }));
        return {
            label: this.props.intl.formatMessage(this.shouldLimitItems() ? (0, $jt9Qd.default).recentProjectsSelectGroup : (0, $jt9Qd.default).projectsSelectGroup),
            options: options.slice(0, this.shouldLimitItems() ? Math.min(this.props.recentProjectsLimit, $2a6ddd68ec9f2eb5$var$ITEM_LIMIT) : $2a6ddd68ec9f2eb5$var$ITEM_LIMIT)
        };
    }
    getUserOptions() {
        const { id: id, displayName: displayName, avatar: avatar } = this.props.user;
        return {
            label: this.props.intl.formatMessage((0, $jt9Qd.default).userSelectGroup),
            options: [
                {
                    label: displayName,
                    value: id,
                    avatar: avatar,
                    type: 'user'
                }
            ]
        };
    }
    getOptions() {
        const { user: user } = this.props;
        return user && (0, $lcCsd.default)(user.displayName, this.state.filterValue) ? [
            this.getProjectOptions(),
            this.getUserOptions()
        ] : [
            this.getProjectOptions()
        ];
    }
    getItems() {
        const { user: user } = this.props;
        return user && (0, $lcCsd.default)(user.displayName, this.state.filterValue) ? [
            this.getProjectsGroup(),
            this.getUserGroup()
        ] : [
            this.getProjectsGroup()
        ];
    }
    shouldLimitItems() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(this.state.filterValue) && Boolean(this.props.recentProjectsLimit);
    }
    anyItemContentMatch(textToMatch) {
        return Boolean((0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(this.getItems(), 'items').find((item)=>item.content === textToMatch));
    }
    render() {
        const { isPending: isPending, label: label, placeholder: placeholder } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a6ddd68ec9f2eb5$var$FieldWidthControl, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "board-location-picker",
            label: label,
            isRequired: false,
            testId: "board-location-dialogs-common.apps.location-picker.location-picker.location-picker"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
                ...fieldProps,
                required: true,
                autoFocus: true,
                isDisabled: isPending,
                placeholder: placeholder,
                options: this.getOptions(),
                formatOptionLabel: $2a6ddd68ec9f2eb5$var$formatOptionLabel,
                onChange: this.onChange,
                onInputChange: this.handleOnFilterChange,
                menuPortalTarget: document.body,
                styles: {
                    menuPortal: (base)=>({
                            ...base,
                            zIndex: 9999
                        })
                }
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.HelperMessage), null, this.props.intl.formatMessage((0, $jt9Qd.default).userSelectHelperText)));
    }
    constructor(...args){
        super(...args), this.state = {
            selectedItem: {},
            filterValue: ''
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.onChange = (item)=>{
            this.setState({
                selectedItem: item
            });
            if (item.type === 'user') this.props.onUserSelected(this.props.user);
            else {
                const projectLocation = this.props.projects.find((project)=>project.id === item.value);
                if (projectLocation) this.props.onProjectSelected(projectLocation);
            }
        }, this.handleOnFilterChange = (value)=>{
            if (!value || value === '' || !this.anyItemContentMatch(value)) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(this.state.selectedItem)) {
                    this.props.onItemUnselected && this.props.onItemUnselected();
                    this.setState({
                        selectedItem: {}
                    });
                }
            }
            this.setState({
                filterValue: value
            });
        };
    }
}
var $2a6ddd68ec9f2eb5$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($2a6ddd68ec9f2eb5$var$LocationPicker);
const $2a6ddd68ec9f2eb5$var$OptionContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a6ddd68ec9f2eb5$var$OptionLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvu2gc _n3tdidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a6ddd68ec9f2eb5$var$FieldWidthControl = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_dw4e1ssb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lcCsd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdbe69dc2a26dc34$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $cdbe69dc2a26dc34$export$2e2bcd8739ae039 = (haystack, needle)=>{
    if (!needle) return true;
    if (!haystack) return false;
    const haystackLowerCase = haystack.toLocaleLowerCase();
    const needleLowerCase = needle.toLocaleLowerCase();
    return haystackLowerCase.includes(needleLowerCase);
};

});

parcelRegister("jt9Qd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c21f2b2dd0af1095$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c21f2b2dd0af1095$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectsSelectGroup: {
        "id": "board-location-dialogs.common.location-picker.projects-select-group",
        "defaultMessage": "Projects"
    },
    recentProjectsSelectGroup: {
        "id": "board-location-dialogs.common.location-picker.recent-projects-select-group",
        "defaultMessage": "Recent projects"
    },
    userSelectGroup: {
        "id": "board-location-dialogs.common.location-picker.user-select-group",
        "defaultMessage": "Your profile"
    },
    userSelectHelperText: {
        "id": "board-location-dialogs.common.location-picker.user-select-group-input-helper",
        "defaultMessage": "The board\u2019s URL will change to match this location."
    }
});

});




parcelRegister("1qOIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae632a48ecf15960$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ae632a48ecf15960$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    classicLocationlessActionPromptText: {
        "id": "board-location-dialogs.common.location-picker.update-url-info",
        "defaultMessage": " This update will redirect you to a new URL for this board. Update any existing bookmarks, resources, or references to make sure they reflect this change."
    }
});

});

parcelRegister("a1epm", function(module, exports) {

$parcel$export(module.exports, "getClassicLocationlessRedirectUrl", () => $4d7aaf3c02703d24$export$f6606f55b4e17f5e);
const $4d7aaf3c02703d24$export$f6606f55b4e17f5e = (classicLocationlessData)=>{
    const { classicLocationless: classicLocationless, selectedLocation: selectedLocation, boardId: boardId } = classicLocationlessData ?? {};
    if (classicLocationless && (selectedLocation?.location?.key || selectedLocation?.location?.name) && boardId) {
        const relUrl = selectedLocation.type === 'project' ? `/jira/software/c/projects/${selectedLocation.location.key}/boards/${boardId}` : `/jira/people/${selectedLocation.location.name}/boards/${boardId}`;
        return typeof window !== 'undefined' ? window.location.origin + relUrl : '';
    }
    return null;
};

});



parcelRegister("cO5M1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c419be12488f6e83$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6yUsV = parcelRequire("6yUsV");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");
const $c419be12488f6e83$var$i18n = (0, $7VHMR.defineMessages)({
    title: {
        "id": "locationless-dialog-v2.error-message-secondary-text",
        "defaultMessage": "Something went wrong setting the location"
    },
    message: {
        "id": "locationless-dialog-v2.error-message-text",
        "defaultMessage": "You can try again or get help "
    },
    here: {
        "id": "locationless-dialog-v2.error-message-here-link-text",
        "defaultMessage": "here"
    }
});
function $c419be12488f6e83$var$ErrorMessage() {
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6yUsV.default), {
        title: intl.formatMessage($c419be12488f6e83$var$i18n.title),
        appearance: "error"
    }, intl.formatMessage($c419be12488f6e83$var$i18n.message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: "https://support.atlassian.com/contact/",
        rel: "noopener noreferrer",
        target: "_blank"
    }, intl.formatMessage($c419be12488f6e83$var$i18n.here)), ".");
}
var $c419be12488f6e83$export$2e2bcd8739ae039 = $c419be12488f6e83$var$ErrorMessage;

});
parcelRegister("6yUsV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2c43b93305034f0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $ctg8C = parcelRequire("ctg8C");

var $c0aEF = parcelRequire("c0aEF");
var $dS3PR = parcelRequire("dS3PR");

var $60LNO = parcelRequire("60LNO");
const $e2c43b93305034f0$var$rootStyles = null;
const $e2c43b93305034f0$var$iconColor = {
    connectivity: "_x5v91r2e",
    confirmation: "_x5v91fgg",
    info: "_x5v913wx",
    warning: "_x5v9f6ss",
    error: "_x5v9k8x7"
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $e2c43b93305034f0$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', type: type = 'connectivity', appearance: appearance, children: children, testId: testId, iconLabel: iconLabel })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const toggleDialog = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    if (!appearance) appearance = type;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _p12f1osq _nt751r31 _49pcnqa1 _1hvwt94y _kvh018uv _38q98stv _1o0knqa1 _1yyu1kum",
            $e2c43b93305034f0$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ctg8C.default), {
        onClose: onCloseDialog,
        content: children,
        isOpen: isOpen,
        placement: placement,
        testId: testId && `${testId}--inline-dialog`
    }, /*#__PURE__*/ $5uXOq.createElement((0, $fVnbM.default), {
        "data-ds--inline-message--button": true,
        appearance: "subtle-link",
        onClick: toggleDialog,
        spacing: "none",
        testId: testId && `${testId}--button`,
        "aria-expanded": isOpen
    }, /*#__PURE__*/ $5uXOq.createElement((0, $c0aEF.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $60LNO.default), {
        isOpen: isOpen,
        appearance: appearance,
        label: iconLabel
    }), /*#__PURE__*/ $5uXOq.createElement((0, $c0aEF.default), {
        space: "space.100"
    }, title && /*#__PURE__*/ $5uXOq.createElement((0, $dS3PR.default), {
        weight: "medium",
        testId: testId && `${testId}--title`
    }, title), secondaryText && /*#__PURE__*/ $5uXOq.createElement((0, $dS3PR.default), {
        weight: "medium",
        color: "color.text.subtlest",
        maxLines: 1,
        testId: testId && `${testId}--text`
    }, secondaryText))))));
};
var $e2c43b93305034f0$export$2e2bcd8739ae039 = $e2c43b93305034f0$var$InlineMessage;

});
parcelRegister("60LNO", function(module, exports) {

$parcel$export(module.exports, "default", () => $474777c4d72d6c07$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jfSgx = parcelRequire("jfSgx");
const $474777c4d72d6c07$var$iconColor = {
    connectivity: "_1b3i1c86",
    confirmation: "_1b3icdx1",
    info: "_1b3ige5s",
    warning: "_1b3i1n6p",
    error: "_1b3i1378"
};
const $474777c4d72d6c07$var$iconWrapperStyles = null;
const $474777c4d72d6c07$var$iconColorStyles = null;
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $474777c4d72d6c07$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $jfSgx.typesMapping);
    return /*#__PURE__*/ $5uXOq.createElement("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _syazkr0v",
            isOpen && "_syaz1kum",
            $474777c4d72d6c07$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $5uXOq.createElement(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        color: "currentColor",
        LEGACY_size: "medium",
        spacing: "spacious"
    }));
};
var $474777c4d72d6c07$export$2e2bcd8739ae039 = $474777c4d72d6c07$var$SelectedIcon;

});
parcelRegister("jfSgx", function(module, exports) {

$parcel$export(module.exports, "typesMapping", () => $e3da74fa628ddd87$export$4d111645c0b39d5d);

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");
const $e3da74fa628ddd87$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jWct))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))),
        defaultLabel: 'error inline message'
    }
};

});
parcelRegister("1jWct", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e457cb24ac9ea7300ef511f2118ffa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f64b62884a9bedb$var$_react = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0f64b62884a9bedb$var$_information = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2Yv61")));

var $0f64b62884a9bedb$var$_info = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2hXfb")));
function $0f64b62884a9bedb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f64b62884a9bedb$var$InformationIcon = (props)=>/*#__PURE__*/ $0f64b62884a9bedb$var$_react.default.createElement($0f64b62884a9bedb$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $0f64b62884a9bedb$var$_info.default
    }, props));
$0f64b62884a9bedb$var$InformationIcon.Name = 'InformationIconMigration';
var $0f64b62884a9bedb$var$_default = module.exports.default = $0f64b62884a9bedb$var$InformationIcon;

});

parcelRegister("c2i4s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b4b1d8f8ae82590ab9e3b231233297b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c33b074f80a91d5$var$_react = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8c33b074f80a91d5$var$_success = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("b0JGA")));

var $8c33b074f80a91d5$var$_checkCircle = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("btivG")));
function $8c33b074f80a91d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c33b074f80a91d5$var$SuccessIcon = (props)=>/*#__PURE__*/ $8c33b074f80a91d5$var$_react.default.createElement($8c33b074f80a91d5$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $8c33b074f80a91d5$var$_checkCircle.default
    }, props));
$8c33b074f80a91d5$var$SuccessIcon.Name = 'SuccessIconMigration';
var $8c33b074f80a91d5$var$_default = module.exports.default = $8c33b074f80a91d5$var$SuccessIcon;

});





parcelRegister("RYNEX", function(module, exports) {

$parcel$export(module.exports, "contextSelector", () => $06f600457b1f1b20$export$c420c9f40402ab6d);
$parcel$export(module.exports, "baseUrlSelector", () => $06f600457b1f1b20$export$1ca9a92a5f28e233);
$parcel$export(module.exports, "rapidViewIdSelector", () => $06f600457b1f1b20$export$718e830000b27a0e);
$parcel$export(module.exports, "currentLocationDisplayNameSelector", () => $06f600457b1f1b20$export$90e89131c1f4a0b5);
$parcel$export(module.exports, "currentLocationAvatarSelector", () => $06f600457b1f1b20$export$c10e6fd65df617c0);

var $dGvGJ = parcelRequire("dGvGJ");
const $06f600457b1f1b20$export$c420c9f40402ab6d = (state)=>state.context;
const $06f600457b1f1b20$export$1ca9a92a5f28e233 = (_)=>'';
const $06f600457b1f1b20$export$718e830000b27a0e = (0, $dGvGJ.createSelector)($06f600457b1f1b20$export$c420c9f40402ab6d, (context)=>context.rapidViewId);
const $06f600457b1f1b20$export$996988dd55f5a8cd = (0, $dGvGJ.createSelector)($06f600457b1f1b20$export$c420c9f40402ab6d, (context)=>context.currentLocation);
const $06f600457b1f1b20$export$90e89131c1f4a0b5 = (0, $dGvGJ.createSelector)($06f600457b1f1b20$export$996988dd55f5a8cd, (location)=>location.displayName);
const $06f600457b1f1b20$export$c10e6fd65df617c0 = (0, $dGvGJ.createSelector)($06f600457b1f1b20$export$996988dd55f5a8cd, (location)=>location.avatar);

});

parcelRegister("lVn0F", function(module, exports) {

$parcel$export(module.exports, "setLocationSuccess", () => $837d59a5e453f5b5$export$5daab09d8e3809e0);

const $837d59a5e453f5b5$export$e97c62ad868ad2c3 = (payload)=>({
        type: (0, $bc190414c824030d$export$e2872d87ddcb5b4a),
        payload: payload
    });
const $837d59a5e453f5b5$export$5daab09d8e3809e0 = (payload, analyticsEvent)=>({
        type: (0, $bc190414c824030d$export$9d8d4e6ce2e6a21),
        payload: payload,
        meta: {
            analytics: analyticsEvent
        }
    });

});
const $bc190414c824030d$export$9d8d4e6ce2e6a21 = 'move-single-board-dialog/SET_LOCATION_SUCCESS';
const $bc190414c824030d$export$e2872d87ddcb5b4a = 'move-single-board-dialog/SET_LOCATION_FAILURE';


parcelRegister("kXILf", function(module, exports) {

$parcel$export(module.exports, "default", () => $cba0825e40ef60bf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $7O4UO = parcelRequire("7O4UO");

var $az4zD = parcelRequire("az4zD");

var $izBWK = parcelRequire("izBWK");

var $4SIgN = parcelRequire("4SIgN");
function $cba0825e40ef60bf$var$CurrentLocation(props) {
    const { avatarUrl: avatarUrl, locationName: locationName, intl: { formatMessage: formatMessage } } = props;
    const label = formatMessage((0, $izBWK.default).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4SIgN.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: label,
        label: label,
        isRequired: false
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4SIgN.AvatarItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            size: "small",
            appearance: "square",
            src: avatarUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4SIgN.LocationName), null, locationName))));
}
var $cba0825e40ef60bf$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($cba0825e40ef60bf$var$CurrentLocation);

});
parcelRegister("izBWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $02ee9fef8ef97ee2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $02ee9fef8ef97ee2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "move-single-board.current-location.label",
        "defaultMessage": "Current location"
    }
});

});

parcelRegister("4SIgN", function(module, exports) {

$parcel$export(module.exports, "AvatarItem", () => $dfb6b938aab3838d$export$15f08c141eda7939);
$parcel$export(module.exports, "LocationName", () => $dfb6b938aab3838d$export$3f15bfb412e8d6df);
$parcel$export(module.exports, "FieldWrapper", () => $dfb6b938aab3838d$export$6a00f65eec6002a6);
/* styled.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $dfb6b938aab3838d$export$15f08c141eda7939 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dfb6b938aab3838d$var$AvatarItemComponent, props);
const $dfb6b938aab3838d$export$3f15bfb412e8d6df = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dfb6b938aab3838d$var$LocationNameComponent, props);
const $dfb6b938aab3838d$export$6a00f65eec6002a6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dfb6b938aab3838d$var$FieldWrapperComponent, props);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dfb6b938aab3838d$var$LocationNameComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $dfb6b938aab3838d$var$AvatarItemComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $dfb6b938aab3838d$var$FieldWrapperComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bchv47k",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1KRvE", function(module, exports) {

$parcel$export(module.exports, "cancelDialog", () => $6500ff382bf3be47$export$d8e990c7994e01bd);
$parcel$export(module.exports, "initDialog", () => $6500ff382bf3be47$export$10e19ed2936eea31);

const $6500ff382bf3be47$export$d8e990c7994e01bd = ()=>({
        type: (0, $0f089ec82ddcf4fe$export$b58c79b7f2d0f102)
    });
const $6500ff382bf3be47$export$10e19ed2936eea31 = ()=>({
        type: (0, $0f089ec82ddcf4fe$export$10b25390e6826dd4)
    });

});
const $0f089ec82ddcf4fe$export$b58c79b7f2d0f102 = 'move-single-board-dialog/CANCEL_DIALOG';
const $0f089ec82ddcf4fe$export$10b25390e6826dd4 = 'move-single-board-dialog/INIT_DIALOG';


parcelRegister("89S6R", function(module, exports) {

$parcel$export(module.exports, "isOpenSelector", () => $b5d03190c5523660$export$eacfcc6aba3b8af4);

var $dGvGJ = parcelRequire("dGvGJ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b5d03190c5523660$var$dialogSelector = (state)=>state.dialog;
const $b5d03190c5523660$export$eacfcc6aba3b8af4 = (0, $dGvGJ.createSelector)($b5d03190c5523660$var$dialogSelector, (dialog)=>dialog.isOpen);

});


parcelRegister("lc3ff", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae55bc1f2419b8ce$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $e1AU2 = parcelRequire("e1AU2");

var $hkadP = parcelRequire("hkadP");

var $c2YD6 = parcelRequire("c2YD6");

var $fm14N = parcelRequire("fm14N");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$ae55bc1f2419b8ce$export$2e2bcd8739ae039 = (initialState)=>(0, $3f2cs.createStore)(// @ts-expect-error - TS2345 - Argument of type '(state: { context: undefined; dialog: undefined; newLocation: undefined; } | undefined, action: any) => unknown' is not assignable to parameter of type 'Reducer<{ context: undefined; dialog: undefined; newLocation: undefined; } | undefined>'.
    (0, $fm14N.default), initialState, (0, $hkadP.default)({
        name: 'Move Single Board'
    })((0, $3f2cs.applyMiddleware)((0, $e1AU2.createEpicMiddleware)((0, $c2YD6.default)))));

});
parcelRegister("c2YD6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b92d3ba1d13820d8$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $9komc = parcelRequire("9komc");
var $b92d3ba1d13820d8$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $9komc.default));

});
parcelRegister("9komc", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbf527db5bb7d2b7$export$2e2bcd8739ae039);
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("64ZAE");
parcelRequire("hZWgu");

var $7skN1 = parcelRequire("7skN1");

var $6mdkU = parcelRequire("6mdkU");
// @ts-expect-error - TS7031 - Binding element 'type' implicitly has an 'any' type. | TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ "move-single-board-dialog/SET_LOCATION_SUCCESS": (state: any) => { eventNameSuffix: string; eventData: { selectedId: any; selectedType: any; rapidViewId: any; }; }; "move-single-board-dialog/SET_LOCATION_FAILURE": (state: any) => { ...; }; "move-single-board-dialog/INIT_DIALOG": (state: any) => { ...; }; "move-sin...'.
const $cbf527db5bb7d2b7$var$shouldActionTriggerAnalytics = ({ type: type })=>(0, $7skN1.default)[type] !== undefined;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cbf527db5bb7d2b7$var$getAnalyticsForAction = (state, action)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ "move-single-board-dialog/SET_LOCATION_SUCCESS": (state: any) => { eventNameSuffix: string; eventData: { selectedId: any; selectedType: any; rapidViewId: any; }; }; "move-single-board-dialog/SET_LOCATION_FAILURE": (state: any) => { ...; }; "move-single-board-dialog/INIT_DIALOG": (state: any) => { ...; }; "move-sin...'.
    (0, $7skN1.default)[action.type](state, action);
// @ts-expect-error - TS7031 - Binding element 'eventNameSuffix' implicitly has an 'any' type. | TS7031 - Binding element 'eventData' implicitly has an 'any' type.
const $cbf527db5bb7d2b7$var$triggerAnalyticsForAction = ({ eventNameSuffix: eventNameSuffix, eventData: eventData })=>(0, $6mdkU.default)(eventNameSuffix, eventData);
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$cbf527db5bb7d2b7$export$2e2bcd8739ae039 = (action$, store)=>action$.filter($cbf527db5bb7d2b7$var$shouldActionTriggerAnalytics)// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
    .map((action)=>$cbf527db5bb7d2b7$var$getAnalyticsForAction(store.getState(), action)).do($cbf527db5bb7d2b7$var$triggerAnalyticsForAction).ignoreElements();

});
parcelRegister("7skN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $68b45d5810353985$export$2e2bcd8739ae039);

var $RYNEX = parcelRequire("RYNEX");



var $jc2It = parcelRequire("jc2It");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$68b45d5810353985$export$2e2bcd8739ae039 = {
    // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
    [(0, $bc190414c824030d$export$9d8d4e6ce2e6a21)]: (state)=>({
            eventNameSuffix: 'move.single.dialog.location.success',
            eventData: {
                selectedId: (0, $jc2It.newLocationIdSelector)(state),
                selectedType: (0, $jc2It.newLocationTypeSelector)(state),
                rapidViewId: (0, $RYNEX.rapidViewIdSelector)(state)
            }
        }),
    // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
    [(0, $bc190414c824030d$export$e2872d87ddcb5b4a)]: (state)=>({
            eventNameSuffix: 'move.single.dialog.location.failure',
            eventData: {
                selectedId: (0, $jc2It.newLocationIdSelector)(state),
                selectedType: (0, $jc2It.newLocationTypeSelector)(state),
                rapidViewId: (0, $RYNEX.rapidViewIdSelector)(state)
            }
        }),
    // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
    [(0, $0f089ec82ddcf4fe$export$10b25390e6826dd4)]: (state)=>({
            eventNameSuffix: 'move.single.dialog.init',
            eventData: {
                rapidViewId: (0, $RYNEX.rapidViewIdSelector)(state)
            }
        }),
    // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
    [(0, $0f089ec82ddcf4fe$export$b58c79b7f2d0f102)]: (state)=>({
            eventNameSuffix: 'move.single.dialog.cancel',
            eventData: {
                rapidViewId: (0, $RYNEX.rapidViewIdSelector)(state)
            }
        })
};

});
parcelRegister("jc2It", function(module, exports) {

$parcel$export(module.exports, "newLocationIdSelector", () => $d7761097833e4199$export$3af701c7c04e58e8);
$parcel$export(module.exports, "newLocationTypeSelector", () => $d7761097833e4199$export$6401b954c59e37f8);

var $dGvGJ = parcelRequire("dGvGJ");
const $d7761097833e4199$export$763518cb81f5c458 = (state)=>state.newLocation;
const $d7761097833e4199$export$3af701c7c04e58e8 = (0, $dGvGJ.createSelector)($d7761097833e4199$export$763518cb81f5c458, (newLocation)=>newLocation.location.id);
const $d7761097833e4199$export$6401b954c59e37f8 = (0, $dGvGJ.createSelector)($d7761097833e4199$export$763518cb81f5c458, (newLocation)=>newLocation.type);

});


parcelRegister("6mdkU", function(module, exports) {

$parcel$export(module.exports, "default", () => $42baab165ff56395$export$2e2bcd8739ae039);
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $42baab165ff56395$var$triggerAnalyticsForApp = (_eventNameSuffix, _eventData)=>{}; // 'MoveSingleBoardDialog' was the app name
var /**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ $42baab165ff56395$export$2e2bcd8739ae039 = $42baab165ff56395$var$triggerAnalyticsForApp;

});



parcelRegister("fm14N", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d170c15ebe56c30$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $7uUwQ = parcelRequire("7uUwQ");

var $3Hg81 = parcelRequire("3Hg81");

var $fl1xw = parcelRequire("fl1xw");

var $5bhQS = parcelRequire("5bhQS");
const $1d170c15ebe56c30$var$initialState = (0, $7uUwQ.freeze)({
    context: undefined,
    dialog: undefined,
    newLocation: undefined
});
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$1d170c15ebe56c30$export$2e2bcd8739ae039 = (state = $1d170c15ebe56c30$var$initialState, action)=>(0, $7uUwQ.freeze)((0, $3f2cs.combineReducers)({
        context: (0, $3Hg81.default),
        newLocation: (0, $5bhQS.default),
        dialog: (0, $fl1xw.default)
    })(// @ts-expect-error - Argument of type '{ context: undefined; dialog: undefined; newLocation: undefined; }' is not assignable to parameter of type 'CombinedState<{ context: any; newLocation: any; dialog: { isOpen: boolean; }; }>'.
    state, action));

});
parcelRegister("3Hg81", function(module, exports) {

$parcel$export(module.exports, "default", () => $10b1f6337caf3251$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

const $10b1f6337caf3251$var$initialState = (0, $7uUwQ.freeze)({
    baseUrl: undefined,
    rapidViewId: undefined,
    currentLocation: undefined
});
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$10b1f6337caf3251$export$2e2bcd8739ae039 = (state = $10b1f6337caf3251$var$initialState, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $e843d49b436e09f8$export$4bc4e62e7d72b94b:
            return (0, $7uUwQ.freeze)(payload);
        default:
            return state;
    }
};

});

parcelRegister("fl1xw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f1c3913107ac0cc$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");


const $5f1c3913107ac0cc$var$initialState = (0, $7uUwQ.freeze)({
    isOpen: true
});
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$5f1c3913107ac0cc$export$2e2bcd8739ae039 = (state = $5f1c3913107ac0cc$var$initialState, action)=>{
    const { type: type } = action;
    switch(type){
        case 0, $0f089ec82ddcf4fe$export$10b25390e6826dd4:
            return (0, $7uUwQ.assocIn)(state, [
                'isOpen'
            ], true);
        case 0, $0f089ec82ddcf4fe$export$b58c79b7f2d0f102:
        case 0, $bc190414c824030d$export$9d8d4e6ce2e6a21:
            return (0, $7uUwQ.assocIn)(state, [
                'isOpen'
            ], false);
        default:
            return state;
    }
};

});

parcelRegister("5bhQS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b17460b6a143ab5$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

const $6b17460b6a143ab5$var$initialState = (0, $7uUwQ.freeze)({});
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$6b17460b6a143ab5$export$2e2bcd8739ae039 = (state = $6b17460b6a143ab5$var$initialState, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $bc190414c824030d$export$9d8d4e6ce2e6a21:
        case 0, $bc190414c824030d$export$e2872d87ddcb5b4a:
            return (0, $7uUwQ.merge)(state, payload);
        default:
            return state;
    }
};

});




parcelRegister("biuDJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b7e31c5f83b42e$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $c7b7e31c5f83b42e$var$styles = {
    show: "_1e0c1kw7",
    hide: "_1e0cglyw"
};
class $c7b7e31c5f83b42e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { MoveSingleBoardDialog: MoveSingleBoardDialog, baseUrl: baseUrl, board: board, onCancel: onCancel } = this.props;
        const { showDialog: showDialog } = this.state;
        const rapidViewId = parseInt(board.id, 10);
        const currentLocation = board.location ? {
            avatar: board.location.avatarURI,
            displayName: board.location.displayName
        } : {};
        // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'. | TS2339 - Property 'name' does not exist on type 'Board'.
        const boardName = board.isPrivate ? undefined : board.name;
        const dialog = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MoveSingleBoardDialog, {
            baseUrl: baseUrl,
            rapidViewId: rapidViewId,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            currentLocation: currentLocation,
            onLocationSet: this.onLocationSet,
            onCancel: onCancel,
            onSetLocationError: this.onSetLocationError,
            onFetchDataError: this.onFetchDataError,
            onFetchDataSuccess: this.onFetchDataSuccess,
            showErrorMessage: false,
            boardName: boardName
        });
        if (showDialog) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                $c7b7e31c5f83b42e$var$styles.show
            ])
        }, dialog);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                $c7b7e31c5f83b42e$var$styles.hide
            ])
        }, dialog);
    }
    constructor(...args){
        super(...args), this.state = {
            showDialog: false
        }, this.onLocationSet = ()=>{
            this.props.onBoardMoved(this.props.board);
        }, this.onSetLocationError = ()=>{
            this.props.onBoardMoveFailed(this.props.board);
        }, this.onFetchDataError = ()=>{
            this.props.onInitialDataFetchFailed(this.props.board);
        }, this.onFetchDataSuccess = ()=>{
            this.setState({
                showDialog: true
            });
            this.props.onInitialDataFetched();
        };
    }
}

});





parcelRegister("i0p32", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb878c0831034ae1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $cheKj = parcelRequire("cheKj");
const $eb878c0831034ae1$var$CreateButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        id: "directories.boards-v2.create-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cheKj.default), null)));
var $eb878c0831034ae1$export$2e2bcd8739ae039 = $eb878c0831034ae1$var$CreateButton;

});
parcelRegister("cheKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c36283c6ab9dfb6$export$2e2bcd8739ae039);

var $7CwOv = parcelRequire("7CwOv");

var $bv1G0 = parcelRequire("bv1G0");

var $8BZxM = parcelRequire("8BZxM");

var $hmgkA = parcelRequire("hmgkA");
var $6c36283c6ab9dfb6$export$2e2bcd8739ae039 = (0, $7CwOv.default)({
    CreateDialogLoader: $bv1G0.default,
    StatelessButton: $8BZxM.default
})((0, $hmgkA.default));

});
parcelRegister("hmgkA", function(module, exports) {

$parcel$export(module.exports, "default", () => $89ee0f8fcb569b8a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $89ee0f8fcb569b8a$var$CreateBoardsButton = ({ CreateDialogLoader: CreateDialogLoader, StatelessButton: StatelessButton })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CreateDialogLoader, null, (load, isLoading)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StatelessButton, {
            onClick: load,
            isDisabled: isLoading
        }));
var $89ee0f8fcb569b8a$export$2e2bcd8739ae039 = $89ee0f8fcb569b8a$var$CreateBoardsButton;

});



parcelRegister("aJD80", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f8f0e238b4553a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $cS37j = parcelRequire("cS37j");

var $4R6GH = parcelRequire("4R6GH");

var $id7K0 = parcelRequire("id7K0");

var $dCm1o = parcelRequire("dCm1o");

var $8wA7J = parcelRequire("8wA7J");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1f8f0e238b4553a9$export$2e2bcd8739ae039 = (props)=>{
    const { CreateButton: CreateButton, BoardsDirectory: BoardsDirectory, intl: { formatMessage: formatMessage }, ...boardsDirectoryProps } = props;
    const actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CreateButton, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $8wA7J.default).pageTitle)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_2') ? $1f8f0e238b4553a9$var$pageHeaderStyles : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        truncateTitle: true,
        actions: actions
    }, formatMessage((0, $8wA7J.default).pageTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BoardsDirectory, boardsDirectoryProps));
};
const $1f8f0e238b4553a9$var$pageHeaderStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.negative.050'
});

});
parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("8wA7J", function(module, exports) {

$parcel$export(module.exports, "default", () => $f462f0568a090709$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f462f0568a090709$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageTitle: {
        "id": "directories.boards-v2.page.page-title",
        "defaultMessage": "Boards"
    }
});

});



parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("fhVq7", function(module, exports) {

$parcel$export(module.exports, "ScrollablePage", () => $501f0ba909d41168$export$8d7a30196b47fe34);
$parcel$export(module.exports, "PageLayout", () => $501f0ba909d41168$export$6d1402fb58384e4f);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");
const $501f0ba909d41168$export$8d7a30196b47fe34 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page',
        xcss: $501f0ba909d41168$var$scrollablePageStyles,
        paddingBlock: "space.0",
        paddingInline: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_1') ? 'space.300' : 'space.500'
    }, children);
const $501f0ba909d41168$export$6d1402fb58384e4f = ({ children: children, hideMargin: hideMargin, ...rest })=>{
    const isVisualRefresh = (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_1');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.page-layout',
        xcss: // eslint-disable-next-line no-nested-ternary
        hideMargin ? $501f0ba909d41168$var$pageLayoutWithoutMarginStyles : isVisualRefresh ? $501f0ba909d41168$var$pageLayoutWithMarginStyles : $501f0ba909d41168$var$pageLayoutWithMarginStylesOld
    }, children);
};
const $501f0ba909d41168$var$scrollablePageStyles = (0, $8CUq3.xcss)({
    minWidth: '800px',
    margin: 'space.0'
});
const $501f0ba909d41168$var$pageLayoutWithoutMarginStyles = (0, $8CUq3.xcss)({
    margin: 'space.0'
});
const $501f0ba909d41168$var$pageLayoutWithMarginStylesOld = (0, $8CUq3.xcss)({
    marginBlock: '0',
    marginInline: 'space.500'
});
const $501f0ba909d41168$var$pageLayoutWithMarginStyles = (0, $8CUq3.xcss)({
    marginBlock: '0',
    marginInline: 'space.300'
});

});

parcelRegister("gcCnU", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryPageLoad", () => $17e4ba2aae6f730c$export$e959f3b40b7337e1);

var $dGrdR = parcelRequire("dGrdR");
const $17e4ba2aae6f730c$export$e959f3b40b7337e1 = (0, $dGrdR.metrics).pageLoad({
    key: 'boards-directory',
    ssr: {
        doneAsFmp: true
    },
    featureFlags: [
        'opsgenie-consolidation-transitioning-state_d7vm9'
    ]
});

});




const $e6a2e0952e4731b8$export$81319ffa9c0d18d7 = 'profileCardNext';
const $e6a2e0952e4731b8$export$3145fc6c544ad7bf = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$50632e21ea714398 = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $e6a2e0952e4731b8$export$2549357601611c61 = 'loadError';
const $e6a2e0952e4731b8$export$23cedd3261bd8015 = 'viewProfile';
const $e6a2e0952e4731b8$export$6bef782d14a92db8 = 'assignedIssues';
const $e6a2e0952e4731b8$export$6b36f20db7a18a86 = 'reportedIssues';
const $e6a2e0952e4731b8$export$56da0dd0b0aa67b9 = 'viewFilters';


//# sourceMappingURL=async-boards-directory.5c31ae53.js.map
